import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { formatInTimeZone } from 'date-fns-tz';
import { uniq } from 'lodash';
import Alert from 'react-bootstrap/Alert';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import createTrend from 'trendline';
import moment from 'moment-timezone';
import { Tab, Tabs } from 'react-bootstrap';
import { getFunctions, httpsCallable } from 'firebase/functions';
import * as Sentry from '@sentry/react';
import Tooltip from '@mui/material/Tooltip';
import { getActiveItems, getConfiguration } from '../util/config';
import {
  getLaboratoryOnly,
  formatLocationOptionLabel,
  compareLocationOptions
} from '../util/locationLabel';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  defaultColumns,
  defaultColumnsExtend,
  defaultColumnsUsExtend,
  defaultColumnsEdit,
  defaultColumnsReport,
  oocFlagColumns,
  summaryStatisticsColumnsPeriodic,
  wFlagColumns,
  yesNoOptions,
  defaultExportDataToCSVColumns
} from '../components/Columns';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import './chart.scss';
import firebaseApp, { currentLogo, getCurrentFeatureFlags } from '../util/firebase';
import { requireAuth, useAuth } from '../util/auth';
import {
  isAdmin,
  arrayAverage,
  calculateHistogram,
  randomDarkColor,
  textSort,
  isContributor,
  checkCreate,
  setDefaultControlStrategies,
  generateControlStrategyData,
  renderLoadingButton,
  firebaseClean,
  checkHasPermission,
  getSigDigitsUtil,
  formatRowSigDigits,
  getTimeZone,
  sanitizePropertyData,
  handleDateTimeColumns,
  renderButtonWithPermissions,
  randomId,
  artecoCustomParameterSort,
  isNumericPlaceholder,
  isMalformedNumericResult,
  filterChartLinesByStrategy,
  isIncludedInSqcChartSeries,
  getEverFlagsDisplayGroups,
  liveEverFlagsConfig
} from '../util/util';
import { preInitialAssessmentStage } from '../util/initialAssessmentStage';
import {
  AD_MR_LABEL,
  buildStatisticsDataset,
  formatAdPair,
  mergeSummaryStatistics,
  relabelLegacyStatistics
} from '../util/summaryStatistics';
import {
  getTenNinetyParameterOptions,
  normalizeTenNinetyParameter,
  resolveTenNinetyParameterForMaterial
} from '../util/tenNinety';
import {
  createAssessment,
  createConfiguration,
  createSampleSchedule,
  createRegularSampleEntry,
  updateConfiguration,
  updateData,
  batchUpdateData,
  updateSummary,
  updateSampleSchedule,
  deleteSampleSchedule,
  updateRegularSampleEntry,
  deleteRegularSampleEntry,
  useEntitiesByFullKey,
  useEntitiesByShortKey,
  useFindAssessmentsByShortKey,
  useFindChartGroupConfigurationByShortKey,
  useFindControlStrategyConfigurationByFullKey,
  useFindDataByMultipleParameters,
  getIndexValues,
  useGetMethods,
  useGetPersonnel,
  useGetResults,
  useGetSampleSchedules,
  useGetRegularSampleEntries,
  useGetSamples,
  useGetSetupGroups,
  useGetSummaries,
  readCombineZScoreParameter,
  createCombineZScoreParameter,
  updateCombineZScoreParameter,
  useGetOrderOfParameters,
  useGetCompanyType,
  resetEverFlags,
  createAssessmentByFullKey,
  getInitAssessmentByShortKey,
  handleSyncAssessments,
  getDefaultControlStrategyConfiguration,
  getDataByFullKey,
  doesDataExistForFullKey,
  getControlStrategyConfigurationByFullKey,
  fetchMultipleControlStrategies,
  fetchOversizedAssessmentData
} from '../util/db';
import InstrumentLimits from '../components/InstrumentLimits';
import OverviewSection from '../components/ChartSections/OverviewSection';
import PrintOverviewSection from '../components/ChartSections/PrintOverviewSection';
import ComparisonSection from '../components/ChartSections/ComparisonSection';
import ConfigurationSection from '../components/ChartSections/ConfigurationSection';
import DataEntrySection from '../components/DataEntrySection/DataEntrySection';
import AssessmentsSection from '../components/AssessmentsSection/AssessmentsSection';
import ReportsSection from '../components/ReportsSection/ReportsSection';
import ReportIssueSection from '../components/ReportIssueSection/ReportIssue';
import ArchiveRestartModal from '../components/Modal/ArchiveRestartModal';
import { pickLatestControlStrategyConfig } from '../util/configSelection';
import { createDefaultControlStrategyConfigEnsurer } from '../util/ensureDefaultControlStrategyConfig';
import Section from '../components/Section';
import SQCLineChart from '../components/SQCLineChart';
import SQCMovingRangeChart from '../components/SQCMovingRangeChart';
import SQCScatterPlot from '../components/SQCScatterPlot';
import SQCHistogram from '../components/SQCHistogram';
import SQCAnalystChart from '../components/SQCAnalystChart';
import SQCInstrumentsChart from '../components/SQCInstrumentsChart';
import { useHistory, useRouter, useLocation } from '../util/router';
import { siblingParametersToRerun, runSequentially } from '../util/initialAssessmentRerun';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import ChartContext from '../components/DataEntrySection/DataEntryProvider';

import 'react-datepicker/dist/react-datepicker.css';
import CustomTable from '../components/Table/CustomTable';
import PrintOverviewDataTable from '../components/Table/PrintOverviewDataTable';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import AppContext from '../components/AppContext';
import { Button as MuiButton, ButtonGroup, Checkbox, TextField, IconButton } from '@mui/material';
import {
  SCREEN,
  RULES,
  UPDATE_TYPE,
  archiveRegex,
  FORMAT_KEY_TIME,
  FORMAT_DATE_YYYYMMDD,
  SUMMARY_STATISTICS_CONFIG
} from '../util/Constant';
import ModalConfirm from '../components/Common/modal/ModalConfirm';
import ModalError from '../components/Common/modal/ModalError';
import ChartAssessment from '../components/Modal/ChartAssessment';
import Loading from '../components/Common/Loading';
import ReportIssue from '../components/ReportIssueSection/ReportIssue';
import UpdateChartSigDigitsModal from '../components/Modal/UpdateChartSigDigitsModal';
import qs from 'qs';
import { useQuery, useQueryClient } from 'react-query';
import Meta from '../components/Meta';

const functions = getFunctions(firebaseApp);
const addDataFunction = httpsCallable(functions, 'addData');
const deleteAllDataFunction = httpsCallable(functions, 'deleteAllData');
const runReBuildIndexFunctions = httpsCallable(functions, 'reBuildIndex');
const runDataFunction = httpsCallable(functions, 'runData');
const editDataFunction = httpsCallable(functions, 'editData');
const archiveDataFunction = httpsCallable(functions, 'archiveData');
const periodicAssessmentArchiveDataFunction = httpsCallable(
  functions,
  'periodicAssessmentArchiveData'
);
const runArchiveDataFunction = httpsCallable(functions, 'runArchiveData');
const updateTenNinetyDatesFunction = httpsCallable(functions, 'updateTenNinetyDates');
const runCombineZScore = httpsCallable(functions, 'combineZScore');
const runUnArchiveFunctions = httpsCallable(functions, 'unArchiveFunctions');
const activeItems = getActiveItems(window.location.hostname, window.location.href);
const runCalculationPipeline = httpsCallable(functions, 'runCalculationPipeline');

const pageSizeDefault = 10;

const radioDataType = {
  ACTIVE: 'Active',
  ARCHIVE: 'Archive'
};

const defaultChartGroupConfigurations = {
  assignedSamples: ['None', 'None', 'None'],
  autoCreateSampleRecheck: 'No',
  displayMethodVersion: 'No',
  fullKey: '',
  initialAssessment: '20',
  ongoingAssessment: '20',
  ongoingAssessmentDays: '0',
  sampleType: 'SQC',
  shortKey: '',
  type: 'Chart Group',
  ewmaLambda: '0.4',
  tAlpha: '0.05',
  fAlpha: '0.05',
  combinedInitialAssessment: 'Yes'
};

function ChartPage() {
  const auth = useAuth();
  const router = useRouter();
  const location = useLocation();
  const queryClient = useQueryClient();
  const config = getConfiguration(window.location.hostname);
  const [periodicPage, setPeriodicPage] = useState('1');
  const [currentShortKey, setCurrentShortKey] = useState(null);
  const { currentFullKey, setCurrentFullKey } = useContext(AppContext);
  const { data: items } = useEntitiesByFullKey(currentFullKey);
  const { data: shortKeyItems } = useEntitiesByShortKey(currentShortKey);
  let { data: assessments } = useFindAssessmentsByShortKey(currentShortKey);
  const [resultsDataTableData, setResultsDataTableData] = useState([]);
  const { data: summaries } = useGetSummaries();
  const { data: orderOfParameters } = useGetOrderOfParameters();
  const [currentResultsData, setCurrentResultsData] = useState([]);
  const [currentPersonnelNames, setCurrentPersonnelNames] = useState([]);
  const [currentPersonnelDots, setCurrentPersonnelDots] = useState([]);
  const [currentInstrumentNames, setCurrentInstrumentNames] = useState([]);
  const [currentInstrumentDots, setCurrentInstrumentDots] = useState([]);
  const [activeTab, setActiveTab] = useState('Overview');
  // "Show ARV" toggle on the Overview I-chart, lifted here so the Overview print
  // view renders the same choice.
  const [showArv, setShowArv] = useState(false);
  let { data: results } = useGetResults();
  const { data: personnel } = useGetPersonnel();
  const [dataEntrySectionData] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [allMethods] = useState([]);
  const [allSampleNames] = useState([]);
  const [allInstruments] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [currentSummaries, setCurrentSummaries] = useState([]);
  const [currentSummariesShortKey, setCurrentSummariesShortKey] = useState([]);
  const [currentSummary, setCurrentSummary] = useState(null);
  const [currentSetupDataOne, setCurrentSetupDataOne] = useState(0);
  const [currentSetupDataZero, setCurrentSetupDataZero] = useState(0);
  // All non-omitted points in the series (setupData 1, 0 or blank) — criterion 1
  // of the initial-assessment trigger (see util/initialAssessmentStage).
  const [currentIncludedPointCount, setCurrentIncludedPointCount] = useState(0);
  const [currentPersonnel, setCurrentPersonnel] = useState([]);
  const [permission, setPermission] = useState('');
  const [currentSetupGroups, setCurrentSetupGroups] = useState([]);
  const { data: setupGroups } = useGetSetupGroups();
  const [startDate] = useState(new Date());
  const [currentLocation, setCurrentLocation] = useState(null);
  const [currentLocations, setCurrentLocations] = useState([]);
  const [showPeriodicModal, setShowPeriodicModal] = useState(false);
  const [currentMethod, setCurrentMethod] = useState(null);
  const [currentMethods, setCurrentMethods] = useState([]);
  const [currentSampleNames, setCurrentSampleNames] = useState([]);
  const [currentInstruments, setCurrentInstruments] = useState([]);
  const [currentParametersDynamic, setCurrentParametersDynamic] = useState([]);
  const [currentIndexes, setCurrentIndexes] = useState([]);
  const [currentActiveIndexes, setCurrentActiveIndexes] = useState([]);
  const [currentArchiveIndexes, setCurrentArchiveIndexes] = useState([]);
  const [currentSampleName, setCurrentSampleName] = useState(null);
  const [currentInstrument, setCurrentInstrument] = useState(null);
  const [currentParameter, setCurrentParameter] = useState(null);
  const [instrumentBeforeSampleName, setInstrumentBeforeSampleName] = useState(false);
  const [currentParameterComparison, setCurrentParameterComparison] = useState(currentParameter);
  const [currentMethodComparison, setCurrentMethodComparison] = useState(currentMethod);
  const [currentSampleNameComparison, setCurrentSampleNameComparison] = useState(currentSampleName);
  // eslint-disable-next-line no-unused-vars
  const [chartHitCount, setChartHitCount] = useState(0);
  const [chartHits, setChartHits] = useState([]);
  const [chartData, setChartData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [instrumentChartData, setInstrumentChartData] = useState([]);
  const [chartScalars, setChartScalars] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showRegularEntryModal, setShowRegularEntryModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [currentParameters, setCurrentParameters] = useState([]);
  const [filteredChartHits, setFilteredChartHits] = useState(false);
  const [filteredShortKeyData, setFilteredShortKeyData] = useState([]);
  const [timezones] = useState(moment.tz.names());
  const [currentNValue, setCurrentNValue] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [chartAssessed, setChartAssessed] = useState(false);
  const [currentAssessments, setCurrentAssessments] = useState([]);
  const [chartStage, setChartStage] = useState('');
  const [chartButtonText, setChartButtonText] = useState('');
  const [modalAssessment, setModalAssessment] = useState({});
  const [modalMode, setModalMode] = useState('save'); // 'save' or 'view'
  const [rowsToUpdate, setRowsToUpdate] = useState([]);
  const [localSearchFinished, setLocalSearchFinished] = useState(false);
  const [chartDataComplete, setChartDataComplete] = useState(true);
  const { data: methods } = useGetMethods();
  const { data: instrumentComparisonData } = useFindDataByMultipleParameters(
    currentMethodComparison,
    currentSampleNameComparison,
    currentParameterComparison
  );
  // eslint-disable-next-line no-unused-vars
  const [currentMethodsDropdown, setCurrentMethodsDropdown] = useState([
    { value: '', label: 'Select method' }
  ]);
  // eslint-disable-next-line no-unused-vars
  const [methodsUpdated, setMethodsUpdated] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [currentParametersDropdown, setCurrentParametersDropdown] = useState([]);
  const [summaryStatisticsAssessmentData, setSummaryStatisticsAssessmentData] = useState([]);
  const [tenNinetyStartDate, setTenNinetyStartDate] = useState(
    currentSummary ? new Date(currentSummary.v_1090_dateMin) : ''
  );
  const [tenNinetyEndDate, setTenNinetyEndDate] = useState(
    currentSummary ? new Date(currentSummary.v_1090_dateMax) : ''
  );

  const [currentSamples, setCurrentSamples] = useState([{ value: 'None', label: 'None' }]);
  const { data: samples } = useGetSamples();
  const [indexes, setIndexes] = useState([]);
  const { data: chartGroupConfigurations } =
    useFindChartGroupConfigurationByShortKey(currentShortKey);
  const { data: controlStrategyConfigurations } =
    useFindControlStrategyConfigurationByFullKey(currentFullKey);
  const { data: sampleSchedules } = useGetSampleSchedules();
  const { data: regularSampleEntries } = useGetRegularSampleEntries();
  const { data: companyTypes } = useGetCompanyType();
  const [currentChartGroupConfigurations, setCurrentChartGroupConfigurations] = useState(
    defaultChartGroupConfigurations
  );
  // The chart group's PERSISTED initialAssessment. Edits mutate the config object
  // in place, so snapshot it whenever a fresh Firestore result arrives (a new
  // array) and compare on save to detect a changed n.
  const savedInitialAssessmentRef = useRef();
  useEffect(() => {
    const chartGroup = Array.isArray(chartGroupConfigurations)
      ? chartGroupConfigurations.find((c) => c.type === 'Chart Group')
      : undefined;
    savedInitialAssessmentRef.current = chartGroup ? chartGroup.initialAssessment : undefined;
  }, [chartGroupConfigurations]);
  const [currentPersonnelDropdown, setCurrentPersonnelDropdown] = useState([]);
  const [unit, setUnit] = useState('');
  const [permissionData, setPermissionData] = useState({});

  const [isSelectCombinedZScore, setIsSelectCombinedZScore] = useState(false);
  const [showCombinedZScoreModal, setShowCombinedZScoreModal] = useState(false);
  const [combinedZScoreData, setCombinedZScoreData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRunData, setLoadingRunData] = useState(false);
  const [loadingRunCalculationPipeline, setLoadingRunCalculationPipeline] = useState(false);
  const [loadingSaveData, setLoadingSaveData] = useState(false);
  const [loadingReIndexData, setLoadingReIndexData] = useState(false);
  const [configCombineZScore, setConfigCombineZScore] = useState(null);
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [chartLoading, setChartLoading] = useState(false);
  const history = useHistory();
  const [radioArchiveValue, setRadioArchiveValue] = useState('Active');
  const [archiveData, setArchiveData] = useState([]);
  const [controlStatusData, setControlStatusData] = useState([]);
  const defaultCombinedParameterName = 'Combined Z-score';
  const defaultControlStrategyConfigurations = getDefaultControlStrategyConfiguration();
  const [currentInstrumentComparisonData, setCurrentInstrumentComparisonData] = useState([]);
  const [defaultSampleId, setDefaultSampleId] = useState(' ');
  const [showUpdateChartSigDigitsModal, setShowUpdateChartSigDigitsModal] = useState(false);
  const [checkedCombinedInitialAssessment, setCheckedCombinedInitialAssessment] = useState(true);
  const [dataReady, setDataReady] = useState(false);
  const [showNotePopover, setShowNotePopover] = useState(false);
  const [popoverTarget, setPopoverTarget] = useState(null);
  const [noteRow, setNoteRow] = useState('');
  const noteRef = useRef();

  useEffect(() => {
    if (
      currentLocations.length > 0 &&
      currentMethods.length > 0 &&
      currentSampleNames.length > 0 &&
      currentInstruments.length > 0
    ) {
      setDataReady(true);
    }
  }, [currentLocations, currentMethods, currentSampleNames, currentInstruments, currentParameters]);

  const injectLimitsToData = (data = [], controlLimits = {}) => {
    const { upperToleranceLimit, lowerToleranceLimit, upperControlLimit, lowerControlLimit } =
      controlLimits;
    // Ensure data is an array before calling .map()
    if (!Array.isArray(data)) {
      return [];
    }
    return data.map((point) => ({
      ...point,
      userDefinedUTL: upperToleranceLimit,
      userDefinedLTL: lowerToleranceLimit,
      userDefinedUCL: upperControlLimit,
      userDefinedLCL: lowerControlLimit
    }));
  };

  const mapInstrumentDataToChart = (updatedInstrumentData) => {
    let instrumentNames = [];
    const instrumentData = [];
    // in data forEach loop
    updatedInstrumentData.forEach((data) => {
      instrumentNames.push(data.instrument);
      instrumentData.push(data);
    });
    instrumentNames = uniq(instrumentNames);
    const instrumentsDots = [];
    const updatedInstrumentNames = [];
    instrumentNames.forEach((name) => {
      const randomColor = randomDarkColor();
      const objectToAdd = {
        name,
        color: randomColor
      };
      instrumentsDots.push(objectToAdd);
      const objectToReturn = {
        name,
        checked: true,
        color: randomColor
      };
      updatedInstrumentNames.push(objectToReturn);
    });
    setCurrentInstrumentNames(updatedInstrumentNames);
    setCurrentInstrumentDots(instrumentsDots);
    setInstrumentChartData(instrumentData);
  };
  function safeDecodeURIComponent(value) {
    try {
      // Replace lone '%' signs with '%25' to avoid URI errors
      const sanitized = value.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');
      return decodeURIComponent(sanitized);
    } catch {
      return '';
    }
  }
  const allParams = currentParametersDynamic
    .filter((p) => p.name !== defaultCombinedParameterName)
    .map((p) => p.name);
  useEffect(() => {
    if (dataReady) {
      const qsObj = qs.parse(String(location?.search).replace(/\?/g, ''));
      const fromUrl = true;

      const decodedParameter = safeDecodeURIComponent(qsObj?.parameter || '');
      const decodedInstrument = safeDecodeURIComponent(qsObj?.instrument || '');
      const decodedSampleName = safeDecodeURIComponent(qsObj?.sampleName || '');
      const decodedMethod = safeDecodeURIComponent(qsObj?.method || '');
      const decodedLocation = safeDecodeURIComponent(qsObj?.location || '');

      // Validate and handle parameter
      if (
        currentParameters.length &&
        (!currentParameter || (currentParameter && currentParameter !== decodedParameter))
      ) {
        const isValidParameter = currentParameters.includes(decodedParameter);
        handleParameterChange(
          { target: { value: isValidParameter ? decodedParameter : '' } },
          fromUrl
        );

        if (decodedParameter === defaultCombinedParameterName) {
          setCurrentParameter(defaultCombinedParameterName);
          setIsSelectCombinedZScore(true);
        }
      }

      // Validate and handle instrument
      if (
        currentInstruments.length &&
        (!currentInstrument || (currentInstrument && currentInstrument !== decodedInstrument))
      ) {
        const isValidInstrument = currentInstruments.some(
          (instrument) => instrument.name === decodedInstrument
        );
        handleInstrumentChange(
          { target: { value: isValidInstrument ? decodedInstrument : '' } },
          fromUrl
        );
      }

      // Validate and handle sample name
      if (
        currentSampleNames.length &&
        (!currentSampleName || (currentSampleName && currentSampleName !== decodedSampleName))
      ) {
        const isValidSampleName = currentSampleNames.some(
          (sampleName) => sampleName.name === decodedSampleName
        );
        handleSampleNameChange(
          { target: { value: isValidSampleName ? decodedSampleName : '' } },
          fromUrl
        );
      }

      // Validate and handle method
      if (
        currentMethods.length &&
        (!currentMethod || (currentMethod && currentMethod !== decodedMethod))
      ) {
        const isValidMethod = currentMethods.some((method) => method.name === decodedMethod);
        handleMethodChange({ target: { value: isValidMethod ? decodedMethod : '' } }, fromUrl);
      }

      // Validate and handle location
      if (
        currentLocations.length &&
        (!currentLocation || (currentLocation && currentLocation !== decodedLocation))
      ) {
        const isValidLocation = currentLocations.some(
          (location) => location.name === decodedLocation
        );
        handleLocationChange(
          { target: { value: isValidLocation ? decodedLocation : '' } },
          fromUrl
        );
      }
    }
  }, [
    location?.search,
    dataReady,
    currentLocations,
    currentMethods,
    currentSampleNames,
    currentInstruments,
    currentParameters
  ]);

  useEffect(() => {
    if (!currentParameter) {
      setChartHits([]);
      setChartData([]);
      setLocalSearchFinished(false);
      setIsSelectCombinedZScore(false);
    }
  }, [currentParameter]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mode = params.get('mode') || 'active';
    setRadioArchiveValue(mode === 'archive' ? 'Archive' : 'Active');
    if (mode === 'archive') {
      setCurrentIndexes([...currentArchiveIndexes]);
    } else {
      setCurrentIndexes([...currentActiveIndexes]);
    }
  }, [location.search, currentArchiveIndexes, currentActiveIndexes]);

  useEffect(() => {
    if (Array.isArray(instrumentComparisonData) && instrumentComparisonData.length > 0) {
      const filteredInstrumentComparisonData = instrumentComparisonData.filter(
        isIncludedInSqcChartSeries
      );

      mapInstrumentDataToChart(filteredInstrumentComparisonData);

      const instrumentSortByDate = [...filteredInstrumentComparisonData].sort(function (A, B) {
        const d1 = new Date(A.dateTime).getTime();
        const d2 = new Date(B.dateTime).getTime();

        if (d1 < d2) {
          return -1;
        }

        if (d1 > d2) {
          return 1;
        }

        return 0;
      });

      setCurrentInstrumentComparisonData(instrumentSortByDate);
    } else {
      setCurrentInstrumentComparisonData([]);
    }
  }, [instrumentComparisonData]);
  const [currentControlStrategyConfigurations, setCurrentControlStrategyConfigurations] = useState(
    defaultControlStrategyConfigurations
  );
  const [featureFlags] = useState(getCurrentFeatureFlags);
  const [timeFormat, setTimeFormat] = useState('HH:mm');
  const [dateTimeFormat, setDateTimeFormat] = useState('MM/DD/YYYY HH:mm');
  const [tz] = useState(getTimeZone(featureFlags));

  const [archiveStatus, setArchiveStatus] = useState('');

  useEffect(() => {
    if (radioArchiveValue === 'Active' && activeTab && archiveStatus !== 'No') {
      setArchiveStatus('No');
    }
  }, [radioArchiveValue, activeTab]);

  const renderChartLabelValue = (dataSet, property) => {
    const propertyExists = dataSet.some((data) =>
      Object.prototype.hasOwnProperty.call(data, property)
    );
    let labelToReturn = ``;
    if (propertyExists) {
      const currentProperty = dataSet[dataSet.length - 1][property];
      if (typeof currentProperty === 'number') {
        labelToReturn = `${renderSigDigits(dataSet[dataSet.length - 1][property])}`;
      }
    }
    return labelToReturn;
  };

  const handleTenNinetyDateChange = (type, value) => {
    if (type === 'start') {
      setTenNinetyStartDate(value);
    } else {
      setTenNinetyEndDate(value);
    }
  };

  const defaultChartLines = [
    {
      yAxis: 'resultOmits',
      name: 'Data',
      color: '#32CD32',
      ewma: true,
      runRules: true,
      controlLimits: true,
      toleranceLimits: true
    },
    {
      yAxis: 'ewmaOmits',
      name: 'EWMA',
      color: '#B0E0E6',
      ewma: true,
      runRules: false,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'mean',
      name: 'Center Line',
      reference: chartData.length > 20,
      label: ``,
      color: '#FFBF00',
      ewma: true,
      runRules: true,
      controlLimits: true,
      toleranceLimits: true
    },
    {
      yAxis: 'sd15p',
      name: 'EWMA UCL',
      label: ``,
      color: '#9932CC',
      reference: true,
      ewma: true,
      runRules: false,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'sd15n',
      name: 'EWMA LCL',
      label: ``,
      color: '#9932CC',
      reference: true,
      ewma: true,
      runRules: false,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'sd3n',
      name: 'LCL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: true,
      runRules: true,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'sd3p',
      name: 'UCL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: true,
      runRules: true,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'userDefinedLTL',
      name: 'User Defined LTL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: false,
      toleranceLimits: true
    },
    {
      yAxis: 'userDefinedUTL',
      name: 'User Defined UTL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: false,
      toleranceLimits: true
    },
    {
      yAxis: 'userDefinedLCL',
      name: 'User Defined LCL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: true,
      toleranceLimits: false
    },
    {
      yAxis: 'userDefinedUCL',
      name: 'User Defined UCL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: true,
      toleranceLimits: false
    }
  ];

  const defaultChartLinesNonUs = [
    {
      yAxis: 'resultOmits',
      name: 'Data',
      color: '#32CD32',
      ewma: true,
      runRules: true,
      controlLimits: true,
      toleranceLimits: true
    },
    {
      yAxis: 'ewmaOmits',
      name: 'EWMA',
      color: '#B0E0E6',
      ewma: true,
      runRules: false,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'mean',
      name: 'Center Line',
      reference: chartData.length > 20,
      label: '',
      color: '#FFBF00',
      ewma: true,
      runRules: true,
      controlLimits: true,
      toleranceLimits: true
    },
    {
      yAxis: 'sd15p',
      name: 'EWMA UCL',
      label: '',
      color: '#9932CC',
      reference: true,
      ewma: true,
      runRules: true,
      controlLimits: true,
      toleranceLimits: true
    },
    {
      yAxis: 'sd15n',
      name: 'EWMA LCL',
      label: '',
      color: '#9932CC',
      reference: true,
      ewma: true,
      runRules: true,
      controlLimits: true,
      toleranceLimits: true
    },
    {
      yAxis: 'sd3n',
      name: 'LCL',
      label: '',
      color: 'red',
      reference: true,
      ewma: true,
      runRules: true,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'sd3p',
      name: 'UCL',
      label: '',
      color: 'red',
      reference: true,
      ewma: true,
      runRules: true,
      controlLimits: false,
      toleranceLimits: false
    },
    {
      yAxis: 'userDefinedLTL',
      name: 'User Defined LTL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: false,
      toleranceLimits: true
    },
    {
      yAxis: 'userDefinedUTL',
      name: 'User Defined UTL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: false,
      toleranceLimits: true
    },
    {
      yAxis: 'userDefinedLCL',
      name: 'User Defined LCL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: true,
      toleranceLimits: false
    },
    {
      yAxis: 'userDefinedUCL',
      name: 'User Defined UCL',
      label: ``,
      color: 'red',
      reference: true,
      ewma: false,
      runRules: false,
      controlLimits: true,
      toleranceLimits: false
    }
  ];
  const isNonUs = companyTypes && companyTypes[0] && companyTypes[0]['nonUs'];
  const isEverFlags = companyTypes && companyTypes[0] && companyTypes[0]['everFlags'];
  const isHideRegionArea = companyTypes && companyTypes[0] && companyTypes[0]['hideRegionArea'];
  const [chartLines, setChartLines] = useState(
    isNonUs ? defaultChartLinesNonUs : defaultChartLines
  );

  const renderSigDigits = (stringValue) => {
    return getSigDigitsUtil(stringValue, currentControlStrategyConfigurations.chartSigDigits);
  };

  const summaryStatisticsDataPeriodic = [
    {
      statistic: 'Sample Size (n)',
      setupData: currentSetupDataOne,
      recentData: currentSetupDataZero,
      pooledData: currentSetupDataOne + currentSetupDataZero,
      evaluation: ''
    },
    {
      statistic: 'Average',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.avg_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.avg_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.avg_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Standard Deviation, RMS',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.sd_rms_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.sd_rms_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.sd_rms_or))
        : '',
      evaluation: ''
    },
    {
      statistic: '% RSD',
      setupData: '',
      recentData: '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.percent_rsd))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Standard Deviation, MR',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.sd_mr_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.sd_mr_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.sd_mr_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'GESD outlier (count)',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.outliers_gesd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.outliers_gend))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.outliers_geor))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Runs Omitted',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.omits_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.omits_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.omits_all))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Repeatability (r)',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.repeat_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.repeat_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.repeat_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Reproducibility (R)',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.repro_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.repro_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.repro_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Site Precision (R’)',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.sp_sd)) : '',
      recentData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.sp_nd)) : '',
      pooledData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.sp_or)) : '',
      evaluation: ''
    },
    {
      statistic: 'Precision Ratio',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.pr_sd)) : '',
      recentData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.pr_nd)) : '',
      pooledData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.pr_or)) : '',
      evaluation: ''
    },
    {
      statistic: 'TPI',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.tpi_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.tpi_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.tpi_or))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.tpi_eval_or) : ''
    },
    {
      statistic: 'Anderson Darling (RMS)',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ad_rms_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ad_rms_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ad_rms_or))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.ad_eval_or) : ''
    },
    {
      // Informational only: the Normality evaluation above uses the RMS row.
      statistic: AD_MR_LABEL,
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ad_mr_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ad_mr_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ad_mr_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'Chi-squared (RMS)',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.chi_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.chi_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.chi_or))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.chi_eval_or) : ''
    },
    {
      statistic: 'Chi-squared (critical)',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.chi_critical_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.chi_critical_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.chi_critical_or))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.chi_eval_or) : ''
    },
    {
      statistic: 't-test, critical value',
      setupData: '',
      recentData: '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.t_critical))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.t_eval) : ''
    },
    {
      statistic: 't-test, test statistic',
      setupData: '',
      recentData: '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.t_statistic))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.t_eval) : ''
    },
    {
      statistic: 'F-test, critical value',
      setupData: '',
      recentData: '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.f_statistic))
        : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.f_eval) : ''
    },
    {
      statistic: 'Variance ratio (F-test)',
      setupData: '',
      recentData: '',
      pooledData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.f_vr)) : '',
      evaluation: currentSummary ? sanitizePropertyData(currentSummary.f_eval) : ''
    },
    {
      statistic: 'UCL',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.ucl_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ucl_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.ucl_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'LCL',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.lcl_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.lcl_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.lcl_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'UWL',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.uwl_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.uwl_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.uwl_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'LWL',
      setupData: currentSummary ? renderSigDigits(sanitizePropertyData(currentSummary.lwl_sd)) : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.lwl_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.lwl_or))
        : '',
      evaluation: ''
    },
    {
      statistic: 'MR UCL',
      setupData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.mrucl_sd))
        : '',
      recentData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.mrucl_nd))
        : '',
      pooledData: currentSummary
        ? renderSigDigits(sanitizePropertyData(currentSummary.mrucl_or))
        : '',
      evaluation: ''
    }
  ];

  const [currentModalAvailableTimes, setCurrentModalAvailableTimes] = useState([]);
  const [currentModalSchedule, setCurrentModalSchedule] = useState({});
  const [currentSampleSchedules, setCurrentSampleSchedules] = useState([]);
  const [scheduleModalType, setScheduleModalType] = useState('');
  const [currentModalRegularEntry, setCurrentModalRegularEntry] = useState({});
  const [currentRegularSampleEntries, setCurrentRegularSampleEntries] = useState([]);
  const [regularEntryModalType, setRegularEntryModalType] = useState('');
  const [sampleScheduleTimes] = useState([
    { time: '12:00 AM', label: '12:00 AM' },
    { time: '12:30 AM', label: '12:30 AM' },
    { time: '1:00 AM', label: '1:00 AM' },
    { time: '1:30 AM', label: '1:30 AM' },
    { time: '2:00 AM', label: '2:00 AM' },
    { time: '2:30 AM', label: '2:30 AM' },
    { time: '3:00 AM', label: '3:00 AM' },
    { time: '3:30 AM', label: '3:30 AM' },
    { time: '4:00 AM', label: '4:00 AM' },
    { time: '4:30 AM', label: '4:30 AM' },
    { time: '5:00 AM', label: '5:00 AM' },
    { time: '5:30 AM', label: '5:30 AM' },
    { time: '6:00 AM', label: '6:00 AM' },
    { time: '6:30 AM', label: '6:30 AM' },
    { time: '7:00 AM', label: '7:00 AM' },
    { time: '7:30 AM', label: '7:30 AM' },
    { time: '8:00 AM', label: '8:00 AM' },
    { time: '8:30 AM', label: '8:30 AM' },
    { time: '9:00 AM', label: '9:00 AM' },
    { time: '9:30 AM', label: '9:30 AM' },
    { time: '10:00 AM', label: '10:00 AM' },
    { time: '10:30 AM', label: '10:30 AM' },
    { time: '11:00 AM', label: '11:00 AM' },
    { time: '11:30 AM', label: '11:30 AM' },
    { time: '12:00 PM', label: '12:00 PM' },
    { time: '12:30 PM', label: '12:30 PM' },
    { time: '1:00 PM', label: '1:00 PM' },
    { time: '1:30 PM', label: '1:30 PM' },
    { time: '2:00 PM', label: '2:00 PM' },
    { time: '2:30 PM', label: '2:30 PM' },
    { time: '3:00 PM', label: '3:00 PM' },
    { time: '3:30 PM', label: '3:30 PM' },
    { time: '4:00 PM', label: '4:00 PM' },
    { time: '4:30 PM', label: '4:30 PM' },
    { time: '5:00 PM', label: '5:00 PM' },
    { time: '5:30 PM', label: '5:30 PM' },
    { time: '6:00 PM', label: '6:00 PM' },
    { time: '6:30 PM', label: '6:30 PM' },
    { time: '7:00 PM', label: '7:00 PM' },
    { time: '7:30 PM', label: '7:30 PM' },
    { time: '8:00 PM', label: '8:00 PM' },
    { time: '8:30 PM', label: '8:30 PM' },
    { time: '9:00 PM', label: '9:00 PM' },
    { time: '9:30 PM', label: '9:30 PM' },
    { time: '10:00 PM', label: '10:00 PM' },
    { time: '10:30 PM', label: '10:30 PM' },
    { time: '11:00 PM', label: '11:00 PM' },
    { time: '11:30 PM', label: '11:30 PM' }
  ]);

  const aggregateFlags = (summaryIn) => {
    const summary = summaryIn;
    summary.flags = '';
    summary.chartStatus = 'In control';
    if (summary.ooc_or && summary.warnings_or) {
      if (summary.ooc_or.length > 0 && summary.warnings_or.length === 0) {
        summary.flags = `OOC: ${summary.ooc_or}`;
        summary.chartStatus = 'OOC';
      } else if (summary.warnings_or.length > 0 && summary.ooc_or.length === 0) {
        summary.flags = `Warning: ${summary.warnings_or}`;
        summary.chartStatus = 'Warning';
      } else if (summary.warnings_or.length > 0 && summary.ooc_or.length > 0) {
        summary.flags = `OOC: ${summary.ooc_or}, Warning: ${summary.warnings_or}`;
        summary.chartStatus = 'OOC';
      }
    }
    return summary;
  };

  useEffect(() => {
    if (Array.isArray(sampleSchedules)) {
      const updatedSampleSchedules = sampleSchedules
        .filter((schedule) => schedule.shortKey === currentShortKey)
        .map((schedule) => {
          const { seconds, nanoseconds } = schedule.startingDate;
          const milliseconds = seconds * 1000 + nanoseconds / 1000000;
          const startingDateDisplayed = moment(new Date(milliseconds)).format('MM/DD/YYYY');
          return {
            ...schedule,
            startingDateDisplayed
          };
        });
      setCurrentSampleSchedules(updatedSampleSchedules);
    }
  }, [sampleSchedules, currentShortKey]);

  useEffect(() => {
    if (Array.isArray(regularSampleEntries)) {
      const updatedRegularSampleEntries = regularSampleEntries
        .filter((entry) => entry.shortKey === currentShortKey)
        .map((entry) => {
          let startingDateDisplayed = '';
          if (entry.startDate?.seconds !== undefined) {
            const { seconds, nanoseconds } = entry.startDate;
            const milliseconds = seconds * 1000 + nanoseconds / 1000000;
            startingDateDisplayed = moment(new Date(milliseconds)).format('MM/DD/YYYY');
          }
          return {
            ...entry,
            startingDateDisplayed
          };
        });
      setCurrentRegularSampleEntries(updatedRegularSampleEntries);
    }
  }, [regularSampleEntries, currentShortKey]);

  useEffect(() => {
    if (Array.isArray(summaries) && summaries.length > 0) {
      summaries.forEach((summaryIn) => {
        const summary = summaryIn;
        summary.recent_sample = parseFloat(summary.recent_sample).toFixed(5);
        summary.tpi_or = parseFloat(summary.tpi_or).toFixed(5);
        summary.sp_or = parseFloat(summary.sp_or).toFixed(5);
        summary.avg_or = parseFloat(summary.avg_or).toFixed(5);
        summary.sd_rms_or = parseFloat(summary.sd_rms_or).toFixed(5);
        summary.sd_mr_or = parseFloat(summary.sd_mr_or).toFixed(5);
        summary.repeat_or = parseFloat(summary.repeat_or).toFixed(5);
        summary.repro_or = parseFloat(summary.repro_or).toFixed(5);
        summary.pr_or = parseFloat(summary.pr_or).toFixed(5);
        summary.ad_mr_or = parseFloat(summary.ad_mr_or).toFixed(5);
        aggregateFlags(summary);
        const fullKey = summary.id;
        summary.location = fullKey.substr(0, fullKey.indexOf('|'));
        const secondStr = fullKey.substr(fullKey.indexOf('|') + 1, fullKey.length - 1);
        summary.method = secondStr.substr(0, secondStr.indexOf('|'));
        const thirdStr = secondStr.substr(secondStr.indexOf('|') + 1, secondStr.length - 1);
        summary.sampleName = thirdStr.substr(0, thirdStr.indexOf('|'));
        const fourthStr = thirdStr.substr(thirdStr.indexOf('|') + 1, thirdStr.length - 1);
        summary.instrument = fourthStr.substr(0, fourthStr.indexOf('|'));
        const fifthStr = fourthStr.substr(fourthStr.indexOf('|') + 1, fourthStr.length - 1);
        summary.parameter = fifthStr.substr(0, fifthStr.length);
      });

      setCurrentSummaries(summaries);
    }
  }, [summaries]);

  const archiveDataPoints = () => {
    const updatedModalAssessment = { ...modalAssessment };
    if (updatedModalAssessment.archive === 'Yes') {
      updatedModalAssessment.archive = 'No';
    } else {
      updatedModalAssessment.archive = 'Yes';
    }
    setModalAssessment(updatedModalAssessment);
  };

  // Pooling a Periodic assessment must durably set setupData=1 + locked=true on
  // every data point for the parameter. For Colonial the daily SFTP correction
  // pass (jobs/job-daily/lib/run-sftp.js) re-zeros setupData on any doc that is
  // not locked, so a pooled doc only survives if its lock write actually lands;
  // boolean locked:true is the value its isDocLocked guard recognizes.
  //
  // The previous version fired un-awaited writes over the (possibly stale)
  // `items` onSnapshot subscription with no error handling, so a partial/failed
  // pool was silently recorded as "Data Pooled" while the data stayed unpooled
  // (fuelsqcv2-dif). Re-fetch the full current set and write only the pooled
  // fields in an atomic, awaited batch so any failure surfaces to the caller.
  const poolData = async () => {
    const dataPoints = await getDataByFullKey(currentFullKey);
    if (dataPoints === null) {
      // getDataByFullKey swallows Firestore errors and returns null; surface it
      // as a fetch failure rather than mislabeling it an empty dataset.
      throw new Error(`Pooling failed to fetch data for ${currentFullKey}`);
    }
    if (!Array.isArray(dataPoints) || dataPoints.length === 0) {
      throw new Error(`Pooling found no data points for ${currentFullKey}`);
    }
    await batchUpdateData(
      dataPoints.map((dataPoint) => ({
        id: dataPoint.id,
        data: { flags: '', locked: true, setupData: 1 }
      }))
    );
  };

  const unArchiveDataPoints = () => {
    items.forEach((dataPointIn) => {
      const dataPoint = dataPointIn;
      dataPoint.flags = '';
      dataPoint.archive = false;
      updateData(dataPoint.id, dataPoint);
    });
  };

  const handleAssessmentChange = (e, propertyName) => {
    const updatedModalAssessment = { ...modalAssessment };
    updatedModalAssessment[propertyName] = e.target.value;
    setModalAssessment(updatedModalAssessment);
  };
  const isValidFlag = (v) => {
    if (typeof v !== 'string') return v != null;
    const val = v.trim().toLowerCase();
    return val !== '' && val !== 'n/a' && val !== '#n/a';
  };
  const renderPeriodicPage = (page) => {
    switch (page) {
      case '1':
        return (
          <>
            <Row className="report-header">
              <h4>
                Summary Statistics: {currentParameter}
                {unit ? `, ${unit}` : ''}
              </h4>
            </Row>
            <Row className="statistics-table">
              <CustomTable
                numberOfRows={50}
                hideFooter={true}
                data={
                  modalMode === 'view' && modalAssessment?.summaryStatistics
                    ? modalAssessment.summaryStatistics
                    : summaryStatisticsDataPeriodic
                }
                header={summaryStatisticsColumnsPeriodic}
              />
            </Row>
            <div>
              <table>
                <tr />
              </table>
            </div>
            <Row className="report-header">
              <h4>Assessment: {currentParameter}</h4>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  1. Visual Assessment for suspicious results (including GESD outliers)
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioSR-pass"
                  id="radioSR-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.suspiciousResults === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.suspiciousResults === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'suspiciousResults')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioSR-fail"
                  id="radioSR-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.suspiciousResults === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.suspiciousResults === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'suspiciousResults')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  2. Visual Assessment for unusual patterns (trending, clustering, cycles)
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioUP-pass"
                  id="radioUP-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.unusualPatterns === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.unusualPatterns === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'unusualPatterns')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioUP-fail"
                  id="radioUP-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.unusualPatterns === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.unusualPatterns === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'unusualPatterns')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  3. Evaluation of TPI to assess site precision vs Reproducibility
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioTE-pass"
                  id="radioTE-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.tpiEvaluation === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.tpiEvaluation === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'tpiEvaluation')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioTE-fail"
                  id="radioTE-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.tpiEvaluation === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.tpiEvaluation === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'tpiEvaluation')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  4. Performance of Chi Square test to assess site precision vs Reproducibility
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioCST-pass"
                  id="radioCST-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.chiSquareTest === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.chiSquareTest === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'chiSquareTest')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioCST-fail"
                  id="radioCST-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.chiSquareTest === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.chiSquareTest === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'chiSquareTest')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  5. Assessment of normal probability plot (for linearity) and histogram
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioNPP-pass"
                  id="radioNPP-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.normalProbabilityPlot === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.normalProbabilityPlot === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'normalProbabilityPlot')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioNPP-fail"
                  id="radioNPP-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.normalProbabilityPlot === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.normalProbabilityPlot === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'normalProbabilityPlot')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  6. Evaluation of Anderson-Darling test statistic for normality
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioAD-pass"
                  id="radioAD-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.andersonDarling === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.andersonDarling === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'andersonDarling')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioAD-fail"
                  id="radioAD-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.andersonDarling === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.andersonDarling === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'andersonDarling')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  7. Performance of t-Test to evaluate accuracy / bias
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radiotT-pass"
                  id="radiotT-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.tTest === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.tTest === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'tTest')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radiotT-fail"
                  id="radiotT-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.tTest === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.tTest === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'tTest')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  8. Performance of F-Test to evaluate changes in variance
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radiofT-pass"
                  id="radiofT-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.fTest === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.fTest === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'fTest')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radiofT-fail"
                  id="radiofT-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.fTest === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.fTest === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'fTest')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  Assessor comments
                </h6>
              </Col>
            </Row>
            <Row>
              <Col lg={9}>
                <Form className="ia-table" style={{ marginLeft: '50px' }}>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Control
                      className="comments"
                      as="textarea"
                      rows={2}
                      onChange={(e) => handleAssessmentChange(e, 'assessorComments')}
                      aria-label="Basic example"
                      value={modalAssessment.assessorComments}
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row style={{ marginTop: '15px' }}>
              <Col lg={9}>
                <h6 className="ia-table" style={{ marginLeft: '50px' }}>
                  Assessment outcome
                </h6>
              </Col>
              <Col>
                <ToggleButton
                  key="radioOutcome-pass"
                  id="radioOutcome-pass"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.outcome === 'Pass'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Pass"
                  checked={modalAssessment.outcome === 'Pass'}
                  onChange={(e) => handleAssessmentChange(e, 'outcome')}
                >
                  Pass
                </ToggleButton>
                <ToggleButton
                  key="radioOutcome-fail"
                  id="radioOutcome-fail"
                  type="radio"
                  variant="outline-primary"
                  name="radio"
                  style={
                    modalAssessment.outcome === 'Fail'
                      ? { backgroundColor: 'navy', color: 'white' }
                      : {}
                  }
                  value="Fail"
                  checked={modalAssessment.outcome === 'Fail'}
                  onChange={(e) => handleAssessmentChange(e, 'outcome')}
                >
                  Fail
                </ToggleButton>
              </Col>
            </Row>
          </>
        );
      case '2':
        return (
          <>
            <div className="overview-chart-header">
              <h4>Chart: {currentParameter}</h4>
            </div>
            {!chartScalars ||
            Object.keys(chartScalars).length === 0 ||
            chartScalars.cYMin == null ||
            chartScalars.cYMax == null ||
            chartScalars.mrYMax == null ||
            chartScalars.mrMean == null ||
            chartScalars.mrUCL == null ||
            chartScalars.trendData == null ||
            chartScalars.qqXMin == null ||
            chartScalars.qqXMax == null ||
            chartScalars.qqYMin == null ||
            chartScalars.qqYMax == null ? (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <p>Chart data is unavailable. Please run the data to generate charts.</p>
              </div>
            ) : (
              <>
                <div className="chart-row-container">
                  <SQCLineChart
                    xAxis="updatedIndex"
                    syncId="chained"
                    yMin={chartScalars.cYMin}
                    yMax={chartScalars.cYMax}
                    data={chartData}
                    lines={chartLines}
                  />
                  <SQCMovingRangeChart
                    xAxis="updatedIndex"
                    key={uuidv4()}
                    data={chartData}
                    syncId="chained2"
                    yMin={0}
                    yMax={chartScalars.mrYMax}
                    lines={[
                      {
                        yAxis: 'mrOmits',
                        name: 'Data',
                        color: '#32CD32'
                      },
                      {
                        yAxis: 'mean',
                        overrideValue: chartScalars.mrMean,
                        name: 'Center Line',
                        reference: true,
                        label: `Center Line`,
                        color: 'orange'
                      },
                      {
                        yAxis: 'sd3p',
                        overrideValue: chartScalars.mrUCL,
                        label: `UCL`,
                        color: 'red',
                        reference: true
                      }
                    ]}
                  />
                </div>
                <div>
                  <>
                    {chartScalars.histogramData && (
                      <SQCHistogram
                        data={chartScalars.histogramData}
                        Xlabel={currentParameter}
                        Ylabel={`Frequency`}
                      />
                    )}
                    {!chartScalars.histogramData && <div>No Histogram</div>}
                  </>
                  <SQCScatterPlot
                    xAxis="zScoreOmits"
                    key={uuidv4()}
                    data={chartData}
                    syncId="chained2"
                    xMin={chartScalars.qqXMin}
                    xMax={chartScalars.qqXMax}
                    yMin={chartScalars.qqYMin}
                    yMax={chartScalars.qqYMax}
                    collections={[
                      {
                        name: 'Lab Results',
                        color: '#32CD32',
                        data: chartData.map((cd) => {
                          return {
                            x: cd.zScoreOmits,
                            y: cd.resultOmits
                          };
                        })
                      },
                      {
                        name: 'Trend Line',
                        color: '#FFBF00',
                        data: chartScalars.trendData,
                        line: true
                      }
                    ]}
                    Xlabel={<text>{`Theoretical quantiles`}</text>}
                    Ylabel={<text>{`Normal data quantiles`}</text>}
                  />
                </div>
              </>
            )}
          </>
        );
      case '3':
        const columns = handleDateTimeColumns(defaultColumnsReport, tz, dateTimeFormat);
        return (
          <>
            <Row className="report-header">
              <h4>Data: {currentParameter}</h4>
            </Row>
            <div className="page-three-container">
              <CustomTable
                numberOfRows={pageSizeDefault}
                data={filteredChartHits}
                header={columns}
                sort={{ sorting: { sortModel: [{ field: 'dateTime', sort: 'asc' }] } }}
              />
            </div>
          </>
        );
      default:
        return <></>;
    }
  };

  const selectPeriodicPage = (e) => {
    setPeriodicPage(e.target.value);
  };

  function sortCountCurrentValues(currentArray) {
    const sortedCountedArray = [];
    currentArray.forEach((element) => {
      const elObj = typeof element === 'string' ? { name: element, count: 1 } : { ...element };

      const existingIndex = sortedCountedArray.findIndex(
        (scElement) => scElement.name === elObj.name
      );
      if (existingIndex !== -1) {
        sortedCountedArray[existingIndex].count += elObj.count || 1;
      } else {
        sortedCountedArray.push(elObj);
      }
    });
    return sortedCountedArray;
  }

  const mapLocationChildren = (
    value,
    updatedMethods,
    updatedSampleNames,
    updatedInstruments,
    updatedParameters
  ) => {
    const currentFilteredLocation = currentLocations.filter((location) => location.name === value);
    if (currentFilteredLocation[0]) {
      currentFilteredLocation[0].method.forEach((method) => {
        updatedMethods.push(method);
        if (!instrumentBeforeSampleName) {
          method.sampleName?.forEach((listedSampleName) => {
            updatedSampleNames.push(listedSampleName);
            listedSampleName.instrument.forEach((instrument) => {
              updatedInstruments.push(instrument);
              instrument.parameter.forEach((parameter) => {
                updatedParameters.push(parameter);
              });
            });
          });
        } else {
          method.instrument?.forEach((listedInstrument) => {
            updatedInstruments.push(listedInstrument);
            listedInstrument.sampleName.forEach((sampleName) => {
              updatedSampleNames.push(sampleName);
              sampleName.parameter.forEach((parameter) => {
                updatedParameters.push(parameter);
              });
            });
          });
        }
      });
    }
  };

  const mode = radioArchiveValue.toLowerCase();

  const handleLocationChange = (e, fromUrl = false) => {
    if (!fromUrl) {
      if (e.target.value) {
        history.push({ search: `?mode=${mode}&location=${encodeURIComponent(e.target.value)}` });
      } else {
        history.push({ search: '' });
      }
      return;
    }
    setCurrentLocation(e.target.value);
    const updatedMethods = [];
    const updatedSampleNames = [];
    const updatedInstruments = [];
    const updatedParameters = [];
    mapLocationChildren(
      e.target.value,
      updatedMethods,
      updatedSampleNames,
      updatedInstruments,
      updatedParameters
    );
    setCurrentMethod(null);
    setCurrentSampleName(null);
    setCurrentInstrument(null);
    setCurrentParameter(null);
    setCurrentMethods([...sortCountCurrentValues(updatedMethods)]);
    setCurrentSampleNames([...sortCountCurrentValues(updatedSampleNames)]);
    setCurrentInstruments([...sortCountCurrentValues(updatedInstruments)]);
    setCurrentParametersDynamic([...sortCountCurrentValues(updatedParameters)]);
  };

  const handleMethodChangeComparison = (e) => {
    setCurrentMethodComparison(e.target.value);
  };

  const handleSampleNameChangeComparison = (e) => {
    setCurrentSampleNameComparison(e.target.value);
  };

  const handleParameterChangeComparison = (e) => {
    setCurrentParameterComparison(e.target.value);
  };

  const mapMethodChildren = (value, updatedSampleNames, updatedInstruments, updatedParameters) => {
    const currentFilteredMethod = currentMethods.filter((method) => method.name === value);
    if (!instrumentBeforeSampleName) {
      currentFilteredMethod[0]?.sampleName?.forEach((listedSampleName) => {
        updatedSampleNames.push(listedSampleName);
        listedSampleName.instrument.forEach((instrument) => {
          updatedInstruments.push(instrument);
          instrument.parameter.forEach((parameter) => {
            updatedParameters.push(parameter);
          });
        });
      });
    } else {
      currentFilteredMethod[0]?.instrument?.forEach((listedInstrument) => {
        updatedInstruments.push(listedInstrument);
        listedInstrument.sampleName.forEach((sampleName) => {
          updatedSampleNames.push(sampleName);
          sampleName.parameter.forEach((parameter) => {
            updatedParameters.push(parameter);
          });
        });
      });
    }
  };

  const handleMethodChange = (e, fromUrl = false) => {
    if (!fromUrl) {
      if (e.target.value) {
        history.push({
          search: `?mode=${mode}&location=${encodeURIComponent(
            currentLocation
          )}&method=${encodeURIComponent(e.target.value)}`
        });
      } else {
        history.push({ search: `?mode=${mode}&location=${encodeURIComponent(currentLocation)}` });
      }
      return;
    }
    setCurrentMethodComparison(e.target.value);
    setCurrentMethod(e.target.value);
    const updatedSampleNames = [];
    const updatedInstruments = [];
    const updatedParameters = [];
    mapMethodChildren(e.target.value, updatedSampleNames, updatedInstruments, updatedParameters);
    setCurrentSampleName(null);
    setCurrentInstrument(null);
    setCurrentParameter(null);
    setCurrentSampleNames([...sortCountCurrentValues(updatedSampleNames)]);
    setCurrentInstruments([...sortCountCurrentValues(updatedInstruments)]);
    setCurrentParametersDynamic([...sortCountCurrentValues(updatedParameters)]);
  };

  const mapSampleNameChildren = (value, updatedInstruments, updatedParameters) => {
    const currentFilteredSampleName = currentSampleNames.filter(
      (sampleName) => sampleName.name === value
    );
    if (!instrumentBeforeSampleName) {
      currentFilteredSampleName[0]?.instrument?.forEach((instrument) => {
        updatedInstruments.push(instrument);
        instrument.parameter.forEach((parameter) => {
          updatedParameters.push(parameter);
        });
      });
    } else {
      currentFilteredSampleName[0]?.parameter?.forEach((parameter) => {
        updatedParameters.push(parameter);
      });
    }
  };

  const handleSampleNameChange = (e, fromUrl = false) => {
    if (!instrumentBeforeSampleName) {
      if (!fromUrl) {
        if (e.target.value) {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&sampleName=${encodeURIComponent(
              e.target.value
            )}`
          });
        } else {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}`
          });
        }
        return;
      }
    } else {
      if (!fromUrl) {
        if (e.target.value) {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&instrument=${encodeURIComponent(
              currentInstrument
            )}&sampleName=${encodeURIComponent(e.target.value)}`
          });
        } else {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&instrument=${encodeURIComponent(
              currentInstrument
            )}`
          });
        }
        return;
      }
    }
    setCurrentSampleNameComparison(e.target.value);
    setCurrentSampleName(e.target.value);
    const updatedInstruments = [];
    const updatedParameters = [];
    mapSampleNameChildren(e.target.value, updatedInstruments, updatedParameters);
    if (!instrumentBeforeSampleName) {
      setCurrentInstrument(null);
      setCurrentInstruments(sortCountCurrentValues(updatedInstruments));
    }
    setCurrentParameter(null);
    setCurrentParametersDynamic(sortCountCurrentValues(updatedParameters));
  };

  const mapInstrumentChildren = (value, updatedSampleNames, updatedParameters) => {
    const currentFilteredInstrument = currentInstruments.filter(
      (instrument) => instrument.name === value
    );
    if (instrumentBeforeSampleName) {
      currentFilteredInstrument[0]?.sampleName?.forEach((listedSampleName) => {
        updatedSampleNames.push(listedSampleName);
        listedSampleName.parameter.forEach((parameter) => {
          updatedParameters.push(parameter);
        });
      });
    } else {
      currentFilteredInstrument[0]?.parameter?.forEach((parameter) => {
        updatedParameters.push(parameter);
      });
    }
  };

  const handleInstrumentChange = (e, fromUrl = false) => {
    if (!instrumentBeforeSampleName) {
      if (!fromUrl) {
        if (e.target.value) {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&sampleName=${encodeURIComponent(
              currentSampleName
            )}&instrument=${encodeURIComponent(e.target.value)}`
          });
        } else {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&sampleName=${encodeURIComponent(
              currentSampleName
            )}`
          });
        }
        return;
      }
    } else {
      if (!fromUrl) {
        if (e.target.value) {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&instrument=${encodeURIComponent(
              e.target.value
            )}`
          });
        } else {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}`
          });
        }
        return;
      }
    }
    setCurrentInstrument(e.target.value);
    const updatedParameters = [];
    const updatedSampleNames = [];
    mapInstrumentChildren(e.target.value, updatedSampleNames, updatedParameters);
    if (instrumentBeforeSampleName) {
      setCurrentSampleName(null);
      setCurrentSampleNames([...sortCountCurrentValues(updatedSampleNames)]);
    }
    setCurrentParameter(null);
    setCurrentParametersDynamic([...sortCountCurrentValues(updatedParameters)]);
  };

  useEffect(() => {
    if (!location) {
      return;
    }

    const queryParams = new URLSearchParams(location.search);
    const hasParameter = queryParams.has('parameter');
    if (hasParameter) {
      return;
    }

    const canAutoFill =
      config?.autoFillingParameter &&
      currentLocation &&
      currentMethod &&
      currentInstrument &&
      currentSampleName &&
      !currentParameter &&
      currentParametersDynamic?.length > 0;

    if (canAutoFill) {
      const sortedParameters = [...currentParametersDynamic]
        .filter((item) => item.name !== defaultCombinedParameterName)
        .sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })
        );
      setTimeout(() => {
        handleParameterChange({ target: { value: sortedParameters[0]?.name ?? null } }, false);
      }, 500);
    }
  }, [
    currentLocation,
    currentMethod,
    currentInstrument,
    currentParameter,
    currentSampleName,
    currentParametersDynamic,
    config,
    location
  ]);

  const handleParameterChange = (e, fromUrl = false) => {
    const value = e.target.value;

    setCurrentParameterComparison(value);
    setCurrentParameter(value);
    sessionStorage.removeItem(currentShortKey);

    if (!fromUrl) {
      if (value) {
        if (instrumentBeforeSampleName) {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&instrument=${encodeURIComponent(
              currentInstrument
            )}&sampleName=${encodeURIComponent(currentSampleName)}&parameter=${encodeURIComponent(
              value
            )}`
          });
        } else {
          history.push({
            search: `?mode=${mode}&location=${encodeURIComponent(
              currentLocation
            )}&method=${encodeURIComponent(currentMethod)}&sampleName=${encodeURIComponent(
              currentSampleName
            )}&instrument=${encodeURIComponent(currentInstrument)}&parameter=${encodeURIComponent(
              value
            )}`
          });
        }
      } else {
        if (instrumentBeforeSampleName) {
          history.push({
            search: `?mode=${mode}&location=${currentLocation}&method=${currentMethod}&instrument=${currentInstrument}&sampleName=${currentSampleName}`
          });
        } else {
          history.push({
            search: `?mode=${mode}&location=${currentLocation}&method=${currentMethod}&sampleName=${currentSampleName}&instrument=${currentInstrument}`
          });
        }
      }
      return;
    }
  };

  const handleCombinedZScoreParameterChange = (event) => {
    const { value } = event.target.selectedOptions[0];
    const exist = combinedZScoreData.find((item) => item.parameter === value);
    if (!exist) {
      setCombinedZScoreData((prevOptions) => [...prevOptions, { parameter: value }]);
    }
  };

  const handleDeleteParameter = (parameterToDelete) => {
    const { parameter } = parameterToDelete;
    setCombinedZScoreData((prevData) => prevData.filter((item) => item.parameter !== parameter));
  };

  const handleResultsTableChange = (e, index, propertyName) => {
    let value = e.currentTarget.value;

    setResultsDataTableData((prevData) => {
      const newData = [...prevData];
      newData[index] = { ...newData[index], [propertyName]: value };

      if (propertyName === 'dateTime') {
        newData[index].isEditedDatetime = true;
      }
      if (propertyName === 'sampleId') {
        newData[index].isEditedSampleId = true;
      }

      return newData;
    });
  };

  useEffect(() => {
    if (currentShortKey) {
      sessionStorage.setItem(currentShortKey, JSON.stringify(resultsDataTableData));
    }
  }, [resultsDataTableData, currentShortKey]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem(currentShortKey);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [currentShortKey]);

  const getChartLinesForStrategy = (strategy, isNonUs) => {
    const chartLinesToReturn = isNonUs ? defaultChartLinesNonUs : defaultChartLines;
    return filterChartLinesByStrategy(strategy, chartLinesToReturn);
  };

  const mapControlStrategyToChartLines = (strategy) => {
    const lines = getChartLinesForStrategy(strategy, isNonUs);
    setChartLines(lines);
  };

  useEffect(() => {
    mapControlStrategyToChartLines(currentControlStrategyConfigurations.controlStrategy);
  }, [currentControlStrategyConfigurations.controlStrategy, companyTypes]);

  const calculateRepeatabilityLimit = (avg_sd, repeat_sd, isLower) => {
    const limit = renderSigDigits(
      Number(avg_sd) + (isLower ? -1 : 1) * (Number(repeat_sd) / 2.77) * 3
    );
    return limit || 'N/A';
  };

  const updateControlLimit = (
    limitType,
    cellName,
    cellValue,
    currentSummary,
    controlStrategyConfigurationsToUpdate
  ) => {
    switch (cellName) {
      case 'Use Repeatability-based limit':
        cellValue.value = calculateRepeatabilityLimit(
          currentSummary.avg_sd,
          currentSummary.repeat_sd,
          limitType === 'lower'
        );
        break;
      case 'Default':
        cellValue.value = 'N/A';
        break;
      case 'Custom':
        cellValue.value = Number.isNaN(Number(cellValue.value)) ? 'N/A' : cellValue.value;
        break;
      default:
        return;
    }

    cellValue.approach = cellName;
    controlStrategyConfigurationsToUpdate[`${limitType}ControlLimitApproach`] = cellValue.approach;
    controlStrategyConfigurationsToUpdate[`${limitType}ControlLimit`] = cellValue.value;
  };

  const updateStateConfigurations = (cellValueIn, cellName) => {
    const cellValue = cellValueIn;
    const chartGroupConfigurationsToUpdate = currentChartGroupConfigurations;
    const controlStrategyConfigurationsToUpdate = currentControlStrategyConfigurations;
    // The config objects are mutated in place, so the setters below get the same
    // reference and React may skip the re-render. Set when another row's displayed
    // value depends on this edit (1090 Material -> 1090 Parameter reset).
    let forceControlStrategyRefresh = false;

    switch (cellValue.variable) {
      // control strategy configurations
      case 'Pre-treat data':
        controlStrategyConfigurationsToUpdate.pretreatData = cellValue.value;
        break;
      case 'Control Strategy':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.controlStrategy = cellValue.value;
        // reset default data for Control Strategy
        setDefaultControlStrategies(cellValue.value, controlStrategyConfigurationsToUpdate);
        break;
      case 'Dynamically updated I-chart':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.duiChart = cellValue.value;
        break;
      case 'Chart axis significant digits':
        cellValue.value = parseInt(cellName, 10);
        controlStrategyConfigurationsToUpdate.chartSigDigits = cellValue.value;
        break;
      case 'Lower Tolerance Limit':
        if (cellName === 'Use Lower Tolerance Limit (1090)') {
          cellValue.value = currentSummary?.avg_minus_1090_delta || 'N/A';
          cellValue.approach = cellName;
          controlStrategyConfigurationsToUpdate.lowerToleranceLimitApproach = cellValue.approach;
        } else if (cellName === 'Default') {
          cellValue.approach = cellName;
          controlStrategyConfigurationsToUpdate.lowerToleranceLimitApproach = cellValue.approach;
          cellValue.value = 'N/A';
        } else if (cellName === 'Custom') {
          cellValue.approach = cellName;
          controlStrategyConfigurationsToUpdate.lowerToleranceLimitApproach = cellValue.approach;
          controlStrategyConfigurationsToUpdate.lowerToleranceLimit = cellValue.value;
          cellValue.value = Number.isNaN(Number(cellValue.value)) ? 'N/A' : cellValue.value;
        } else {
          cellValue.value = cellName;
        }
        controlStrategyConfigurationsToUpdate.lowerToleranceLimit = cellValue.value;
        break;
      case 'Upper Tolerance Limit':
        if (cellName === 'Use Upper Tolerance Limit (1090)') {
          cellValue.value = currentSummary?.avg_plus_1090_delta || 'N/A';
          cellValue.approach = cellName;
          controlStrategyConfigurationsToUpdate.upperToleranceLimitApproach = cellValue.approach;
          controlStrategyConfigurationsToUpdate.upperToleranceLimit = cellValue.value;
        } else if (cellName === 'Default') {
          cellValue.approach = cellName;
          cellValue.value = 'N/A';
          controlStrategyConfigurationsToUpdate.upperToleranceLimitApproach = cellValue.approach;
          controlStrategyConfigurationsToUpdate.upperToleranceLimit = cellValue.value;
        } else if (cellName === 'Custom') {
          cellValue.approach = cellName;
          cellValue.value = Number.isNaN(Number(cellValue.value)) ? 'N/A' : cellValue.value;
          controlStrategyConfigurationsToUpdate.upperToleranceLimitApproach = cellValue.approach;
          controlStrategyConfigurationsToUpdate.upperToleranceLimit = cellValue.value;
        } else {
          cellValue.value = cellName;
          controlStrategyConfigurationsToUpdate.upperToleranceLimit = cellValue.value;
        }
        break;
      case 'Lower Control Limit':
        updateControlLimit(
          'lower',
          cellName,
          cellValue,
          currentSummary,
          controlStrategyConfigurationsToUpdate
        );
        break;
      case 'Upper Control Limit':
        updateControlLimit(
          'upper',
          cellName,
          cellValue,
          currentSummary,
          controlStrategyConfigurationsToUpdate
        );
        break;
      case 'Mean':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.mean = cellValue.value;
        break;
      case 'Standard Deviation':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.standardDeviation = cellValue.value;
        break;
      case 'n':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.n = cellValue.value;
        break;
      case 'Reproducibility':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.reproducibility = cellValue.value;
        break;
      case 'Repeatability':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.repeatability = cellValue.value;
        break;
      case 'EWMA Lambda':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.ewmaLambda = cellValue.value;
        break;
      case 't alpha':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.tAlpha = cellValue.value;
        break;
      case 'f alpha':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.fAlpha = cellValue.value;
        break;
      case 'Control limit violation (3 sigma)':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.controlLimitViolation = cellValue.value;
        break;
      case 'Warning limit violation (2 sigma)':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.warningLimitViolation = cellValue.value;
        break;
      case '2 of 3 points > 2 sigma':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.twoOfThree = cellValue.value;
        break;
      case '5 consecutive points > 1 sigma':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.fiveConsecutive = cellValue.value;
        break;
      case '9 consecutive points above/below centerline':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.nineConsecutive = cellValue.value;
        break;
      case '7 consecutive points increasing / decreasing':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.sevenConsecutive = cellValue.value;
        break;
      case 'EWMA trend':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.ewmaTrend = cellValue.value;
        break;
      case 'User defined control limit exceedance':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.controlLimitExceedance = cellValue.value;
        break;
      case 'Tolerance limit exceedance':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.toleranceLimitExceedance = cellValue.value;
        break;
      case 'Moving range limit violation (single point)':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.singlePointViolation = cellValue.value;
        break;
      case 'Moving range limit violation (5 of 20 points)':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.fivePointViolation = cellValue.value;
        break;
      case 'Anderson Darling exceeds exceeds 1.13':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.andersonDarling = cellValue.value;
        break;
      case 'TPI less than D6792 Limits':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.tpiOnePointTwo = cellValue.value;
        break;
      case 'Suppress TPI notifications':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.suppressTPI = cellValue.value;
        break;
      case 'Suppress Anderson Darling Notifications':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.suppressNormality = cellValue.value;
        break;
      // chart group configurations
      case 'Initial Assessment, samples (n)':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.initialAssessment = cellValue.value;
        break;
      case 'Ongoing assessment, samples (n)':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.ongoingAssessment = cellValue.value;
        break;
      case 'Ongoing assessment, days':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.ongoingAssessmentDays = cellValue.value;
        break;
      case 'Sample Type':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.sampleType = cellValue.value;
        break;
      case '1090 Material': {
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.tenNinetyMaterial = cellValue.value;
        // Gasoline allows Sulfur/Benzene/Oxygenates/RVP; every other material is
        // Sulfur only. A saved 1090 Parameter the new material doesn't support is
        // reset to Auto (the calc would ignore it anyway) and the user is told.
        const previousParameter = normalizeTenNinetyParameter(
          controlStrategyConfigurationsToUpdate.tenNinetyParameter
        );
        const keptParameter = resolveTenNinetyParameterForMaterial(
          previousParameter,
          cellValue.value
        );
        if (keptParameter !== previousParameter) {
          window.alert(
            `1090 Parameter "${previousParameter}" is not available for ${cellValue.value}; it has been reset to Auto.`
          );
        }
        controlStrategyConfigurationsToUpdate.tenNinetyParameter = keptParameter;
        forceControlStrategyRefresh = true;
        break;
      }
      case '1090 Parameter':
        // Only valid combos are offered; coerce anything else to Auto.
        cellValue.value = resolveTenNinetyParameterForMaterial(
          cellName,
          controlStrategyConfigurationsToUpdate.tenNinetyMaterial
        );
        controlStrategyConfigurationsToUpdate.tenNinetyParameter = cellValue.value;
        break;
      case 'Display method version':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.displayMethodVersion = cellValue.value;
        break;
      case 'Auto-create sample re-check':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.autoCreateSampleRecheck = cellValue.value;
        break;
      case 'Frequency':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.sampleScheduleFrequency = cellValue.value;
        break;
      case 'Starting on':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.sampleScheduleStartingOn = cellValue.value;
        break;
      case 'Time':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.sampleScheduleTime = cellValue.value;
        break;
      case 'Archive':
        cellValue.value = cellName;
        setArchiveStatus(cellValue.value);
        // controlStrategyConfigurationsToUpdate.archive = cellValue.value;
        break;
      case 'Control Status':
        cellValue.value = cellName;
        controlStrategyConfigurationsToUpdate.controlStatus = cellValue.value;
        break;
      case 'Combined Initial Assessment':
        cellValue.value = cellName;
        chartGroupConfigurationsToUpdate.combinedInitialAssessment = cellValue.value;
        break;
      default:
    }
    setCurrentChartGroupConfigurations(chartGroupConfigurationsToUpdate);
    setCurrentControlStrategyConfigurations(
      forceControlStrategyRefresh
        ? { ...controlStrategyConfigurationsToUpdate }
        : controlStrategyConfigurationsToUpdate
    );
    // reset data for table value control strategy change
    if (cellValue.variable == 'Control Strategy') {
      setControlStrategyData(generateControlStrategyData(controlStrategyConfigurationsToUpdate));
    }
  };

  const buildSummaryStatisticsDataSet = () => {
    const data = buildStatisticsDataset(currentSummariesShortKey, SUMMARY_STATISTICS_CONFIG, {
      formatSig: renderSigDigits
    });

    setSummaryStatisticsAssessmentData(data);
  };

  useEffect(() => {
    if (!currentFullKey || !Array.isArray(summaries)) return;

    // Always update currentSummary and currentSummariesShortKey
    const currentSummaryObject = summaries.find(
      (summaryObject) => summaryObject.id === firebaseClean(currentFullKey)
    );
    setCurrentSummary(currentSummaryObject);

    const currentShortKeyClean = firebaseClean(currentShortKey);
    const summariesShortKey = summaries.filter((summaryObject) =>
      summaryObject.id.includes(currentShortKeyClean)
    );
    setCurrentSummariesShortKey(summariesShortKey);

    // Mode-specific statistics display
    if (modalMode === 'view') {
      if (modalAssessment?.summaryStatistics) {
        setSummaryStatisticsAssessmentData(
          relabelLegacyStatistics(modalAssessment.summaryStatistics)
        );
      }
      return;
    }

    if (summariesShortKey.length > 0) {
      const data = buildStatisticsDataset(summariesShortKey, SUMMARY_STATISTICS_CONFIG, {
        formatSig: renderSigDigits
      });
      setSummaryStatisticsAssessmentData(data);
    }
  }, [
    currentFullKey,
    summaries,
    modalMode,
    modalAssessment,
    currentShortKey,
    currentChartGroupConfigurations.chartSigDigits,
    loadingRunData
  ]);
  useEffect(() => {
    if (Array.isArray(setupGroups) && setupGroups.length > 0) {
      setupGroups.forEach((groupIn) => {
        const group = groupIn;
        const locationsToDisplay = [];
        group.locations.forEach((location) => {
          locationsToDisplay.push(location.name);
        });
        group.locationsDisplayed = locationsToDisplay.toString().replaceAll(',', ', ');
        group.personnelNumber = group.personnel.length;
        group.instrumentsNumber = group.instruments.length;
        group.instrumentsAssigned = [];
        if (Array.isArray(currentInstruments) && currentInstruments.length > 0) {
          group.instruments.forEach((instrumentName) => {
            const existingInstrument = currentInstruments.find(
              (instrument) => instrument.name === instrumentName
            );
            if (existingInstrument) {
              group.instrumentsAssigned.push(existingInstrument);
            }
          });
        }
      });
      setCurrentSetupGroups(setupGroups);
    }
  }, [setupGroups && currentInstruments && currentPersonnel, setupGroups]);

  useEffect(() => {
    setCurrentShortKey(
      [currentLocation, currentMethod, currentSampleName, currentInstrument].join('|')
    );
    setCurrentFullKey(
      [currentLocation, currentMethod, currentSampleName, currentInstrument, currentParameter].join(
        '|'
      )
    );
    if (currentParameter !== null) {
      setLocalSearchFinished(true);
      if (Array.isArray(currentParameters)) {
        const currentDate = moment()
          .tz(tz || 'UTC')
          .format('YYYY/MM/DD');
        const currentTime = moment()
          .tz(tz || 'UTC')
          .format(timeFormat);
        const emailBeforeTheAt = auth.user.email.split('@')[0];
        const currentDateTime = moment(Date.now())
          .tz(tz || 'UTC')
          .format(dateTimeFormat);
        const matchingUser = currentPersonnel.find(
          (person) => person.email.toLowerCase() === auth.user.email.toLowerCase()
        );
        let rowIndex = 0;
        const updatedResultsDataTableData = [];
        let setupData = '0';
        if (currentNValue < 20 && currentNValue > 0) {
          setupData = '1';
        }
        const formatSample = `SQC${currentDate.replace(/\//g, '')}`;
        setDefaultSampleId(formatSample);

        const paramsOrdered = orderOfParameters?.[0]?.[currentShortKey] ?? {};

        for (const parameter of currentParameters) {
          const data = {
            key: rowIndex,
            date: currentDate,
            time: currentTime,
            dateTime: currentDateTime,
            isEditedDatetime: false,
            parameter,
            personnel: matchingUser
              ? config.useAbbreviationPersonnelName
                ? matchingUser.abbreviation || matchingUser.name
                : matchingUser.name
              : emailBeforeTheAt,
            sampleId: formatSample,
            isEditedSampleId: false,
            setupData,
            notes: '',
            result: '',
            order: paramsOrdered?.[parameter] ?? Number.MAX_SAFE_INTEGER
          };

          if (
            parameter !== defaultCombinedParameterName &&
            ((!archiveRegex.test(parameter) && radioArchiveValue === radioDataType.ACTIVE) ||
              (archiveRegex.test(parameter) && radioArchiveValue === radioDataType.ARCHIVE))
          ) {
            updatedResultsDataTableData.push(data);
            rowIndex += 1;
          }
        }

        const sortedResultsData = [...updatedResultsDataTableData].sort(
          (a, b) =>
            (a?.order ?? Number.MAX_SAFE_INTEGER) - (b?.order ?? Number.MAX_SAFE_INTEGER) ||
            (a?.parameter ?? '').localeCompare(b?.parameter ?? '')
        );

        const shortKey = [
          currentLocation,
          currentMethod,
          currentSampleName,
          currentInstrument
        ].join('|');
        const cacheResultDataTable = sessionStorage.getItem(shortKey);

        if (cacheResultDataTable) {
          try {
            const parsedCacheResultDataTable = JSON.parse(cacheResultDataTable);
            if (
              Array.isArray(parsedCacheResultDataTable) &&
              parsedCacheResultDataTable.length > 0
            ) {
              // Build lookup map once - O(n)
              const cachedByParam = new Map();
              parsedCacheResultDataTable.forEach((cached) => {
                if (cached.parameter) cachedByParam.set(cached.parameter, cached);
              });
              // map through sortedResultsData and update with any edited values from cache
              sortedResultsData.forEach((resultRow) => {
                const cachedRow = cachedByParam.get(resultRow.parameter);
                if (cachedRow) {
                  resultRow.result = cachedRow.result;
                  resultRow.notes = cachedRow.notes || '';
                  if (cachedRow.isEditedDatetime) {
                    resultRow.dateTime = cachedRow.dateTime;
                    resultRow.isEditedDatetime = true;
                  }
                  if (cachedRow.isEditedSampleId) {
                    resultRow.sampleId = cachedRow.sampleId;
                    resultRow.isEditedSampleId = true;
                  }
                }
              });
            }
          } catch (error) {
            console.error('Failed to parse cached results data:', error);
            sessionStorage.removeItem(shortKey); // Clean corrupted data
          }
        }
        setResultsDataTableData(sortedResultsData);
      }
    }
  }, [
    currentLocation,
    currentMethod,
    currentSampleName,
    currentInstrument,
    currentParameter,
    currentParameters,
    orderOfParameters
  ]);

  useEffect(() => {
    if (currentParameter && Array.isArray(methods) && methods.length > 0) {
      setUnit('');
      methods.forEach((item) => {
        if (item.parameter === currentParameter && item.method === currentMethod) {
          setUnit(item.units);
        }
      });
    }
  }, [currentParameter, methods]);

  const renderTimezoneOptions = () => {
    const optionsToReturn = [];
    timezones.forEach((timezone) => {
      optionsToReturn.push(<option value={timezone}>{timezone}</option>);
    });
    return optionsToReturn;
  };

  const renderTimesOptions = () => {
    const timesOptionsToReturn = [];
    currentModalAvailableTimes.forEach((time) => {
      timesOptionsToReturn.push(<option value={time.time}>{time.label}</option>);
    });
    return timesOptionsToReturn;
  };

  useEffect(() => {
    buildSummaryStatisticsDataSet();
  }, [setCurrentChartGroupConfigurations.chartSigDigits]);

  useEffect(() => {
    if (Array.isArray(results) && results.length > 0) {
      const updatedResults = [];
      results.forEach((updatedResultIn) => {
        const updatedResult = updatedResultIn;
        updatedResult.resultOmits7651 = updatedResult.resultOmits;
        updatedResult.resultOmits301 = updatedResult.resultOmits;
        updatedResult.resultOmits3026 = updatedResult.resultOmits;
        updatedResult.resultOmits330 = updatedResult.resultOmits;
        if (updatedResult.instrument !== '426') {
          delete updatedResult.resultOmits7651;
        }
        if (updatedResult.instrument !== '301') {
          delete updatedResult.resultOmits301;
        }
        if (updatedResult.instrument !== '3026') {
          delete updatedResult.resultOmits3026;
        }
        if (updatedResult.instrument !== '330') {
          delete updatedResult.resultOmits330;
        }
      });
      results = updatedResults;
    }
  }, [results]);

  const configurationData = [
    {
      id: 1,
      variable: 'Pre-treat data',
      value: currentControlStrategyConfigurations.pretreatData
    },
    {
      id: 2,
      variable: 'Control Strategy',
      value: currentControlStrategyConfigurations.controlStrategy
    },
    {
      id: 3,
      variable: 'Dynamically updated I-chart',
      value: currentControlStrategyConfigurations.duiChart
    },
    {
      id: 4,
      variable: 'Chart axis significant digits',
      value: currentControlStrategyConfigurations.chartSigDigits
    }
  ];

  const configurationTableColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      editable: false,
      flex: 2,
      sortable: false
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      flex: 1,
      sortable: false,
      type: 'singleSelect',
      valueOptions: (params) => {
        const yesNo = ['No', 'Yes'];
        const controlStrategy = ['EWMA', 'Run rules', 'Control limits', 'Tolerance limits'];
        const sigDigitOptions = [2, 3, 4, 5, 6, 7];
        switch (params.row.variable) {
          case 'Pre-treat data':
            return yesNo;
          case 'Control Strategy':
            return controlStrategy;
          case 'Dynamically updated I-chart':
            return yesNo;
          case 'Chart axis significant digits':
            return sigDigitOptions;
          default:
            return [];
        }
      }
    }
  ];

  const runData = async () => {
    try {
      setLoadingRunData(true);

      const invalidDateItems = filteredChartHits.filter(
        (cd) => !cd.dateTime || isNaN(new Date(cd.dateTime).getTime())
      );

      if (invalidDateItems.length > 0) {
        // eslint-disable-next-line no-alert
        const proceed = window.confirm(
          `Found ${invalidDateItems.length} record(s) with invalid dateTime.\n` +
            `Do you want to run without that data?`
        );
        if (!proceed) {
          setLoadingRunData(false);
          return;
        }
      }

      if (
        !currentLocation ||
        !currentMethod ||
        !currentInstrument ||
        !currentSampleName ||
        !currentParameter
      ) {
        alert('Need to select location, method, sample name, instrument, and parameter');
        return;
      }
      const runDataObject = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        sampleName: currentSampleName,
        parameter: currentParameter
      };

      await runDataFunction(runDataObject);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoadingRunData(false);
    }
  };
  const runCalculation = async () => {
    try {
      setLoadingRunCalculationPipeline(true);

      const requestData = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        sampleName: currentSampleName,
        parameter: currentParameter
      };

      const response = await runCalculationPipeline(requestData);

      const data = response?.data?.rows;
      const summary = response?.data?.summary;

      // Export data CSV
      if (Array.isArray(data) && data.length > 0) {
        const headers = Object.keys(data[0]);

        const csvHeader = headers.join(',');

        const csvRows = data.map((row) =>
          headers
            .map((key) => {
              const value = row[key];

              if (value === null || value === undefined) return '';

              const escaped = String(value).replace(/"/g, '""');

              return `"${escaped}"`;
            })
            .join(',')
        );

        const csvString = [csvHeader, ...csvRows].join('\n');

        const blob = new Blob([csvString], {
          type: 'text/csv;charset=utf-8;'
        });

        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.href = url;
        link.download = `|DATA|${currentParameter}|${moment().format(FORMAT_DATE_YYYYMMDD)}.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      }

      // Export summary CSV
      if (summary && typeof summary === 'object') {
        const summaryRows = Object.entries(summary).map(([key, value]) => {
          const escapedValue =
            value === null || value === undefined ? '' : String(value).replace(/"/g, '""');

          const escapedKey = String(key).replace(/"/g, '""');

          return `"${escapedValue}","${escapedKey}"`;
        });

        const summaryCsvString = summaryRows.join('\n');

        const summaryBlob = new Blob([summaryCsvString], {
          type: 'text/csv;charset=utf-8;'
        });

        const summaryLink = document.createElement('a');
        const summaryUrl = URL.createObjectURL(summaryBlob);

        summaryLink.href = summaryUrl;
        summaryLink.download = `|SUMMARY|${currentParameter}|${moment().format(
          FORMAT_DATE_YYYYMMDD
        )}.csv`;

        document.body.appendChild(summaryLink);
        summaryLink.click();
        document.body.removeChild(summaryLink);

        URL.revokeObjectURL(summaryUrl);
      }

      if ((!Array.isArray(data) || data.length === 0) && !summary) {
        alert('No data returned from calculation pipeline');
      }
    } catch (error) {
      console.error('Error running calculation pipeline:', error);
    } finally {
      setLoadingRunCalculationPipeline(false);
    }
  };
  const saveConfigurations = async () => {
    // Read before saving: the config subscription refreshes the ref as soon as the
    // write lands locally.
    const parametersToRerun = siblingParametersToRerun({
      savedInitialAssessment: savedInitialAssessmentRef.current,
      nextInitialAssessment: currentChartGroupConfigurations.initialAssessment,
      parameters: currentParameters,
      currentParameter
    });
    try {
      currentControlStrategyConfigurations.archive = archiveStatus;
      setChartLoading(true);
      await Promise.all([
        updateConfiguration(currentChartGroupConfigurations.id, currentChartGroupConfigurations),
        updateConfiguration(
          currentControlStrategyConfigurations.id,
          currentControlStrategyConfigurations
        )
      ]);
      const tenNinetyDateRequestObject = {
        startDate: moment(tenNinetyStartDate).tz(tz).format('M/D/YYYY'),
        endDate: moment(tenNinetyEndDate).tz(tz).format('M/D/YYYY')
      };
      if (
        tenNinetyDateRequestObject.startDate !== 'Invalid date' &&
        tenNinetyDateRequestObject.endDate !== 'Invalid date'
      ) {
        await updateTenNinetyDatesFunction(tenNinetyDateRequestObject);
      }

      if (currentControlStrategyConfigurations.archive === 'Yes') {
        const response = await archiveDataFunction({
          shortKey: currentShortKey,
          fullKey: currentFullKey,
          parameter: currentParameter,
          checkedCombinedInitialAssessment
        });
        const [
          archivedLocation,
          archivedMethod,
          archivedSampleName,
          archivedInstrument,
          archivedParameter
        ] = response.data[0].split('|');
        const runDataArchiveObject = {
          archivedLocation,
          archivedMethod,
          archivedInstrument,
          archivedSampleName,
          archivedParameter
        };
        await runArchiveDataFunction(runDataArchiveObject);
        setChartLoading(false);
        window.location.reload();
      } else {
        // eslint-disable-next-line no-lonely-if
        if (!currentLocation || !currentMethod || !currentInstrument || !currentSampleName) {
          // eslint-disable-next-line no-alert
          alert('Need to select location, method, sample name, and instrument');
        } else {
          const runDataObject = {
            location: currentLocation,
            method: currentMethod,
            instrument: currentInstrument,
            sampleName: currentSampleName,
            parameter: currentParameter
          };
          await runDataFunction(runDataObject);
          // A changed n applies to the whole chart group: re-run the sibling
          // parameters so their setupData stamps (Colonial) and calc catch up now.
          await runSequentially(
            parametersToRerun,
            (parameter) => runDataFunction({ ...runDataObject, parameter }),
            (parameter, error) => console.error(`runData failed for ${parameter}:`, error)
          );
          setChartLoading(false);
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      const runDataObject = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        sampleName: currentSampleName,
        parameter: currentParameter
      };
      await runDataFunction(runDataObject);
      setChartLoading(false);
    }
  };

  const [hasActiveEdits, setHasActiveEdits] = useState(false);

  const editData = () => {
    if (!currentLocation || !currentMethod || !currentInstrument || !currentSampleName) {
      // eslint-disable-next-line no-alert
      alert('Need to select location, method, sample name, and instrument');
    } else {
      const editedRows = rowsToUpdate.map((row) => {
        return {
          ...row,
          dateTime: moment(row.dateTime).toISOString()
        };
      });
      // we had a bug, found in BlueTide, where some values in this array
      // were causing the serialization of the object to be sent over the wire to fail with an NaN error
      // so we just send the ones in the table
      let columns;
      if (isNonUs) {
        columns = [
          { field: 'id' }, // need to add id to make sure id goes
          ...defaultColumnsEdit(currentPersonnelDropdown, dateTimeFormat, tz),
          ...defaultColumnsEditUsExtend(true)
        ];
      } else {
        columns = [
          { field: 'id' }, // need to add id to make sure id goes
          ...defaultColumnsEdit(currentPersonnelDropdown, dateTimeFormat, tz),
          ...defaultColumnsEditExtend(true)
        ];
      }
      const columnFields = columns.map((column) => column.field);

      for (let i = 0; i < editedRows.length; i++) {
        for (const key in editedRows[i]) {
          if (!columnFields.includes(key)) {
            delete editedRows[i][key];
          } else if (['---', 'N/A'].includes(editedRows[i][key])) {
            delete editedRows[i][key];
          }
        }
        if (editedRows[i].sampleId) {
          editedRows[i].sampleId = String(editedRows[i].sampleId).trim();
        }
      }

      const editDataObject = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        rows: editedRows
      };
      // firebase editData function
      editDataFunction(editDataObject).then(() => {
        //after update success clear data
        setRowsToUpdate([]);
        runData();
      });
    }
  };

  function saveEditModal() {
    editData();
    setShowEditModal(false);
  }

  const handleLockAllRows = (lockValue) => {
    // Create a copy of all rows with updated locked status
    const updatedRows = filteredChartHits.map((row) => ({
      ...row,
      locked: lockValue ? 'Y' : 'N'
    }));

    // Update rowsToUpdate with all rows
    const currentRowsToUpdate = [];
    updatedRows.forEach((row) => {
      currentRowsToUpdate.push(row);
    });

    setRowsToUpdate(currentRowsToUpdate);
    setFilteredChartHits(updatedRows);
  };

  const updateEditingMode = (hasEdits) => {
    // pass whether we are in editing mode to state
    setHasActiveEdits(hasEdits);
  };

  const returnLocationsAssigned = (locations, setupGroupsIn) => {
    const setupGroupsAssigned = [];
    const locationsAssigned = [];
    const locationsToReturn = [];
    setupGroupsIn.forEach((setupGroup) => {
      const matchingUser = setupGroup.personnel.find(
        (person) => person.email?.toLowerCase() === auth.user.email?.toLowerCase()
      );
      if (matchingUser) {
        setupGroupsAssigned.push(setupGroup);
      }
    });
    setupGroupsAssigned.forEach((assignedSetupGroup) => {
      assignedSetupGroup.locations.forEach((location) => {
        locationsAssigned.push(location.value);
      });
    });
    locations.forEach((location) => {
      const foundLocation = locationsAssigned.find(
        (assignedLocation) => assignedLocation === location.name
      );
      if (foundLocation) {
        locationsToReturn.push(location);
      }
    });
    return locationsToReturn;
  };

  const mapDropdownsFromIndex = (amendedLocations) => {
    const updatedLocations = [];
    let updatedMethods = [];
    let updatedSampleNames = [];
    let updatedInstruments = [];
    let updatedParameters = [];

    amendedLocations.forEach((location) => {
      updatedLocations.push(location);
      location.method?.forEach((method) => {
        updatedMethods.push(method);
        if (!instrumentBeforeSampleName) {
          method.sampleName?.forEach((listedSampleName) => {
            updatedSampleNames.push(listedSampleName);
            listedSampleName.instrument?.forEach((instrument) => {
              updatedInstruments.push(instrument);
              instrument.parameter?.forEach((parameter) => {
                updatedParameters.push(parameter);
              });
            });
          });
        } else {
          method.instrument?.forEach((listedInstrument) => {
            updatedInstruments.push(listedInstrument);
            listedInstrument.sampleName?.forEach((sampleName) => {
              updatedSampleNames.push(sampleName);
              sampleName.parameter?.forEach((parameter) => {
                updatedParameters.push(parameter);
              });
            });
          });
        }
      });
    });

    if (currentLocation) {
      const loc = updatedLocations.find((l) => l.name === currentLocation);
      if (loc) {
        const locMethods = [];
        const locSampleNames = [];
        const locInstruments = [];
        const locParameters = [];

        loc.method?.forEach((method) => {
          locMethods.push(method);
          if (!instrumentBeforeSampleName) {
            method.sampleName?.forEach((sn) => {
              locSampleNames.push(sn);
              sn.instrument?.forEach((inst) => {
                locInstruments.push(inst);
                inst.parameter?.forEach((p) => locParameters.push(p));
              });
            });
          } else {
            method.instrument?.forEach((inst) => {
              locInstruments.push(inst);
              inst.sampleName?.forEach((sn) => {
                locSampleNames.push(sn);
                sn.parameter?.forEach((p) => locParameters.push(p));
              });
            });
          }
        });

        updatedMethods = locMethods;
        updatedSampleNames = locSampleNames;
        updatedInstruments = locInstruments;
        updatedParameters = locParameters;
      } else {
        updatedMethods = [];
        updatedSampleNames = [];
        updatedInstruments = [];
        updatedParameters = [];
      }
    }
    if (currentMethod) {
      const methodObj = updatedMethods.find((m) => m.name === currentMethod);
      if (methodObj) {
        const methSampleNames = [];
        const methInstruments = [];
        const methParameters = [];

        if (!instrumentBeforeSampleName) {
          methodObj.sampleName?.forEach((sn) => {
            methSampleNames.push(sn);
            sn.instrument?.forEach((inst) => {
              methInstruments.push(inst);
              inst.parameter?.forEach((p) => methParameters.push(p));
            });
          });
        } else {
          methodObj.instrument?.forEach((inst) => {
            methInstruments.push(inst);
            inst.sampleName?.forEach((sn) => {
              methSampleNames.push(sn);
              sn.parameter?.forEach((p) => methParameters.push(p));
            });
          });
        }

        updatedSampleNames = methSampleNames;
        updatedInstruments = methInstruments;
        updatedParameters = methParameters;
      } else {
        updatedSampleNames = [];
        updatedInstruments = [];
        updatedParameters = [];
      }
    }

    if (currentSampleName) {
      const sampleObj = updatedSampleNames.find((s) => s.name === currentSampleName);
      if (sampleObj) {
        const sampInstruments = [];
        const sampParameters = [];

        if (!instrumentBeforeSampleName) {
          sampleObj.instrument?.forEach((inst) => {
            sampInstruments.push(inst);
            inst.parameter?.forEach((p) => sampParameters.push(p));
          });
        } else {
          sampleObj.parameter?.forEach((p) => sampParameters.push(p));
        }

        if (!instrumentBeforeSampleName) updatedInstruments = sampInstruments;
        updatedParameters = sampParameters;
      } else {
        if (!instrumentBeforeSampleName) updatedInstruments = [];
        updatedParameters = [];
      }
    }

    if (currentInstrument) {
      const instrumentObj = updatedInstruments.find((i) => i.name === currentInstrument);
      if (instrumentObj) {
        const instSampleNames = [];
        const instParameters = [];

        if (instrumentBeforeSampleName) {
          instrumentObj.sampleName?.forEach((sn) => {
            instSampleNames.push(sn);
            sn.parameter?.forEach((p) => instParameters.push(p));
          });
          updatedSampleNames = instSampleNames;
        } else {
          instrumentObj.parameter?.forEach((p) => instParameters.push(p));
        }

        updatedParameters = instParameters;
      } else {
        if (instrumentBeforeSampleName) updatedSampleNames = [];
        updatedParameters = [];
      }
    }

    setCurrentLocations(updatedLocations);
    setAllLocations(updatedLocations);
    setCurrentMethods(sortCountCurrentValues(updatedMethods));
    setCurrentSampleNames(sortCountCurrentValues(updatedSampleNames));
    setCurrentInstruments(sortCountCurrentValues(updatedInstruments));
    generateValueForParametersDynamic(sortCountCurrentValues(updatedParameters));
  };

  const generateLocationsForUser = (indexesIn, setupGroupsIn) => {
    const amendedLocations = returnLocationsAssigned(indexesIn[0].index, setupGroupsIn);
    mapDropdownsFromIndex(amendedLocations);
  };

  useEffect(() => {
    if (Array.isArray(currentIndexes) && currentIndexes.length > 0) {
      generateLocationsForUser(currentIndexes, currentSetupGroups);
    }
  }, [currentIndexes, currentSetupGroups]);

  useEffect(() => {
    if (Array.isArray(indexes) && indexes.length > 0 && !methodsUpdated) {
      const activeIndexes = indexes.filter((index) => !index.id.includes('Archive'));
      const archiveIndexes = indexes.filter((index) => index.id.includes('Archive'));
      setCurrentIndexes(radioArchiveValue === 'Active' ? activeIndexes : archiveIndexes);
      setCurrentActiveIndexes(activeIndexes);
      setCurrentArchiveIndexes(archiveIndexes);
    }
  }, [indexes, radioArchiveValue]);

  useEffect(() => {
    (async () => {
      const result = await getIndexValues();
      setIndexes(result.data);
    })();
  }, []);

  useEffect(() => {
    setInstrumentBeforeSampleName(
      (companyTypes && companyTypes[0] && companyTypes[0]['orderTypeInstrumentBefore']) || false
    );
  }, [companyTypes]);

  useEffect(() => {
    if (Array.isArray(samples) && samples.length > 0) {
      const currentSamplesToUpdate = currentSamples;
      samples.forEach((sample) => {
        const entryToAdd = {
          value: sample.id,
          label: sample.name
        };
        currentSamplesToUpdate.push(entryToAdd);
      });
      setCurrentSamples(currentSamplesToUpdate);
    }
  }, [currentSamples, samples]);

  useEffect(() => {
    const shortKeyComplete =
      currentLocation && currentMethod && currentSampleName && currentInstrument;
    if (
      Array.isArray(chartGroupConfigurations) &&
      chartGroupConfigurations.length > 0 &&
      shortKeyComplete
    ) {
      chartGroupConfigurations.forEach((configuration) => {
        if (configuration.type === 'Chart Group') {
          if (configuration.combinedInitialAssessment === 'Yes')
            setCheckedCombinedInitialAssessment(true);
          else if (
            configuration.combinedInitialAssessment === 'No' ||
            configuration.combinedInitialAssessment === undefined
          )
            setCheckedCombinedInitialAssessment(false);
          setCurrentChartGroupConfigurations(configuration);
        }
      });
    } else if (Array.isArray(chartGroupConfigurations) && chartGroupConfigurations.length === 0) {
      defaultChartGroupConfigurations.shortKey = currentShortKey;
      createConfiguration(defaultChartGroupConfigurations);
    }
  }, [chartGroupConfigurations, currentShortKey, currentChartGroupConfigurations]);
  // One default-config creator per page instance: concurrent / repeated effect
  // runs for the same fullKey create at most one default (see the util).
  const ensureDefaultControlStrategyConfigRef = useRef(null);
  if (!ensureDefaultControlStrategyConfigRef.current) {
    ensureDefaultControlStrategyConfigRef.current = createDefaultControlStrategyConfigEnsurer({
      doesDataExist: (fullKey) => doesDataExistForFullKey(fullKey),
      fetchConfigs: (fullKey) => getControlStrategyConfigurationByFullKey(fullKey),
      create: (data) => createConfiguration(data)
    });
  }

  useEffect(() => {
    if (Array.isArray(controlStrategyConfigurations) && controlStrategyConfigurations.length > 0) {
      // Duplicates for one fullKey: show/edit the most recently updated doc — the
      // same rule the calculation uses (functions/calculations/configSelection.js).
      const updatedCurrentControlStrategyConfigurations = pickLatestControlStrategyConfig(
        controlStrategyConfigurations
      );

      setCurrentControlStrategyConfigurations(updatedCurrentControlStrategyConfigurations);
      setControlStrategyData(
        generateControlStrategyData(updatedCurrentControlStrategyConfigurations)
      );
    }

    if (
      Array.isArray(controlStrategyConfigurations) &&
      controlStrategyConfigurations.length === 0 &&
      currentFullKey &&
      !archiveRegex.test(currentFullKey)
    ) {
      ensureDefaultControlStrategyConfigRef
        .current(currentFullKey, defaultControlStrategyConfigurations)
        .catch((error) => console.error('Failed to create default Control Strategy config', error));
    }
    queryClient.invalidateQueries([
      'batchControlStrategies',
      currentControlStrategyConfigurations?.fullKey
    ]);
  }, [controlStrategyConfigurations, currentFullKey, currentSummary]);

  useEffect(() => {
    setArchiveData([
      {
        id: randomId(),
        variable: 'Archive',
        value: currentControlStrategyConfigurations.archive
      }
    ]);

    setControlStatusData([
      {
        id: randomId(),
        variable: 'Control Status',
        value: currentControlStrategyConfigurations.controlStatus ?? 'Yes'
      }
    ]);
  }, [currentControlStrategyConfigurations]);

  function generateNValue(fromItems) {
    const myCurrentParameters = uniq(fromItems.map((i) => i.parameter)).sort();
    const newParametersArray = myCurrentParameters.map((param) => {
      let currentSetupDataCount = 0;
      fromItems.filter((i) => {
        if (i.parameter === param && String(i.setupData) === '1') {
          currentSetupDataCount += 1;
        }
        return true;
      });
      return currentSetupDataCount;
    });

    setCurrentNValue(newParametersArray[0]);
  }
  useEffect(() => {
    if (Array.isArray(shortKeyItems) && shortKeyItems.length > 0) {
      if (isNonUs) {
        const sortedParameters = artecoCustomParameterSort(
          uniq(
            shortKeyItems
              .filter((item) => item.parameter !== defaultCombinedParameterName)
              .map((i) => i.parameter)
          ).sort()
        );
        setCurrentParameters(sortedParameters);
      } else {
        setCurrentParameters(
          uniq(
            shortKeyItems
              .filter((item) => item.parameter !== defaultCombinedParameterName)
              .map((i) => i.parameter)
          ).sort()
        );
      }
      generateNValue(shortKeyItems);
      const timeZone = tz || 'UTC';
      // check for ooc and add _r to sample ID
      setFilteredShortKeyData(
        shortKeyItems
          .map((cd, index) => {
            const wFlags = wFlagColumns.map((f) => cd[f]).filter(isValidFlag);
            const oocFlags = oocFlagColumns.map((f) => cd[f]).filter(isValidFlag);
            const row = {
              index,
              flags: `${wFlags.length > 0 ? `Warnings: ${wFlags.join(', ')}` : ''}${
                wFlags.length > 0 && oocFlags.length > 0 ? '; ' : ''
              }${oocFlags.length > 0 ? `OOC: ${oocFlags.join(', ')}` : ''}`
            };

            // eslint-disable-next-line no-restricted-syntax
            for (const elt of Object.keys(cd)) {
              if (['date'].includes(elt)) {
                row[elt] = cd[elt];
              } else if (['objectID'].includes(elt)) {
                row[elt] = cd[elt];
              } else if (
                String(cd[elt]).match(/[A-Z]/i) ||
                ['instrument', 'parameter', 'location', 'sampleName', 'method'].includes(elt)
              ) {
                row[elt] = cd[elt];
              } else if (!Number.isNaN(parseFloat(cd[elt]))) {
                row[elt] = Number(cd[elt]); // 3 decimal places max
              } else {
                row[elt] = cd[elt];
              }
            }
            if (row.dateTime) {
              if (typeof row.dateTime !== 'string') {
                row.dateTime = 'Invalid date';
              } else {
                const theDate = new Date(row.dateTime);
                if (isNaN(theDate.getTime())) {
                  row.dateTime = 'Invalid date';
                } else {
                  row.date = formatInTimeZone(theDate, timeZone, 'M/d/yyyy');
                  row.time = formatInTimeZone(theDate, timeZone, 'h:mm aaa');
                }
              }
            }
            return row;
          })
          .sort((a, b) => {
            const aTime = new Date(a.dateTime).getTime();
            const bTime = new Date(b.dateTime).getTime();
            if (isNaN(aTime)) return 1;
            if (isNaN(bTime)) return -1;
            return aTime - bTime;
          })
      );
    }
  }, [shortKeyItems, companyTypes, currentParameter]);

  useEffect(() => {
    if (Array.isArray(shortKeyItems) && shortKeyItems.length > 0) {
      const parameters = uniq(
        shortKeyItems
          .filter((item) => item.parameter !== defaultCombinedParameterName)
          .map((i) => i.parameter)
      ).sort();

      if (isNonUs) {
        setCurrentParameters(artecoCustomParameterSort(parameters));
      } else {
        setCurrentParameters(parameters);
      }
    }
  }, [shortKeyItems, isNonUs, currentParameter]);
  useEffect(() => {
    if (Array.isArray(items) && items.length > 0) {
      setChartHits(items);
      setChartHitCount(items?.length || 0);
    } else {
      setChartHits([]);
    }
  }, [items]);

  useEffect(() => {
    if (!currentParameter) {
      setChartHits([]);
      setChartData([]);
      setLocalSearchFinished(false);
      setIsSelectCombinedZScore(false);
    }
  }, [currentParameter]);

  useEffect(() => {
    if (Array.isArray(personnel) && personnel.length > 0) {
      const matchingUser = personnel.find((person) => person.email === auth.user.email);
      if (matchingUser && auth?.permissionData) {
        setPermission(matchingUser.permission);
        setPermissionData(auth.permissionData[matchingUser.permission]);
      }
      setCurrentPersonnel(personnel);
      const personnelDropdown = personnel.map((person) => {
        const personToReturn = {
          id: person.id,
          value: config.useAbbreviationPersonnelName
            ? person.abbreviation || person.name
            : person.name,
          label: config.useAbbreviationPersonnelName
            ? person.abbreviation || person.name
            : person.name
        };

        return personToReturn;
      });
      setCurrentPersonnelDropdown(personnelDropdown);
    }
  }, [personnel]);

  const renderButton = (buttonText, currentFunction, table, rule, hasLoading, isLoading) => {
    if (currentControlStrategyConfigurations.archive !== 'Yes') {
      return renderButtonWithPermissions(
        buttonText,
        currentFunction,
        table,
        rule,
        permissionData,
        hasLoading,
        isLoading
      );
    }
  };
  const hasSingleParameter = Array.isArray(allParams) && allParams.length === 1;

  useEffect(() => {
    if (Array.isArray(assessments)) {
      if (radioArchiveValue === 'Active') {
        assessments = assessments.filter(
          (assessment) => !Object.prototype.hasOwnProperty.call(assessment, 'archive')
        );
      } else if (radioArchiveValue === 'Archive') {
        assessments = assessments.filter(
          (assessment) =>
            Object.prototype.hasOwnProperty.call(assessment, 'archive') &&
            (assessment.archive === true || assessment.archive === 'Yes')
        );
      }
      for (const assessment of assessments) {
        if (assessment.createdAt) {
          assessment.created = assessment.createdAt.toDate().toDateString();
        }
      }

      const initialAssessmentOutcomePassByFullKey = assessments.find(
        (assessment) =>
          assessment.type === 'Initial' &&
          assessment.outcome === 'Pass' &&
          assessment?.fullKey === currentFullKey
      );
      // Two-part trigger: total non-omitted points reach n AND >= 20 of them are
      // setupData=1 (util/initialAssessmentStage).
      const pendingInitialStage = preInitialAssessmentStage({
        totalCount: currentIncludedPointCount,
        setupOneCount: currentSetupDataOne,
        initialAssessment: currentChartGroupConfigurations.initialAssessment
      });

      // check existing assessments in DB
      // if zero exist, check configuration (initial assessment n value) and then compare current n value to see if initial assessment due
      if (
        assessments.length === 0 &&
        (checkedCombinedInitialAssessment || !initialAssessmentOutcomePassByFullKey)
      ) {
        // check configuration value in DB for n value of when initial assessment needs to be completed.

        if (pendingInitialStage === 'Needs Initial Assessment') {
          setChartStage('Needs Initial Assessment');
          setChartButtonText('Perform Initial Assessment');
        } else {
          // chart stage in development
          setChartStage('In Development');
        }
      } else if (assessments.length > 0) {
        // check for initial assessment with outcome of pass
        const periodicAssessmentConfigValue = parseInt(
          currentChartGroupConfigurations.ongoingAssessment,
          10
        );
        const initialAssessmentOutcomePass = assessments.find(
          (assessment) =>
            assessment.type === 'Initial' &&
            assessment.outcome === 'Pass' &&
            assessment?.fullKey === undefined
        );
        const combineInitial = checkedCombinedInitialAssessment;

        const initialAssessment = hasSingleParameter
          ? initialAssessmentOutcomePass || initialAssessmentOutcomePassByFullKey
          : combineInitial
            ? initialAssessmentOutcomePass
            : initialAssessmentOutcomePassByFullKey;
        if (initialAssessment) {
          if (currentSetupDataZero >= periodicAssessmentConfigValue) {
            // first periodic assessment due
            setChartStage('Needs Periodic Assessment');
            setChartButtonText('Perform Periodic Assessment');
            const periodicAssessments = assessments.filter(
              (assessment) =>
                assessment.type === 'Periodic' && assessment.fullKey === currentFullKey
            );
            if (periodicAssessments.length > 0) {
              periodicAssessments.sort((x, y) => x.createdAt - y.createdAt);
              const mostRecentPeriodicAssessment =
                periodicAssessments[periodicAssessments.length - 1];
              if (mostRecentPeriodicAssessment.outcome === 'Pass') {
                if (
                  currentSetupDataOne + currentSetupDataZero - mostRecentPeriodicAssessment.n <
                  periodicAssessmentConfigValue
                ) {
                  // most recent periodic assessment complete and passed, but not ready for next periodic assessment yet;
                  setChartStage('Active');
                  setChartButtonText('View Completed Assessment');
                } else if (
                  currentSetupDataOne + currentSetupDataZero - mostRecentPeriodicAssessment.n >=
                  periodicAssessmentConfigValue
                ) {
                  // periodic assessment due
                  setChartStage('Needs Periodic Assessment');
                  setChartButtonText('Perform Periodic Assessment');
                }
              } else {
                // periodic assessment stil due - no pass on most recent periodic assessment outcome
                setChartStage('Needs Periodic Assessment');
                setChartButtonText('Perform Periodic Assessment');
              }
            } else {
              // periodic assessment due
              setChartStage('Needs Periodic Assessment');
              setChartButtonText('Perform Periodic Assessment');
            }
          } else {
            // initial assessment complete, but not ready for periodic assessment yet;
            setChartStage('Active');
            setChartButtonText('View Completed Assessment');
          }
        } else {
          if (pendingInitialStage === 'Needs Initial Assessment') {
            // initial assessment still due - no pass on initial assessment outcome
            setChartStage('Needs Initial Assessment');
            setChartButtonText('Perform Initial Assessment');
          } else {
            // initial assessment still due, but not ready yet
            setChartStage('In Development');
          }
        }
      }
      assessments.sort((x, y) => x.createdAt - y.createdAt);
      setCurrentAssessments(assessments);
      if (assessments.length > 0) {
        setChartAssessed(true);
      } else {
        setChartAssessed(false);
      }
      if (Array.isArray(currentResultsData) && currentResultsData.length > 0) {
        const updatedCurrentResultsData = currentResultsData;
        for (const result of updatedCurrentResultsData) {
          result.setupData = '0';
        }
        setCurrentResultsData(updatedCurrentResultsData);
      }
    }
  }, [
    assessments,
    currentChartGroupConfigurations,
    currentSetupDataOne,
    currentSetupDataZero,
    currentIncludedPointCount
  ]);

  const initializedKeys = useRef(new Set());

  const fetchingRef = useRef(false);

  const oversizedAssessmentsDeps = useMemo(
    () =>
      currentAssessments
        .filter(
          (a) =>
            (a.oversized === true || a.oversized === 'true') &&
            a.storagePath &&
            !a._oversizedFetched
        )
        .map((a) => a.id || a.fullKey || a.shortKey),
    [currentAssessments]
  );

  useEffect(() => {
    const fetchOversizedData = async () => {
      if (fetchingRef.current) return;
      fetchingRef.current = true;

      try {
        const updatedAssessments = await Promise.all(
          currentAssessments.map(async (assessment) => {
            if (assessment._oversizedFetched) return assessment;

            if (
              (assessment.oversized === true || assessment.oversized === 'true') &&
              assessment.storagePath
            ) {
              try {
                const fetchedData = await fetchOversizedAssessmentData(assessment.storagePath);

                if (!fetchedData || Object.keys(fetchedData).length === 0) {
                  console.warn('No data returned from oversized file for', assessment.shortKey);
                  return { ...assessment, _oversizedFetched: true };
                }

                return { ...assessment, ...fetchedData, _oversizedFetched: true };
              } catch (error) {
                console.error('Failed to fetch oversized data for', assessment.fullKey, error);
                return {
                  ...assessment,
                  _oversizedFetched: true,
                  _fetchError: error.message
                };
              }
            }

            return assessment;
          })
        );

        setCurrentAssessments((prev) => {
          const changed =
            JSON.stringify(prev.map((a) => a._oversizedFetched)) !==
            JSON.stringify(updatedAssessments.map((a) => a._oversizedFetched));
          return changed ? updatedAssessments : prev;
        });
      } finally {
        fetchingRef.current = false;
      }
    };

    const hasOversized = currentAssessments.some(
      (a) =>
        (a.oversized === true || a.oversized === 'true') && a.storagePath && !a._oversizedFetched
    );

    if (hasOversized) {
      fetchOversizedData();
    }
  }, [oversizedAssessmentsDeps]);

  async function saveChartAssessment() {
    setShowModal(false);
    setShowPeriodicModal(false);
    const assessmentToSave = { ...modalAssessment };

    if (assessmentToSave.type === 'Initial') {
      let hasPassedInitial = false;
      if (checkedCombinedInitialAssessment) {
        // Check for any Initial assessment with outcome Pass for the shortKey
        hasPassedInitial =
          Array.isArray(currentAssessments) &&
          currentAssessments.some(
            (a) => a.type === 'Initial' && a.outcome === 'Pass' && a.shortKey === currentShortKey
          );
      } else {
        // Check for Initial assessment with outcome Pass for the specific fullKey
        hasPassedInitial =
          Array.isArray(currentAssessments) &&
          currentAssessments.some(
            (a) => a.type === 'Initial' && a.outcome === 'Pass' && a.fullKey === currentFullKey
          );
      }
      if (hasPassedInitial) {
        return;
      }
    }

    setChartAssessed(true);
    setChartLoading(true);
    try {
      // Pool BEFORE persisting the assessment: pooling only changes
      // setupData/locked (the assessment statistics are already computed), and
      // if it throws we must not leave behind an assessment record that claims
      // the data was pooled when it wasn't (fuelsqcv2-dif).
      if (assessmentToSave.type === 'Periodic' && assessmentToSave.pool === 'true') {
        await poolData();
      }

      if (checkedCombinedInitialAssessment) {
        if (assessmentToSave.type === 'Initial') {
          assessmentToSave.summaryStatistics = summaryStatisticsAssessmentData;
        } else if (assessmentToSave.type === 'Periodic') {
          assessmentToSave.summaryStatistics = summaryStatisticsDataPeriodic;
        }

        await createAssessment(assessmentToSave);
      } else {
        if (assessmentToSave.type === 'Initial') {
          // --- Create assessment for the current parameter (fullKey) ---

          const fullKey = `${currentShortKey}|${currentParameter}`;

          const paramCleaned = firebaseClean(currentParameter);
          const existingSummary =
            currentAssessments?.find((a) => a.shortKey === currentShortKey)?.summaryStatistics ||
            [];

          const mergedSummary = mergeSummaryStatistics(
            existingSummary,
            summaryStatisticsAssessmentData,
            paramCleaned
          );

          const paramAssessment = {
            ...modalAssessment,
            summaryStatistics: mergedSummary
          };
          await createAssessmentByFullKey(currentShortKey, fullKey, paramAssessment);
        } else if (assessmentToSave.type === 'Periodic') {
          assessmentToSave.summaryStatistics = summaryStatisticsDataPeriodic;
          await createAssessment(assessmentToSave);
        }
      }

      const updatedCurrentSummary = currentSummary;
      updatedCurrentSummary.assessed = true;
      updateSummary(currentFullKey, updatedCurrentSummary);

      if (assessmentToSave.type === 'Periodic') {
        if (assessmentToSave.archive === 'Yes') {
          const response = await periodicAssessmentArchiveDataFunction({
            shortKey: currentShortKey,
            fullKey: currentFullKey,
            inputParameter: currentParameter,
            checkedCombinedInitialAssessment
          });
          const [location, method, sampleName, instrument, parameter] = response.data[1].split('|');
          const runDataObject = { location, method, instrument, sampleName, parameter };
          const [
            archivedLocation,
            archivedMethod,
            archivedSampleName,
            archivedInstrument,
            archivedParameter
          ] = response.data[0].split('|');
          const runDataArchiveObject = {
            archivedLocation,
            archivedMethod,
            archivedInstrument,
            archivedSampleName,
            archivedParameter
          };
          await runDataFunction(runDataObject);
          await runArchiveDataFunction(runDataArchiveObject).then(() => {
            window.location.reload();
          });
        }
      }
    } catch (err) {
      console.error('Failed to save assessment:', err);
      Sentry.captureException(err);
      const reason = err?.message ? `\n\nReason: ${err.message}` : '';
      alert(`Failed to save assessment. Please try again.${reason}`);
    } finally {
      setChartLoading(false);
    }
  }

  const assignedSamplesData = [
    {
      id: randomId(),
      sample: 'None'
    },
    {
      id: randomId(),
      sample: 'None'
    },
    {
      id: randomId(),
      sample: 'None'
    }
  ];

  const archiveColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      sortable: false,
      editable: false,
      flex: 2
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      sortable: false,
      flex: 1,
      type: 'singleSelect',
      valueOptions: () => ['No', 'Yes']
    }
  ];

  const controlStatusColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      sortable: false,
      editable: false,
      flex: 2
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      sortable: false,
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['No', 'Yes']
    }
  ];

  const deleteAllDataColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      sortable: false,
      editable: false,
      flex: 2
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      sortable: false,
      flex: 1,
      type: 'singleSelect',
      valueOptions: () => ['No', 'Yes']
    }
  ];

  const renderAssessmentTableHeader = (tableData) => {
    const columnHeaders = [
      {
        field: 'statistic',
        headerName: 'Statistic',
        flex: 1,
        sortable: false
      }
    ];
    tableData.forEach((result) => {
      if (!result.parameter) {
        return;
      }
      const fieldName =
        radioArchiveValue === radioDataType.ARCHIVE
          ? result.parameter.split('_')[0]
          : result.parameter;
      const columnToPush = {
        field: firebaseClean(fieldName),
        headerName: result.parameter,
        flex: 1,
        sortable: false
      };
      columnHeaders.push(columnToPush);
    });
    return columnHeaders;
  };
  const summaryStatisticsAssessmentColumns = renderAssessmentTableHeader(resultsDataTableData);

  const summaryStatisticsColumns = [
    {
      field: 'statistic',
      headerName: 'Statistic',
      flex: 2,
      sortable: false
    },
    {
      field: 'value',
      headerName: currentParameter || '',
      flex: 1,
      sortable: false
    }
  ];

  const summaryStatisticsPreview = [
    {
      id: randomId(),
      statistic: 'Average',
      value: currentSummary ? renderSigDigits(currentSummary.avg_or) : ''
    },
    {
      id: randomId(),
      statistic: 'Standard Deviation, RMS',
      value: currentSummary ? renderSigDigits(currentSummary.sd_rms_or) : ''
    },
    {
      id: randomId(),
      statistic: '% RSD',
      value: currentSummary ? renderSigDigits(currentSummary.percent_rsd) : ''
    },
    {
      id: randomId(),
      statistic: 'Standard Deviation, MR',
      value: currentSummary ? renderSigDigits(currentSummary.sd_mr_or) : ''
    },
    {
      id: randomId(),
      statistic: 'Repeatability (r)',
      value: currentSummary ? renderSigDigits(currentSummary.repeat_or) : ''
    },
    {
      id: randomId(),
      statistic: 'Upper Control Limit',
      value: currentSummary ? renderSigDigits(currentSummary.ucl_sd) : ''
    },
    { id: randomId(), statistic: 'n', value: currentSummary ? Number(currentSummary.n_or) : '' }
  ];

  const summaryStatisticsPreviewTwo = [
    {
      id: randomId(),
      statistic: 'Reproducibility (R)',
      value: currentSummary ? renderSigDigits(currentSummary.repro_or) : ''
    },
    {
      id: randomId(),
      statistic: 'Precision Ratio',
      value: currentSummary ? renderSigDigits(currentSummary.pr_or) : ''
    },
    {
      id: randomId(),
      statistic: 'TPI',
      value: currentSummary ? renderSigDigits(currentSummary.tpi_or) : ''
    },
    {
      id: randomId(),
      // Both shown; normality is evaluated from the RMS value only.
      statistic: 'Anderson Darling (RMS / MR)',
      value: currentSummary
        ? formatAdPair(currentSummary.ad_rms_or, currentSummary.ad_mr_or, renderSigDigits)
        : ''
    },
    {
      id: randomId(),
      statistic: 'Lower Control Limit',
      value: currentSummary ? renderSigDigits(currentSummary.lcl_sd) : ''
    },
    {
      id: randomId(),
      statistic: 'Site Precision (R’)',
      value: currentSummary ? renderSigDigits(currentSummary.sd_rms_or * 2.77) : ''
    }
  ];

  const handleDeleteSchedule = (row) => {
    deleteSampleSchedule(row.id);
  };

  const handleEditSchedule = (scheduleIn) => {
    const schedule = scheduleIn;
    if (schedule.startingDate.seconds) {
      schedule.startingDate = new Date(
        schedule.startingDate.seconds * 1000 + schedule.startingDate.nanoseconds / 1000000
      );
    }
    setCurrentModalSchedule(schedule);
    setCurrentModalAvailableTimes([...sampleScheduleTimes]);
    setScheduleModalType('Edit');
    setShowScheduleModal(true);
  };

  const handleDeleteRegularEntry = (row) => {
    deleteRegularSampleEntry(row.id);
  };

  const handleEditRegularEntry = (entryIn) => {
    const entry = { ...entryIn };
    if (entry.startDate?.seconds !== undefined) {
      entry.startDate = new Date(
        entry.startDate.seconds * 1000 + entry.startDate.nanoseconds / 1000000
      );
    }
    setCurrentModalRegularEntry(entry);
    setRegularEntryModalType('Edit');
    setShowRegularEntryModal(true);
  };

  const regularSampleEntryColumns = (readOnly) => {
    const base = [
      {
        field: 'startingDateDisplayed',
        headerName: 'Start Date',
        editable: false,
        flex: 2,
        sortable: false
      },
      {
        field: 'periodDays',
        headerName: 'Period (days)',
        editable: false,
        flex: 1,
        sortable: false
      }
    ];
    if (!readOnly) {
      base.push({
        field: 'edit',
        headerName: '',
        sortable: false,
        width: 40,
        renderCell: (params) => {
          return (
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              color="inherit"
              onClick={() => handleEditRegularEntry(params.row)}
            />
          );
        }
      });
      base.push({
        field: 'delete',
        headerName: '',
        sortable: false,
        width: 40,
        editable: () => {
          return false;
        },
        renderCell: (params) => {
          return (
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              color="inherit"
              onClick={() => handleDeleteRegularEntry(params.row)}
            />
          );
        }
      });
    }
    return base;
  };

  const sampleScheduleColumnsNew = (readOnly) => {
    const base = [
      {
        field: 'description',
        headerName: 'Description',
        editable: false,
        flex: 2,
        sortable: false
      },
      {
        field: 'frequency',
        headerName: 'Frequency',
        editable: false,
        sortable: false
      },
      {
        field: 'time',
        headerName: 'Time',
        editable: false,
        sortable: false
      },
      {
        field: 'startingDateDisplayed',
        headerName: 'Starting Date',
        editable: false,
        flex: 2,
        sortable: false
      },
      {
        field: 'timezone',
        headerName: 'Timezone',
        editable: false,
        sortable: false,
        flex: 1
      }
    ];
    if (!readOnly) {
      base.push({
        field: 'edit',
        headerName: '',
        sortable: false,
        width: 40,
        renderCell: (params) => {
          return (
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              color="inherit"
              onClick={() => handleEditSchedule(params.row)}
            />
          );
        }
      });
      base.push({
        field: 'delete',
        headerName: '',
        sortable: false,
        width: 40,
        editable: () => {
          return false;
        },
        renderCell: (params) => {
          return (
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              color="inherit"
              onClick={() => handleDeleteSchedule(params.row)}
            />
          );
        }
      });
    }
    return base;
  };

  const parameterSecondaryDataColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      editable: false,
      flex: 2,
      sortable: false
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      flex: 3,
      sortable: false
    }
  ];

  const methodSecondaryDataColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      editable: false,
      sortable: false,
      flex: 4
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      sortable: false,
      flex: 1,
      type: 'singleSelect',
      valueOptions: (params) => {
        const sqcDropdown = ['SQC', 'Accuracy', 'CRM'];
        const yesNo = ['No', 'Yes'];
        const tenNinetyMaterial = [
          'N/A',
          'ULSD',
          '500 ppm LM diesel fuel',
          'ECA Marine fuel',
          'Butane',
          'Gasoline'
        ];
        switch (params.row.variable) {
          case 'Sample Type':
            return sqcDropdown;
          case '1090 Material':
            return tenNinetyMaterial;
          case '1090 Parameter':
            // Only the parameters the 1090 reference table defines for the selected
            // material (Gasoline: Sulfur/Benzene/Oxygenates/RVP; others: Sulfur).
            return getTenNinetyParameterOptions(
              currentControlStrategyConfigurations.tenNinetyMaterial
            );
          default:
            return yesNo;
        }
      }
    }
  ];

  const [controlStrategyData, setControlStrategyData] = useState(
    generateControlStrategyData(currentControlStrategyConfigurations)
  );

  const bottomTPIData = [
    {
      id: randomId(),
      variable: 'Suppress TPI notifications',
      value: currentControlStrategyConfigurations.suppressTPI
    },
    {
      id: randomId(),
      variable: 'Suppress Anderson Darling Notifications',
      value: currentControlStrategyConfigurations.suppressNormality
    }
  ];

  const methodSpecificData = [
    {
      id: randomId(),
      variable: 'Initial Assessment, samples (n)',
      value: currentChartGroupConfigurations.initialAssessment
    },
    {
      id: randomId(),
      variable: 'Ongoing assessment, samples (n)',
      value: currentChartGroupConfigurations.ongoingAssessment
    },
    {
      id: randomId(),
      variable: 'Ongoing assessment, days',
      value: currentChartGroupConfigurations.ongoingAssessmentDays
    }
  ];

  const parameterSecondaryData = [
    {
      id: randomId(),
      variable: 'Mean',
      value: currentControlStrategyConfigurations?.mean
    },
    {
      id: randomId(),
      variable: 'Standard Deviation',
      value: currentControlStrategyConfigurations.standardDeviation
    },
    {
      id: randomId(),
      variable: 'n',
      value: currentControlStrategyConfigurations.n
    },
    {
      id: randomId(),
      variable: 'Reproducibility',
      value: currentControlStrategyConfigurations.reproducibility
    },
    {
      id: randomId(),
      variable: 'Repeatability',
      value: currentControlStrategyConfigurations.repeatability
    },
    {
      id: randomId(),
      variable: 'EWMA Lambda',
      value: currentControlStrategyConfigurations.ewmaLambda
    },
    {
      id: randomId(),
      variable: 't alpha',
      value: currentControlStrategyConfigurations.tAlpha
    },
    {
      id: randomId(),
      variable: 'f alpha',
      value: currentControlStrategyConfigurations.fAlpha
    }
  ];

  const bottomTPIColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      sortable: false,
      editable: false,
      flex: 4
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      sortable: false,
      flex: 1,
      type: 'singleSelect',
      valueOptions: () => ['Yes', 'No']
    }
  ];

  const controlStrategyConfigurationColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      editable: false,
      sortable: false,
      flex: 4
    },
    {
      field: 'value',
      headerName: 'Value',
      sortable: false,
      editable: editable,
      flex: 1,
      type: 'singleSelect',
      valueOptions: () => ['Off', 'Warning', 'Out of Control']
    }
  ];

  function alphaNumericSorter(a, b) {
    return String(a.name).localeCompare(String(b.name), undefined, { numeric: true });
  }

  const renderOptionsDynamic = (dropdownOptions) => {
    const rows = [];
    dropdownOptions.sort(alphaNumericSorter);
    dropdownOptions.forEach((option) => {
      let description = `${option.name}`;
      if (option.count) {
        description = `${description} (${option.count})`;
      }
      rows.push(<option value={option.name}>{description}</option>);
    });
    return rows;
  };

  // Location dropdown options. When the "Hide Region/Area" org toggle is on we
  // display only the laboratory portion of each location, but the option's value
  // stays the full "Region - Area - Laboratory" string used to key the data.
  const renderLocationOptions = (dropdownOptions) => {
    const rows = [];
    // Sort by the visible label so the list stays alphabetical even when the
    // toggle hides region/area (otherwise labs would sort by their hidden region).
    const sortedOptions = [...dropdownOptions].sort((a, b) =>
      compareLocationOptions(a, b, isHideRegionArea)
    );
    sortedOptions.forEach((option) => {
      rows.push(
        <option value={option.name}>{formatLocationOptionLabel(option, isHideRegionArea)}</option>
      );
    });
    return rows;
  };

  const renderOptionsDynamicParameter = (dropdownOptions) => {
    const rows = [];
    let combineOption;
    dropdownOptions.sort(alphaNumericSorter).sort((a, b) => a.order - b.order);
    dropdownOptions.forEach((option) => {
      let description = `${option.name}`;
      if (option.count) {
        description = `${description} (${option.count})`;
      }
      if (option.name !== defaultCombinedParameterName) {
        rows.push(<option value={option.name}>{description}</option>);
      } else {
        combineOption = <option value={option.name}>{description}</option>;
      }
    });
    if (combineOption) {
      rows.push(combineOption);
    }
    return rows;
  };

  const assignedSamplesTableColumns = (editable = true) => [
    {
      field: 'sample',
      headerName: 'Sample',
      type: 'singleSelect',
      flex: 1,
      editable: editable,
      sortable: false,
      getOptionValue: (value) => value.value,
      getOptionLabel: (value) => value.label,
      valueOptions: currentSamples
    }
  ];

  const methodSpecificColumns = (editable = true) => [
    {
      field: 'variable',
      headerName: 'Variable',
      editable: false,
      sortable: false,
      flex: 4
    },
    {
      field: 'value',
      headerName: 'Value',
      editable: editable,
      sortable: false,
      flex: 1
    }
  ];

  const handleAddSchedule = () => {
    setCurrentModalSchedule({
      description: '',
      frequency: 'None',
      time: currentModalAvailableTimes[0]?.time || '12:00 AM',
      startingDate: startDate,
      timezone: moment.tz.guess(),
      fullKey: currentFullKey,
      shortKey: currentShortKey,
      parameters: currentParameters
    });
    setScheduleModalType('Add');
    setCurrentModalAvailableTimes([...sampleScheduleTimes]);
    setShowScheduleModal(true);
  };

  const handleAddRegularEntry = () => {
    const [location, method, sampleName, instrument] = String(currentShortKey || '').split('|');
    setCurrentModalRegularEntry({
      startDate,
      startingDateDisplayed: moment(startDate).format('MM/DD/YYYY'),
      periodDays: 7,
      location,
      method,
      sampleName,
      instrument,
      shortKey: currentShortKey,
      parameters: currentParameters
    });
    setRegularEntryModalType('Add');
    setShowRegularEntryModal(true);
  };

  const handleRegularStartDateChange = (date) => {
    const startingDateDisplayed = moment(date).format('MM/DD/YYYY') || '';
    setCurrentModalRegularEntry({
      ...currentModalRegularEntry,
      startDate: date,
      startingDateDisplayed
    });
  };

  const handleRegularPeriodChange = (e) => {
    const periodDays = parseInt(e.target.value, 10);
    setCurrentModalRegularEntry({
      ...currentModalRegularEntry,
      periodDays: Number.isNaN(periodDays) ? '' : periodDays
    });
  };

  const handleSaveRegularEntry = () => {
    const period = Number(currentModalRegularEntry.periodDays);
    if (!Number.isInteger(period) || period <= 0) {
      // eslint-disable-next-line no-alert
      window.alert('Please enter a period of at least 1 day.');
      return;
    }
    const payload = {
      ...currentModalRegularEntry,
      periodDays: period,
      // keep the identifying fields current for this shortKey
      shortKey: currentShortKey,
      parameters: currentParameters
    };
    if (regularEntryModalType === 'Add') {
      createRegularSampleEntry(payload);
    } else if (regularEntryModalType === 'Edit') {
      updateRegularSampleEntry(payload);
    }
    setShowRegularEntryModal(false);
  };

  const handlePrintClick = () => {
    setActiveTab('PrintOverview');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      requestAnimationFrame(() => {
        window.print();
      });
    }, 1000);
  };

  const handleBackToOverview = () => {
    setActiveTab('Overview');
  };

  const methodSecondaryData = [
    {
      id: randomId(),
      variable: 'Sample Type',
      value: currentChartGroupConfigurations.sampleType
    },
    {
      id: randomId(),
      variable: 'Display method version',
      value: currentChartGroupConfigurations.displayMethodVersion
    },
    {
      id: randomId(),
      variable: 'Auto-create sample re-check',
      value: currentChartGroupConfigurations.autoCreateSampleRecheck
    },
    {
      id: randomId(),
      variable: '1090 Material',
      value: currentControlStrategyConfigurations.tenNinetyMaterial
    },
    {
      id: randomId(),
      variable: '1090 Parameter',
      // Legacy 'DVPE' displays as RVP; blank/unknown as Auto.
      value: normalizeTenNinetyParameter(currentControlStrategyConfigurations.tenNinetyParameter)
    }
  ];

  const cellEditProp = {
    mode: 'click',
    blurToSave: true,
    afterSaveCell: (_row, cellName, cellValue) => {
      updateStateConfigurations(cellValue, cellName);
    }
  };

  const handleDescriptionChange = (e) => {
    setCurrentModalSchedule({
      ...currentModalSchedule,
      description: e.target.value
    });
  };

  const handleFrequencyChange = (e) => {
    setCurrentModalSchedule({
      ...currentModalSchedule,
      frequency: e.target.value
    });
  };

  const handleTimeChange = (e) => {
    setCurrentModalSchedule({
      ...currentModalSchedule,
      time: e.target.value
    });
  };

  const handleStartDateChange = (date) => {
    const startingDateDisplayed = moment(date).format('MM/DD/YYYY') || '';
    setCurrentModalSchedule({
      ...currentModalSchedule,
      startingDate: date,
      startingDateDisplayed
    });
  };

  const handleTimezoneChange = (e) => {
    setCurrentModalSchedule({
      ...currentModalSchedule,
      timezone: e.target.value
    });
  };

  const cellEditPropSampleSchedule = {
    mode: 'click',
    blurToSave: true,
    afterSaveCell: () => {}
  };

  const handleSaveSchedule = () => {
    if (scheduleModalType === 'Add') {
      createSampleSchedule(currentModalSchedule);
    } else if (scheduleModalType === 'Edit') {
      updateSampleSchedule(currentModalSchedule);
    }
    setShowScheduleModal(false);
  };

  const cellEditPropLimitData = {
    mode: 'click',
    blurToSave: true,
    afterSaveCell: (_row, cellName, cellValue) => {
      updateStateConfigurations(cellValue, cellName);
    }
  };
  const shouldFetchMultiple =
    allParams.length > 1 && !!currentControlStrategyConfigurations?.fullKey;

  const { data: fetchedChartControlStrategySnapshot = {} } = useQuery(
    ['batchControlStrategies', currentControlStrategyConfigurations?.fullKey],
    () => fetchMultipleControlStrategies(currentControlStrategyConfigurations.fullKey, allParams),
    {
      enabled: shouldFetchMultiple,
      refetchOnWindowFocus: false
    }
  );

  const [chartControlStrategySnapshot, setChartControlStrategySnapshot] = useState({});

  useEffect(() => {
    if (shouldFetchMultiple && Object.keys(fetchedChartControlStrategySnapshot).length > 0) {
      setChartControlStrategySnapshot(fetchedChartControlStrategySnapshot);
    } else if (
      !shouldFetchMultiple &&
      currentControlStrategyConfigurations &&
      Object.keys(currentControlStrategyConfigurations).length > 0
    ) {
      setChartControlStrategySnapshot(currentControlStrategyConfigurations);
    }
  }, [
    shouldFetchMultiple,
    fetchedChartControlStrategySnapshot,
    currentControlStrategyConfigurations
  ]);

  const generateChartLinesSnapshot = (rawSnapshot, isNonUs) => {
    const chartLinesSnapshot = {};

    const isSingleConfig =
      rawSnapshot && rawSnapshot.controlStrategy && typeof rawSnapshot.controlStrategy === 'string';

    const normalizedSnapshot = isSingleConfig
      ? Object.fromEntries(allParams.map((param) => [param, rawSnapshot]))
      : rawSnapshot;

    Object.entries(normalizedSnapshot || {}).forEach(([param, config]) => {
      const strategy = config?.controlStrategy;
      chartLinesSnapshot[param] = getChartLinesForStrategy(strategy, isNonUs);
    });

    return chartLinesSnapshot;
  };

  function newAssessment(rawSnapshot, isNonUs) {
    const isSingleConfig =
      rawSnapshot && rawSnapshot.controlStrategy && typeof rawSnapshot.controlStrategy === 'string';

    const normalizedChartControlStrategySnapshot = isSingleConfig
      ? Object.fromEntries(allParams.map((param) => [param, rawSnapshot]))
      : rawSnapshot;

    const chartDataSnapshot = {};
    const chartScalarsSnapshot = {};
    const chartLinesSnapshot = generateChartLinesSnapshot(
      normalizedChartControlStrategySnapshot,
      isNonUs
    );

    allParams.forEach((param) => {
      let paramChartData = shortKeyItems.filter((item) => item.parameter === param);
      paramChartData = paramChartData.filter(isIncludedInSqcChartSeries);

      paramChartData.forEach((item) => {
        if (!item.date && item.dateTime) {
          const d = new Date(item.dateTime);
          item.date = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
        }
        if (!item.date) {
          const d = new Date();
          item.date = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
        }
        item.formattedDate = new Date(item.date);
      });

      paramChartData.sort((a, b) => {
        const dateA = a.dateTime ? new Date(a.dateTime).getTime() : 0;
        const dateB = b.dateTime ? new Date(b.dateTime).getTime() : 0;
        return dateA - dateB;
      });

      paramChartData.forEach((item, idx) => {
        item.updatedIndex = idx;
      });

      const chartScalars = {};
      if (paramChartData.length > 0) {
        const rs = paramChartData.map((d) => Number(d.resultOmits));
        const rMin = Math.min(...rs);
        const rMax = Math.max(...rs);
        const last = paramChartData[paramChartData.length - 1];
        const sd3n = Number(last?.sd3n);
        const sd3p = Number(last?.sd3p);
        const topYMin = Number.isFinite(rMin) && Number.isFinite(sd3n) ? Math.min(rMin, sd3n) : 0;
        const topYMax = Number.isFinite(rMax) && Number.isFinite(sd3p) ? Math.max(rMax, sd3p) : 1;
        const topYInterval = topYMax - topYMin;

        const mrs = paramChartData
          .filter((d) => !Number.isNaN(parseFloat(d.mrOmits)))
          .map((d) => parseFloat(d.mrOmits));
        const mrMean = arrayAverage(mrs);
        const mrUCL = mrMean * 3.27;
        const mrMaxVal = Math.max(...mrs);
        const mrMax = mrUCL > mrMaxVal ? mrUCL : mrMaxVal;

        const zscores = paramChartData.map((d) => Number(d.zScoreOmits));
        const newResults = paramChartData.map((d) => Number(d.resultOmits));
        const xMin = Math.min(...zscores);
        const xMax = Math.max(...zscores);
        const yMin = Math.min(...newResults);
        const yMax = Math.max(...newResults);

        const dateTrend = paramChartData
          .map((item) => ({
            zScoreOmits: Number(item.zScoreOmits),
            resultOmits: Number(item.resultOmits)
          }))
          .filter((p) => !Number.isNaN(p.zScoreOmits) && !Number.isNaN(p.resultOmits));

        let trend = null;

        if (dateTrend.length >= 2) {
          const uniqueX = new Set(dateTrend.map((d) => d.zScoreOmits));

          if (uniqueX.size > 1) {
            trend = createTrend(dateTrend, 'zScoreOmits', 'resultOmits');
          }
        }

        Object.assign(chartScalars, {
          mrMean,
          mrUCL,
          mrYMax: mrMax * 1.05,
          trendData: trend
            ? [
                { y: trend.calcY(xMin), x: xMin },
                { y: trend.calcY(xMax), x: xMax }
              ]
            : [],
          qqXMin: xMin,
          qqXMax: xMax,
          qqYMin: yMin,
          qqYMax: yMax,
          cYMin: topYMin - 0.05 * topYInterval,
          cYMax: topYMax + 0.05 * topYInterval,
          histogramData: calculateHistogram(paramChartData, yMin, yMax)
        });
      }

      chartDataSnapshot[param] = paramChartData;
      chartScalarsSnapshot[param] = chartScalars;
    });

    return {
      assessed: true,
      assessorComments: '',
      clusteringEvident: '',
      normalDistribution: '',
      outcome: '',
      createdBy: resultsDataTableData[0]?.personnel,
      n: currentSetupDataOne + currentSetupDataZero,
      type: 'Initial',
      locked: false,
      shortKey: currentShortKey,
      cyclicalPatterns: '',
      tpiAssessment: '',
      trendingDirectionEvident: '',
      chartDataSnapshot,
      chartScalarsSnapshot,
      chartLinesSnapshot,
      chartControlStrategySnapshot: normalizedChartControlStrategySnapshot
    };
  }

  function newAssessmentPeriodic() {
    const assessment = {
      assessed: true,
      assessorComments: '',
      suspiciousResults: '',
      unusualPatterns: '',
      pool: false,
      outcome: '',
      createdBy: resultsDataTableData[0]?.personnel,
      n: currentSetupDataOne + currentSetupDataZero,
      type: 'Periodic',
      locked: false,
      shortKey: currentShortKey,
      fullKey: currentFullKey,
      tpiEvaluation: '',
      chiSquareTest: '',
      normalProbabilityPlot: '',
      andersonDarling: '',
      tTest: '',
      fTest: ''
    };
    return assessment;
  }

  function renderResultsTable(renderResults) {
    const rows = [];
    const readOnly = !checkCreate(permissionData, SCREEN?.DATA);

    const normalize = (s) => (typeof s === 'string' ? s.trim().toLowerCase() : '');

    const groupsWithLocation = (currentSetupGroups || []).filter((group) => {
      if (!currentLocation) return false;
      const current = normalize(currentLocation);
      const locs = group.locations || [];
      return locs.some((loc) => {
        if (!loc) return false;
        const locStr = normalize(loc.name || loc.value || loc.label || loc.id || loc);
        return locStr === current;
      });
    });

    const flattenedGroupPersonnel = groupsWithLocation.flatMap((g) => g.personnel || []);

    const uniquePersonnelMap = new Map();
    for (const p of flattenedGroupPersonnel) {
      if (typeof p === 'string') continue;
      const key = p.email || p.id || p.name;
      const existing = uniquePersonnelMap.get(key);
      if (!existing || (!existing.abbreviation && p.abbreviation)) {
        uniquePersonnelMap.set(key, p);
      }
    }

    const uniquePersonnelList = Array.from(uniquePersonnelMap.values());

    const groupPersonnelNames =
      uniquePersonnelList.map((p) =>
        config.useAbbreviationPersonnelName ? p.abbreviation || p.name : p.name
      ) || [];

    const basePersonnelOptions =
      personnel
        ?.filter(
          (p) => p.location === 'All' || normalize(p.location) === normalize(currentLocation)
        )
        ?.map((p) => (config.useAbbreviationPersonnelName ? p.abbreviation || p.name : p.name)) ||
      [];

    const personnelOptions = Array.from(
      new Set([...basePersonnelOptions, ...groupPersonnelNames].filter(Boolean))
    );

    const matchingUser = personnel?.find((person) => person.email === auth.user.email);
    const currentUserName = config.useAbbreviationPersonnelName
      ? matchingUser?.abbreviation || matchingUser?.name || ''
      : matchingUser?.name || '';

    rows.push(
      <div key="results-header" className="results-table-class">
        <input readOnly value="Date" className="results-entry" style={{ width: '25%' }} />
        <input readOnly value="Parameter" className="results-entry" style={{ width: '20%' }} />
        <input readOnly value="Personnel" className="results-entry" style={{ width: '20%' }} />
        <input readOnly value="Result ID" className="results-entry" style={{ width: '20%' }} />
        <input readOnly value="Setup" className="results-entry" style={{ width: '15%' }} />
      </div>
    );
    // --- Body ---
    renderResults.forEach((row, index) => {
      rows.push(
        <div key={row.id || index} className="results-table-class">
          <input
            style={{ width: '25%' }}
            readOnly={readOnly}
            onChange={(e) => handleResultsTableChange(e, index, 'dateTime')}
            value={row.dateTime || ''}
            type="text"
          />
          <Tooltip title={row.parameter} arrow>
            <input
              style={{ width: '20%' }}
              readOnly={readOnly}
              onChange={(e) => handleResultsTableChange(e, index, 'parameter')}
              value={row.parameter || ''}
              type="text"
            />
          </Tooltip>
          <select
            style={{ width: '20%' }}
            className={`results-select ${readOnly ? 'disabled' : ''}`}
            disabled={readOnly}
            value={row.personnel || currentUserName}
            onChange={(e) => handleResultsTableChange(e, index, 'personnel')}
          >
            {personnelOptions.map((person) => (
              <option key={person} value={person}>
                {person}
              </option>
            ))}
          </select>
          <input
            readOnly={readOnly}
            onChange={(e) => handleResultsTableChange(e, index, 'sampleId')}
            value={row.sampleId || ''}
            type="text"
            style={{ width: '20%' }}
          />
          <input
            style={{ width: '15%' }}
            readOnly={readOnly}
            onChange={(e) => handleResultsTableChange(e, index, 'setupData')}
            value={row.setupData ?? ''}
            type="text"
          />
        </div>
      );
    });

    return rows;
  }

  function renderResultsEntry(resultsEntryData) {
    const rows = [];
    const readOnly = !checkCreate(permissionData, SCREEN?.DATA);

    rows.push(<input key="label" readOnly value="Result" />);

    resultsEntryData.forEach((entry, index) => {
      rows.push(
        <input
          readOnly={readOnly}
          onChange={(e) => handleResultsTableChange(e, index, 'result')}
          key={`result-${index}`}
          value={entry.result || ''}
          type="text"
        />
      );
    });

    return rows;
  }

  const addData = () => {
    setLoadingSaveData(true);
    if (!currentLocation || !currentMethod || !currentInstrument || !currentSampleName) {
      // eslint-disable-next-line no-alert
      alert('Need to select location, method, sample name, and instrument');
      setLoadingSaveData(false);
    } else {
      const resultsRows = resultsDataTableData.map((item) => ({ ...item }));
      setResultsDataTableData(resultsDataTableData.map((item) => ({ ...item, result: '' })));
      const createAt = moment().tz(tz || 'UTC');
      for (const dataPoint of resultsRows) {
        if (dataPoint.isEditedDatetime) {
          const inputDateTime = moment.tz(dataPoint.dateTime, 'MM/DD/YYYY HH:mm', tz || 'UTC');
          dataPoint.dateTime = inputDateTime.toISOString();
          dataPoint.date = inputDateTime.format('MM/DD/YYYY');
          dataPoint.time = inputDateTime.format(config.timeIn24HourFormat ? 'HH:mm' : 'h:mm A');
        } else {
          dataPoint.dateTime = createAt.toISOString();
          dataPoint.date = createAt.format('MM/DD/YYYY');
          dataPoint.time = createAt.format(config.timeIn24HourFormat ? 'HH:mm' : 'h:mm A');
        }
        // Generate sampleId with only the time in HHmmss format
        if (!dataPoint.isEditedSampleId) {
          const timeComponent = createAt.format('HHmmss'); // e.g., "023034"
          dataPoint.sampleId = `SQC${createAt.format('YYYYMMDD')}_${timeComponent}`;
        }
      }
      const addDataObject = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        rows: resultsRows
          .filter((row) => !!String(row.result))
          .map((row) => {
            return { ...row, sampleName: currentSampleName };
          })
      };

      addDataFunction(addDataObject)
        .then(({ data }) => {
          resultsDataTableData.forEach((item) => {
            item['result'] = '';
          });
          if (data.status === 200) setLoadingSaveData(false);
        })
        .catch(() => {
          setLoadingSaveData(false);
        });
      sessionStorage.removeItem(currentShortKey);
    }
  }; // addData
  function renderOverviewCharts(activeTabSelected, isDataComplete) {
    const chartSectionToReturn = [];
    if (activeTabSelected === 'Overview' && isDataComplete === true) {
      chartSectionToReturn.push(
        <div className="charts-master-container">
          {Array.isArray(chartData) && chartData.length && (
            <div>
              <div className="overview-chart-header">
                <h4>
                  Summary Statistics: {currentParameter}
                  {unit ? `, ${unit}` : ''}
                </h4>
              </div>
              <div className="statistics-table">
                <div>
                  <CustomTable
                    data={summaryStatisticsPreview}
                    header={summaryStatisticsColumns}
                    hideFooter={true}
                    hideHeader={true}
                  />
                </div>
                <div>
                  <CustomTable
                    data={summaryStatisticsPreviewTwo}
                    header={summaryStatisticsColumns}
                    hideFooter={true}
                    hideHeader={true}
                  />
                </div>
              </div>
              <div className="overview-chart-header">
                <h4>Charts</h4>
              </div>
              {!chartScalars ||
              Object.keys(chartScalars).length === 0 ||
              !isFinite(chartScalars.cYMin) ||
              !isFinite(chartScalars.cYMax) ||
              !isFinite(chartScalars.mrYMax) ||
              !isFinite(chartScalars.mrMean) ||
              !isFinite(chartScalars.mrUCL) ||
              chartScalars.trendData == null ||
              !isFinite(chartScalars.qqXMin) ||
              !isFinite(chartScalars.qqXMax) ||
              !isFinite(chartScalars.qqYMin) ||
              !isFinite(chartScalars.qqYMax) ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <p>Chart data is unavailable. Please run the data to generate charts.</p>
                </div>
              ) : (
                <>
                  <div className="chart-row-container">
                    <SQCLineChart
                      xAxis="updatedIndex"
                      syncId="chained"
                      yMin={chartScalars.cYMin}
                      yMax={chartScalars.cYMax}
                      data={chartData}
                      lines={chartLines}
                      isEverFlags={isEverFlags}
                      unit={unit || ''}
                      arv={currentControlStrategyConfigurations?.mean}
                      showArv={showArv}
                      onShowArvChange={setShowArv}
                      showDateTimeInTooltip
                      tz={tz}
                      dateTimeFormat={dateTimeFormat}
                    />
                    <SQCMovingRangeChart
                      xAxis="updatedIndex"
                      key={uuidv4()}
                      data={chartData}
                      showDateTimeInTooltip
                      tz={tz}
                      dateTimeFormat={dateTimeFormat}
                      syncId="chained2"
                      yMin={0}
                      yMax={chartScalars.mrYMax}
                      lines={[
                        {
                          yAxis: 'mrOmits',
                          name: 'Data',
                          color: '#32CD32'
                        },
                        {
                          yAxis: 'mean',
                          overrideValue: chartScalars.mrMean,
                          name: 'Center Line',
                          reference: true,
                          label: ``,
                          color: 'orange'
                        },
                        {
                          yAxis: 'sd3p',
                          overrideValue: chartScalars.mrUCL,
                          label: ``,
                          name: 'UCL',
                          color: 'red',
                          reference: true
                        }
                      ]}
                      unit={unit || ''}
                    />
                  </div>
                  <div>
                    <>
                      {chartScalars.histogramData && (
                        <SQCHistogram
                          data={chartScalars.histogramData}
                          Xlabel={<text>{currentParameter}</text>}
                          Ylabel={<text>{`Frequency`}</text>}
                          unit={unit}
                        />
                      )}
                      {!chartScalars.histogramData && <div>No Histogram</div>}
                    </>
                    <SQCScatterPlot
                      xAxis="zScoreOmits"
                      key={uuidv4()}
                      data={chartData}
                      syncId="chained2"
                      xMin={chartScalars.qqXMin}
                      xMax={chartScalars.qqXMax}
                      yMin={chartScalars.qqYMin}
                      yMax={chartScalars.qqYMax}
                      collections={[
                        {
                          name: 'Lab Results',
                          color: '#32CD32',
                          data: chartData.map((cd) => {
                            return {
                              x: Number(cd.zScoreOmits),
                              y: Number(cd.resultOmits)
                            };
                          })
                        },
                        {
                          name: 'Trend Line',
                          color: '#FFBF00',
                          data: chartScalars.trendData,
                          line: true
                        }
                      ]}
                      Xlabel={<text>{`Theoretical quantiles`}</text>}
                      Ylabel={<text>{`Normal data quantiles`}</text>}
                      unit={unit || ''}
                    />
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      );
    } else if (activeTabSelected === 'Overview' && isDataComplete === false) {
      chartSectionToReturn.push(
        <>
          <div className="compiling-issue-container">
            <div className="compiling-issue-header ">
              <h4>Summary Statistics and Charts</h4>
              <div>
                There were issues compiling chart data for that location, method, sample name,
                instrument and parameter. Try running the data to fix this.
              </div>
            </div>
          </div>
        </>
      );
    } else {
      chartSectionToReturn.push(<></>);
    }
    return chartSectionToReturn;
  }

  const handleLowerControlLimitChange = (e) => {
    setCurrentControlStrategyConfigurations({
      ...currentControlStrategyConfigurations,
      lowerControlLimit: e.target.value
    });
  };

  const handleUpperControlLimitChange = (e) => {
    setCurrentControlStrategyConfigurations({
      ...currentControlStrategyConfigurations,
      upperControlLimit: e.target.value
    });
  };

  const mapApproachToValue = (approach, limitType) => {
    let valueToReturn = '';
    switch (approach) {
      case 'Use Repeatability-based limit': {
        if (limitType === 'lowerControlLimit') {
          valueToReturn = renderSigDigits(
            Number(currentSummary.avg_sd) - (Number(currentSummary.repeat_sd) / 2.77) * 3
          );
        } else {
          valueToReturn = renderSigDigits(
            Number(currentSummary.avg_sd) + (Number(currentSummary.repeat_sd) / 2.77) * 3
          );
        }
        break;
      }
      case 'Default':
        valueToReturn = 'N/A';
        break;
      case 'Custom':
        valueToReturn = '';
        break;
      default:
        break;
    }
    return valueToReturn;
  };

  const handleUpperControlLimitSelect = (e) => {
    setCurrentControlStrategyConfigurations({
      ...currentControlStrategyConfigurations,
      upperControlLimitApproach: e.target.value,
      upperControlLimit: mapApproachToValue(e.target.value, 'upperControlLimit')
    });
  };

  const handleLowerControlLimitSelect = (e) => {
    setCurrentControlStrategyConfigurations({
      ...currentControlStrategyConfigurations,
      lowerControlLimitApproach: e.target.value,
      lowerControlLimit: mapApproachToValue(e.target.value, 'lowerControlLimit')
    });
  };

  const updateRowData = (rowData, isDelete = false) => {
    const currentRowsToUpdate = rowsToUpdate;
    const existingIndex = currentRowsToUpdate.findIndex(
      (rowToUpdate) => rowToUpdate.id === rowData.id
    );
    if (existingIndex !== -1) {
      if (isDelete) {
        currentRowsToUpdate[existingIndex] = {
          ...currentRowsToUpdate[existingIndex],
          delete: rowData.delete
        };
      } else {
        rowData.delete = currentRowsToUpdate[existingIndex].delete;
        currentRowsToUpdate[existingIndex] = rowData;
      }
    } else {
      currentRowsToUpdate.push(rowData);
    }
    setRowsToUpdate(currentRowsToUpdate);
  };

  const renderPrintOverviewCharts = () => {
    return (
      <div>
        {Array.isArray(chartData) && chartData.length && (
          <div>
            <div className="overview-chart-header">
              <h4>Charts</h4>
            </div>
            {!chartScalars ||
            Object.keys(chartScalars).length === 0 ||
            chartScalars.cYMin == null ||
            chartScalars.cYMax == null ||
            chartScalars.mrYMax == null ||
            chartScalars.mrMean == null ||
            chartScalars.mrUCL == null ||
            chartScalars.trendData == null ||
            chartScalars.qqXMin == null ||
            chartScalars.qqXMax == null ||
            chartScalars.qqYMin == null ||
            chartScalars.qqYMax == null ? (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <p>Chart data is unavailable. Please run the data to generate charts.</p>
              </div>
            ) : (
              <>
                <div className="chart-row-container">
                  <SQCLineChart
                    xAxis="updatedIndex"
                    syncId="chained"
                    yMin={chartScalars.cYMin}
                    yMax={chartScalars.cYMax}
                    data={chartData}
                    lines={chartLines}
                    unit={unit || ''}
                    arv={currentControlStrategyConfigurations?.mean}
                    showArv={showArv}
                    onShowArvChange={setShowArv}
                  />
                  <SQCMovingRangeChart
                    xAxis="updatedIndex"
                    key={uuidv4()}
                    data={chartData}
                    syncId="chained2"
                    yMin={0}
                    yMax={chartScalars.mrYMax}
                    lines={[
                      {
                        yAxis: 'mrOmits',
                        name: 'Data',
                        color: '#32CD32'
                      },
                      {
                        yAxis: 'mean',
                        overrideValue: chartScalars.mrMean,
                        name: 'Center Line',
                        reference: true,
                        label: ``,
                        color: 'orange'
                      },
                      {
                        yAxis: 'sd3p',
                        overrideValue: chartScalars.mrUCL,
                        label: ``,
                        name: 'UCL',
                        color: 'red',
                        reference: true
                      }
                    ]}
                    unit={unit || ''}
                  />
                </div>
                <div>
                  <>
                    {chartScalars.histogramData && (
                      <SQCHistogram
                        data={chartScalars.histogramData}
                        Xlabel={<text>{currentParameter}</text>}
                        Ylabel={<text>{`Frequency`}</text>}
                        unit={unit || ''}
                      />
                    )}
                    {!chartScalars.histogramData && <div>No Histogram</div>}
                  </>
                  <SQCScatterPlot
                    xAxis="zScoreOmits"
                    key={uuidv4()}
                    data={chartData}
                    syncId="chained2"
                    xMin={chartScalars.qqXMin}
                    xMax={chartScalars.qqXMax}
                    yMin={chartScalars.qqYMin}
                    yMax={chartScalars.qqYMax}
                    collections={[
                      {
                        name: 'Lab Results',
                        color: '#32CD32',
                        data: chartData.map((cd) => {
                          return {
                            x: cd.zScoreOmits,
                            y: cd.resultOmits
                          };
                        })
                      },
                      {
                        name: 'Trend Line',
                        color: '#FFBF00',
                        data: chartScalars.trendData,
                        line: true
                      }
                    ]}
                    Xlabel={<text>{`Theoretical quantiles`}</text>}
                    Ylabel={<text>{`Normal data quantiles`}</text>}
                    unit={unit}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  const exportToCSV = () => {
    if (!filteredChartHits || filteredChartHits.length === 0) return;

    const allKeys = defaultExportDataToCSVColumns.map((column) => column.field);
    const allHeaders = defaultExportDataToCSVColumns.map((column) => column.headerName);

    // Create CSV header row
    const csvHeader = allHeaders.join(',');

    // Create CSV data rows
    const csvRows = filteredChartHits.map((obj) => {
      return allKeys
        .map((key) => {
          const value = obj[key];
          // Handle special cases like dates, numbers, strings with commas
          if (value === null || value === undefined) return '';
          if (typeof value === 'string' && value.includes(',')) return `"${value}"`;
          if (value instanceof Date || key === 'dateTime')
            return moment(value)
              .tz(tz || 'UTC')
              .format(FORMAT_KEY_TIME);
          return value;
        })
        .join(',');
    });

    // Combine header and rows
    const csvString = [csvHeader, ...csvRows].join('\n');

    // Create and trigger download
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      const fileName = `${currentParameter}_Dataset_${moment().format(FORMAT_DATE_YYYYMMDD)}.csv`;
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const renderResultsSection = useMemo(() => {
    const resultsSectionToReturn = [];
    if (currentControlStrategyConfigurations.archive === 'Yes') {
      resultsSectionToReturn.push(<></>);
    } else {
      resultsSectionToReturn.push(
        <div>
          <div className="overview-chart-header">
            <h4>Results</h4>
          </div>
          <div className="results-table-container">
            <div className="results-entry-container">
              <div className="render-results-table-container ">
                <div>{renderResultsTable(resultsDataTableData)}</div>
                <div className="render-results-entry-table-container">
                  {renderResultsEntry(resultsDataTableData)}
                </div>
              </div>
            </div>
          </div>
          <div className="edit-button">
            {renderButton(
              'Re-index Data',
              () => {
                setLoadingReIndexData(true);
                runReBuildIndexFunctions()
                  .then(() => {
                    setLoadingReIndexData(false);
                  })
                  .catch(() => {
                    setLoadingReIndexData(false);
                  });
              },
              SCREEN?.DATA,
              RULES.CREATE,
              true,
              loadingReIndexData
            )}
            {renderButton(
              'Run Data',
              () => runData(),
              SCREEN?.DATA,
              RULES.SAVE,
              true,
              loadingRunData
            )}
            {renderButton(
              'Save Data',
              () => addData(),
              SCREEN?.DATA,
              RULES.CREATE,
              true,
              loadingSaveData
            )}
            {['uat', 'localhost', 'netlify.app'].some((env) =>
              window.location.hostname.toLowerCase().includes(env)
            ) && (
              <Button
                variant="secondary"
                onClick={runCalculation}
                disabled={loadingRunCalculationPipeline}
              >
                {loadingRunCalculationPipeline ? 'Calculating...' : 'Run Calculate Data'}
              </Button>
            )}
          </div>
        </div>
      );
    }
    return resultsSectionToReturn;
  }, [
    currentControlStrategyConfigurations,
    resultsDataTableData,
    loadingRunData,
    loadingSaveData,
    loadingReIndexData,
    loadingRunCalculationPipeline
  ]);

  const handleSaveNote = async () => {
    if (noteRow && noteRef.current) {
      const noteValue = noteRef.current.value;
      setFilteredChartHits((prev) =>
        prev.map((row) => (row.id === noteRow.id ? { ...row, notes: noteValue } : row))
      );
      await updateData(noteRow.id, { notes: noteValue });
      setShowNotePopover(false);
      if (noteRef.current) noteRef.current.value = '';
    }
  };
  let columns;
  if (isNonUs) {
    columns = [...defaultColumns(dateTimeFormat, tz), ...defaultColumnsUsExtend];
  } else {
    columns = [...defaultColumns(dateTimeFormat, tz), ...defaultColumnsExtend];
  }

  const getFlagsColumn = (baseCol, options = {}) => {
    const { showNote = false } = options;

    return {
      ...baseCol,
      renderCell: (params) => {
        const { value, row } = params;

        const isSilenceOmit = row?.omitFromSqc === 'Y' || row?.silence === 'Y';

        const parts =
          typeof value === 'string'
            ? value
                .split(';')
                .map((p) => p.trim())
                .filter(Boolean)
            : [];

        const showEllipsis = parts.length > 2;

        return (
          <Tooltip title={value || ''} arrow>
            <span style={{ display: 'flex', alignItems: 'flex-start' }}>
              {showNote && (
                <>
                  <IconButton
                    size="sm"
                    style={{ marginRight: 4, marginTop: 2 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPopoverTarget(e.currentTarget);
                      setNoteRow(row);
                      setShowNotePopover(!showNotePopover || noteRow !== row);
                    }}
                  >
                    <NoteAddIcon />
                  </IconButton>
                  <Overlay
                    show={showNotePopover && noteRow === row}
                    target={popoverTarget}
                    placement="right"
                    containerPadding={20}
                    rootClose
                    onHide={() => setShowNotePopover(false)}
                  >
                    <Popover id="add-note-popover">
                      <Popover.Body>
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            handleSaveNote();
                            setShowNotePopover(false);
                          }}
                        >
                          <Form.Group>
                            <Form.Control
                              type="text"
                              ref={noteRef}
                              placeholder="Enter note"
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  handleSaveNote();
                                  setShowNotePopover(false);
                                }
                              }}
                            />
                          </Form.Group>
                          <div style={{ marginTop: 8, textAlign: 'right' }}>
                            <Button
                              size="sm"
                              variant="secondary"
                              onClick={() => setShowNotePopover(false)}
                              style={{ marginRight: 8 }}
                            >
                              Cancel
                            </Button>
                            <Button size="sm" variant="primary" type="submit">
                              Save
                            </Button>
                          </div>
                        </Form>
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </>
              )}

              {!isSilenceOmit && (
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  {parts.slice(0, 2).map((part, idx) => (
                    <span key={idx}>
                      {part}
                      <br />
                    </span>
                  ))}
                  {showEllipsis && <span>...</span>}
                </span>
              )}
            </span>
          </Tooltip>
        );
      }
    };
  };

  // Note: In the future, we want to render a single table and dynamically update columns. However, BootstrapTable is unable to do that so we have to render separate tables for now.
  const renderEditTable = () => {
    const flagsColIdx = columns.findIndex((col) => col.field === 'flags');

    if (flagsColIdx !== -1) {
      columns[flagsColIdx] = getFlagsColumn(columns[flagsColIdx], {
        showNote: true
      });
    }

    const addRowClass = (params) => {
      const row = params.row || params;
      const hasOOC = Object.keys(row).some(
        (key) =>
          (key.startsWith('ooc') && isValidFlag(row[key])) ||
          (key.startsWith('flags') && String(row[key]).includes('OOC:'))
      );

      if (hasOOC && !(row?.omitFromSqc === 'Y' || row?.silence === 'Y')) {
        return 'row-ooc';
      }

      // Flag a typo'd result ("3.24v", "10..5") so the lab can spot and correct
      // it — the calc drops these to a chart gap, and they used to be masked into
      // a clean number in this table. OOC red takes precedence if both apply.
      if (isMalformedNumericResult(row?.result)) {
        return 'row-nonnumeric';
      }

      return '';
    };

    if (isEverFlags && !columns.some((col) => col.field === 'everFlags')) {
      // EverFlags are shown on EVERY row (not only omitted/silenced ones) so the
      // table agrees with the I-chart overlay (#466), and re-evaluated against the
      // key's live config exactly like the chart dots: codes whose rule is now Off
      // are dropped and severity follows the live rule (Arteco Density: stale
      // "OOC: 9CP" flags frozen on locked rows).
      const everFlagsConfig = liveEverFlagsConfig(currentControlStrategyConfigurations);
      columns.splice(5, 0, {
        field: 'everFlags',
        headerName: 'EverFlags',
        minWidth: 250,
        editable: false,
        sortComparator: (a, b, cellParamsA, cellParamsB) => {
          const rowA = cellParamsA?.api?.getRow(cellParamsA.id);
          const rowB = cellParamsB?.api?.getRow(cellParamsB.id);

          const everA = getEverFlagsDisplayGroups(rowA ?? { everFlags: a }, everFlagsConfig).join(
            ';'
          );
          const everB = getEverFlagsDisplayGroups(rowB ?? { everFlags: b }, everFlagsConfig).join(
            ';'
          );

          const isEmptyA = !everA.trim();
          const isEmptyB = !everB.trim();

          if (isEmptyA && !isEmptyB) return -1;
          if (!isEmptyA && isEmptyB) return 1;

          const getPriority = (str) => {
            if (/warnings:/i.test(str)) return 1;
            if (/ooc:/i.test(str)) return 2;
            return 0;
          };

          const prioA = getPriority(everA);
          const prioB = getPriority(everB);

          if (prioA !== prioB) return prioB - prioA;

          return everB.localeCompare(everA);
        },
        renderCell: (params) => {
          const { row } = params;
          const groupedFlags = getEverFlagsDisplayGroups(row, everFlagsConfig);

          if (groupedFlags.length === 0) {
            return <></>;
          }

          return (
            <Tooltip
              title={
                <span>
                  {groupedFlags.map((flag, i) => (
                    <p key={i} style={{ margin: 0 }}>
                      {flag}
                    </p>
                  ))}
                </span>
              }
            >
              <span>
                {groupedFlags.map((flag, i) => (
                  <p key={i} style={{ margin: 0 }}>
                    {flag}
                  </p>
                ))}
              </span>
            </Tooltip>
          );
        }
      });
    }

    if (activeTab === 'PrintOverview') {
      const [showPopover, setShowPopover] = useState(false);
      const [minDate, setMinDate] = useState('');
      const [maxDate, setMaxDate] = useState('');
      const [tempMinDate, setTempMinDate] = useState('');
      const [tempMaxDate, setTempMaxDate] = useState('');
      const target = useRef(null);

      const togglePopover = () => {
        setTempMinDate(minDate);
        setTempMaxDate(maxDate);
        setShowPopover(!showPopover);
      };

      const handleFilter = (data) => {
        return data.filter((row) => {
          const rowDate = moment(row.dateTime).tz(tz || 'UTC');
          const min = minDate
            ? moment(minDate)
                .startOf('day')
                .tz(tz || 'UTC')
            : null;
          const max = maxDate
            ? moment(maxDate)
                .endOf('day')
                .tz(tz || 'UTC')
            : null;
          return (!min || rowDate.isSameOrAfter(min)) && (!max || rowDate.isSameOrBefore(max));
        });
      };

      const handleApply = () => {
        setMinDate(tempMinDate);
        setMaxDate(tempMaxDate);
        setShowPopover(false);
      };

      const clearFilters = () => {
        setTempMinDate('');
        setTempMaxDate('');
        setMinDate('');
        setMaxDate('');
        setShowPopover(false);
      };

      const filteredData = useMemo(
        () => handleFilter(filteredChartHits),
        [filteredChartHits, minDate, maxDate]
      );
      const HIDDEN_PRINT_FIELDS = ['mean', 'sd3n', 'sd3p', 'omit1090', 'everFlags', 'resultOmits'];
      const printColumns = columns.filter((col) => !HIDDEN_PRINT_FIELDS.includes(col.field));

      return (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4>Results</h4>
            <IconButton color="default" onClick={togglePopover} ref={target}>
              <FilterListIcon />
            </IconButton>
          </div>
          <div>
            <Overlay
              show={showPopover}
              target={target.current}
              placement="bottom-end"
              rootClose={true}
              onHide={() => setShowPopover(false)}
            >
              <Popover id="date-filter-popover" style={{ minWidth: '250px' }}>
                <Popover.Header as="h3">Filter by Date</Popover.Header>
                <Popover.Body>
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-2">
                      <label className="text-sm whitespace-nowrap">Min Date:</label>
                      <input
                        type="date"
                        className="form-control flex-1"
                        value={tempMinDate}
                        onChange={(e) => setTempMinDate(e.target.value)}
                      />
                    </div>
                    <div className="flex items-center gap-2">
                      <label className="text-sm whitespace-nowrap">Max Date:</label>
                      <input
                        type="date"
                        className="form-control flex-1"
                        value={tempMaxDate}
                        onChange={(e) => setTempMaxDate(e.target.value)}
                      />
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <Button variant="secondary" onClick={clearFilters} size="sm">
                        Clear
                      </Button>
                      <Button variant="primary" onClick={handleApply} size="sm">
                        Apply
                      </Button>
                    </div>
                  </div>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>

          <PrintOverviewDataTable
            columns={printColumns}
            data={filteredData}
            tz={tz}
            getRowClassName={addRowClass}
          />
        </>
      );
    } else {
      //overview tab case
      return (
        <CustomTable
          header={columns}
          data={filteredChartHits}
          rowHeight={42}
          numberOfRows={50}
          sort={{ sorting: { sortModel: [{ field: 'dateTime', sort: 'desc' }] } }}
          columnsInitialState={{
            columns: {
              columnVisibilityModel: {
                resultOmits: false
              }
            }
          }}
          rowClass={addRowClass}
        />
      );
    }
  };

  const defaultColumnsEditExtend = (allowDelete) => {
    const list = [
      {
        field: 'omit1090',
        headerName: 'Omit 1090',
        minWidth: 100,
        editable: true,
        type: 'singleSelect',
        valueOptions: yesNoOptions
      },

      {
        field: 'notes',
        headerName: 'Notes',
        minWidth: 150,
        flex: 1,
        editable: true
      },
      {
        field: 'locked',
        headerName: 'Locked',
        textAlign: 'center',
        minWidth: 80,
        renderCell: ({ row }) => (
          <Checkbox
            checked={row?.locked === 'Y' || row?.locked === true}
            onChange={(e) => {
              updateRowData({ ...row, locked: e.target.checked ? 'Y' : 'N' });
              // update filtered chart hits:
              setFilteredChartHits(
                filteredChartHits.map((r) =>
                  r.id === row.id ? { ...r, locked: e.target.checked ? 'Y' : 'N' } : r
                )
              );
            }}
          />
        )
      }
    ];
    if (allowDelete) {
      list.push({
        field: 'delete',
        headerName: 'Delete',
        textAlign: 'center',
        minWidth: 40,
        renderCell: ({ row }) => (
          <Checkbox
            disabled={!allowDelete}
            defaultChecked={row?.delete}
            onChange={(e) => {
              updateRowData({ ...row, delete: e.target.checked }, true);
            }}
          />
        )
      });
    }
    return list;
  };

  const defaultColumnsEditUsExtend = (allowDelete) => {
    const list = [
      {
        field: 'locked',
        headerName: 'Locked',
        textAlign: 'center',
        minWidth: 80,
        renderCell: ({ row }) => (
          <Checkbox
            checked={row?.locked === 'Y' || row?.locked === true}
            onChange={(e) => {
              updateRowData({ ...row, locked: e.target.checked ? 'Y' : 'N' });
              // update filtered chart hits:
              setFilteredChartHits(
                filteredChartHits.map((r) =>
                  r.id === row.id ? { ...r, locked: e.target.checked ? 'Y' : 'N' } : r
                )
              );
            }}
          />
        )
      },
      {
        field: 'notes',
        headerName: 'Notes',
        minWidth: 150,
        flex: 1,
        editable: true
      }
    ];
    if (allowDelete) {
      list.push({
        field: 'delete',
        headerName: 'Delete',
        textAlign: 'center',
        minWidth: 40,
        renderCell: ({ row }) => (
          <Checkbox
            disabled={!allowDelete}
            defaultChecked={row?.delete}
            onChange={(e) => {
              updateRowData({ ...row, delete: e.target.checked }, true);
            }}
          />
        )
      });
    }
    return list;
  };
  // Note: In the future, we want to render a single table and dynamically update columns. However, BootstrapTable is unable to do that so we have to render separate tables for now.
  const renderModalEditTable = () => {
    let columns;
    const update = permissionData?.[SCREEN?.DATA]?.update || false;
    const allowDelete = permissionData?.[SCREEN?.DATA]?.delete || false;
    if (isNonUs) {
      columns = [
        ...defaultColumnsEdit(currentPersonnelDropdown, dateTimeFormat, tz),
        ...defaultColumnsEditUsExtend(allowDelete)
      ];
    } else {
      columns = [
        ...defaultColumnsEdit(currentPersonnelDropdown, dateTimeFormat, tz),
        ...defaultColumnsEditExtend(allowDelete)
      ];
    }
    const flagsColIdx = columns.findIndex((col) => col.field === 'flags');

    if (flagsColIdx !== -1) {
      columns[flagsColIdx] = getFlagsColumn(columns[flagsColIdx], {
        showNote: false
      });
    }
    if (update && update.type != UPDATE_TYPE.ALL) {
      columns.forEach((item) => {
        if (item) {
          if (
            update.type === UPDATE_TYPE.NONE ||
            !(update.fieldAllow && update.fieldAllow.includes(item.field))
          ) {
            item.editable = false;
          } else {
            item.editable = true;
          }
        }
      });
    }
    return (
      <CustomTable
        data={filteredChartHits}
        header={columns}
        setData={setFilteredChartHits}
        numberOfRows={20}
        updateRowData={updateRowData}
        actionPosition={'first'}
        action={['edit']}
        sort={{ sorting: { sortModel: [{ field: 'dateTime', sort: 'desc' }] } }}
        columnsInitialState={{
          columns: {
            columnVisibilityModel: {
              resultOmits: false
            }
          }
        }}
        updateEditingModeFunction={updateEditingMode}
      />
    );
  };

  const [loadingResetEverFlags, setLoadingResetEverFlags] = useState(false);
  const handleResetEverFlags = async () => {
    try {
      setLoadingResetEverFlags(true);
      if (!currentLocation || !currentMethod || !currentInstrument || !currentSampleName) {
        alert('Need to select location, method, sample name, and instrument');
      } else {
        const everFlagsReset = filteredChartHits
          .map((item) => ({ flags: item.flags, id: item.id }))
          .filter((item) => item.flags);
        await resetEverFlags(currentFullKey, everFlagsReset);
      }
    } catch (error) {
      console.error('handle reset everFlags error:', error);
    } finally {
      setLoadingResetEverFlags(false);
    }
  };

  const [isDeleteAllData, setIsDeleteAllData] = useState(false);
  const [openCofirmDeleteAllData, setOpenCofirmDeleteAllData] = useState(false);
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(true);
  const [confirmationInput, setConfirmationInput] = useState('');
  const [error, setError] = useState('');

  const handleConfirmationInputChange = (event) => {
    setConfirmationInput(event.target.value);
    if (event.target.value === 'delete') {
      setIsDeleteDisabled(false);
    } else {
      setIsDeleteDisabled(true);
    }
  };

  const handleConfirmDelete = async () => {
    if (confirmationInput.toLowerCase() !== 'delete') {
      setError("You must type 'delete' to confirm.");
      return;
    }

    if (!currentLocation || !currentMethod || !currentSampleName || !currentInstrument) {
      setError('Please select a location, method, sample name, instrument, and parameter.');
      return;
    }

    const resetSelection = () => {
      setCurrentLocation('');
      setCurrentMethod('');
      setCurrentSampleName('');
      setCurrentInstrument('');
      setCurrentParameter('');
    };

    try {
      setChartLoading(true);

      const response = await deleteAllDataFunction({ fullKey: currentFullKey });

      if (response?.data.success) {
        alert('All data deleted successfully! Proceeding to rebuild the index.');
        resetSelection();
        await runReBuildIndexFunctions();
        window.location.reload();
      } else {
        alert('All data deletion and re-indexing failed.');
      }
    } catch (error) {
      console.error('[handleConfirmDelete] Error:', error);
      alert('An error occurred while deleting data. Please try again.');
    } finally {
      setChartLoading(false);
      setConfirmationInput('');
      setError('');
    }
  };

  const exportFullKeysToCSV = (currentLocation) => {
    if (!currentLocation || currentLocation.trim() === '') {
      alert('Please select a [LOCATION] before download.');
      return;
    }

    const extractFullKeys = (indexesArray, label) => {
      return indexesArray.flatMap((entry) => {
        const locations = entry.index;
        if (!Array.isArray(locations)) return [];

        return locations
          .filter((loc) => loc.name === currentLocation)
          .flatMap((loc) => {
            return (loc.method || []).flatMap((methodObj) => {
              const method = methodObj.name;
              const samples = methodObj.sampleName || [];

              return samples.flatMap((sampleObj) => {
                const sampleName = sampleObj.name;
                const instruments = sampleObj.instrument || [];

                return instruments.flatMap((instrumentObj) => {
                  const instrument = instrumentObj.name;
                  const parameters = instrumentObj.parameter || [];

                  return parameters.map((parameterObj) => {
                    const parameter = parameterObj.name;

                    return {
                      location: loc.name,
                      method,
                      sampleName,
                      instrument,
                      parameter,
                      type: label
                    };
                  });
                });
              });
            });
          });
      });
    };

    const fullKeys = [
      ...extractFullKeys(currentActiveIndexes, 'Active'),
      ...extractFullKeys(currentArchiveIndexes, 'Archive')
    ];

    if (fullKeys.length === 0) {
      alert(`No fullKeys found for "${currentLocation}".`);
      return;
    }

    const headers = ['Location', 'Method', 'Parameter', 'Instrument', 'Sample Name'];

    const escapeCSV = (val) => {
      if (val == null) return '';
      const str = String(val);
      return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
    };

    const csvContent = [
      headers.map(escapeCSV).join(','),
      ...fullKeys.map((row) =>
        [row.location, row.method, row.parameter, row.instrument, row.sampleName]
          .map(escapeCSV)
          .join(',')
      )
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${currentLocation}_fullKeys.csv`);
    link.click();
    URL.revokeObjectURL(url);
  };

  function renderBottomSection(section) {
    if (section === 'PrintOverview') {
      return (
        <PrintOverviewSection
          currentControlStrategyConfigurations={currentControlStrategyConfigurations}
          chartStage={chartStage}
          currentParameter={currentParameter}
          unit={unit}
          summaryStatisticsColumns={summaryStatisticsColumns}
          summaryStatisticsPreview={summaryStatisticsPreview}
          pageSizeDefault={pageSizeDefault}
          summaryStatisticsPreviewTwo={summaryStatisticsPreviewTwo}
          renderEditTable={renderEditTable}
          renderPrintOverviewCharts={renderPrintOverviewCharts}
          handleBackToOverview={handleBackToOverview}
        />
      );
    }
    if (section === 'Comparison') {
      if (
        !isAdmin(permissionData) &&
        !checkHasPermission(permissionData?.[SCREEN?.COMPARISON], RULES.VIEW)
      ) {
        return <></>;
      }
      return (
        <ComparisonSection
          localSearchFinished={localSearchFinished}
          currentPersonnelNames={currentPersonnelNames}
          currentPersonnelDots={currentPersonnelDots}
          chartScalars={chartScalars}
          chartData={chartData}
          renderChartLabelValue={renderChartLabelValue}
          currentMethodComparison={currentMethodComparison}
          handleMethodChangeComparison={handleMethodChangeComparison}
          currentMethods={currentMethods}
          renderOptionsDynamic={renderOptionsDynamic}
          currentSampleNameComparison={currentSampleNameComparison}
          handleSampleNameChangeComparison={handleSampleNameChangeComparison}
          currentSampleNames={currentSampleNames}
          currentParameterComparison={currentParameterComparison}
          handleParameterChangeComparison={handleParameterChangeComparison}
          currentParametersDynamic={currentParametersDynamic}
          currentInstrumentNames={currentInstrumentNames}
          currentInstrumentDots={currentInstrumentDots}
          currentInstrumentComparisonData={currentInstrumentComparisonData}
          currentInstrument={currentInstrument}
          currentLocation={currentLocation}
          summaries={currentSummaries}
          hideRegionArea={!!isHideRegionArea}
          tz={tz}
          dateTimeFormat={dateTimeFormat}
        />
      );
    }
    if (section === 'Instrument Limits') {
      if (!activeItems.instrumentLimits) {
        return <></>;
      }
      return (
        <InstrumentLimits
          location={currentLocation}
          method={currentMethod}
          sampleName={currentSampleName}
          instrument={currentInstrument}
          parameter={currentParameter}
          summaries={summaries}
        />
      );
    }
    if (section === 'Configuration') {
      if (
        !isAdmin(permissionData) &&
        !checkHasPermission(permissionData?.[SCREEN?.CONFIG], RULES.VIEW)
      ) {
        return <></>;
      }
      return (
        <>
          <ConfigurationSection
            permissionData={permissionData}
            radioArchiveValue={radioArchiveValue}
            configurationData={configurationData}
            configurationTableColumns={configurationTableColumns}
            currentControlStrategyConfigurations={currentControlStrategyConfigurations}
            parameterSecondaryData={parameterSecondaryData}
            parameterSecondaryDataColumns={parameterSecondaryDataColumns}
            controlStrategyData={controlStrategyData}
            controlStrategyConfigurationColumns={controlStrategyConfigurationColumns}
            bottomTPIData={bottomTPIData}
            bottomTPIColumns={bottomTPIColumns}
            methodSpecificData={methodSpecificData}
            methodSpecificColumns={methodSpecificColumns}
            methodSecondaryData={methodSecondaryData}
            methodSecondaryDataColumns={methodSecondaryDataColumns}
            tenNinetyStartDate={tenNinetyStartDate}
            tenNinetyEndDate={tenNinetyEndDate}
            handleTenNinetyDateChange={handleTenNinetyDateChange}
            currentSampleSchedules={currentSampleSchedules}
            sampleScheduleColumnsNew={sampleScheduleColumnsNew}
            handleAddSchedule={handleAddSchedule}
            showScheduleModal={showScheduleModal}
            setShowScheduleModal={setShowScheduleModal}
            scheduleModalType={scheduleModalType}
            currentModalSchedule={currentModalSchedule}
            handleDescriptionChange={handleDescriptionChange}
            handleFrequencyChange={handleFrequencyChange}
            handleTimeChange={handleTimeChange}
            renderTimesOptions={renderTimesOptions}
            handleStartDateChange={handleStartDateChange}
            handleTimezoneChange={handleTimezoneChange}
            renderTimezoneOptions={renderTimezoneOptions}
            handleSaveSchedule={handleSaveSchedule}
            currentRegularSampleEntries={currentRegularSampleEntries}
            regularSampleEntryColumns={regularSampleEntryColumns}
            handleAddRegularEntry={handleAddRegularEntry}
            showRegularEntryModal={showRegularEntryModal}
            setShowRegularEntryModal={setShowRegularEntryModal}
            regularEntryModalType={regularEntryModalType}
            currentModalRegularEntry={currentModalRegularEntry}
            handleRegularStartDateChange={handleRegularStartDateChange}
            handleRegularPeriodChange={handleRegularPeriodChange}
            handleSaveRegularEntry={handleSaveRegularEntry}
            assignedSamplesData={assignedSamplesData}
            assignedSamplesTableColumns={assignedSamplesTableColumns}
            archiveData={archiveData}
            archiveColumns={archiveColumns}
            runUnArchiveFunctions={runUnArchiveFunctions}
            runDataFunction={runDataFunction}
            setChartLoading={setChartLoading}
            checkedCombinedInitialAssessment={checkedCombinedInitialAssessment}
            controlStatusData={controlStatusData}
            controlStatusColumns={controlStatusColumns}
            isDeleteAllData={isDeleteAllData}
            setIsDeleteAllData={setIsDeleteAllData}
            openCofirmDeleteAllData={openCofirmDeleteAllData}
            setOpenCofirmDeleteAllData={setOpenCofirmDeleteAllData}
            confirmationInput={confirmationInput}
            handleConfirmationInputChange={handleConfirmationInputChange}
            error={error}
            isDeleteDisabled={isDeleteDisabled}
            chartLoading={chartLoading}
            handleConfirmDelete={handleConfirmDelete}
            config={config}
            showUpdateChartSigDigitsModal={showUpdateChartSigDigitsModal}
            setShowUpdateChartSigDigitsModal={setShowUpdateChartSigDigitsModal}
            currentLocations={currentLocations}
            saveConfigurations={saveConfigurations}
            renderButton={renderButton}
            updateStateConfigurations={updateStateConfigurations}
            showArchiveModal={showArchiveModal}
            setShowArchiveModal={setShowArchiveModal}
          />
          <ArchiveRestartModal
            isShowModal={showArchiveModal}
            setShowModal={setShowArchiveModal}
            columns={columns}
            filteredChartHits={filteredChartHits}
            archiveDataFunction={archiveDataFunction}
            runArchiveDataFunction={runArchiveDataFunction}
            currentShortKey={currentShortKey}
            currentFullKey={currentFullKey}
            currentParameter={currentParameter}
            checkedCombinedInitialAssessment={checkedCombinedInitialAssessment}
            currentControlStrategyConfigurations={currentControlStrategyConfigurations}
            currentChartGroupConfigurations={currentChartGroupConfigurations}
            setChartLoading={setChartLoading}
          />
        </>
      );
    }
    if (section === 'DataEntry') {
      if (
        !isAdmin(permissionData) &&
        !checkHasPermission(permissionData?.[SCREEN?.DATA_ENTRY], RULES.VIEW)
      ) {
        return <></>;
      }
      return (
        <DataEntrySection
          locations={allLocations}
          methods={allMethods}
          samples={allSampleNames}
          instruments={allInstruments}
          data={dataEntrySectionData}
          location={currentLocation}
          method={currentMethod}
          sampleName={currentSampleName}
          instrument={currentInstrument}
          parameter={currentParameter}
          recheckConfig={currentChartGroupConfigurations.autoCreateSampleRecheck}
          tz={tz}
          currentLocation={currentLocation}
          exportFullKeysToCSV={exportFullKeysToCSV}
          setIndexes={setIndexes}
        />
      );
    }
    if (section === 'Assessments') {
      if (
        !isAdmin(permissionData) &&
        !checkHasPermission(permissionData?.[SCREEN?.ASSESSMENTS], RULES.VIEW)
      ) {
        return <></>;
      }
      return (
        <AssessmentsSection
          currentFullKey={currentFullKey}
          summaryStatisticsAssessmentData={summaryStatisticsAssessmentData}
          summaryStatisticsAssessmentColumns={summaryStatisticsAssessmentColumns}
          currentAssessments={currentAssessments}
          filteredChartHits={filteredChartHits}
          chartData={chartData}
          chartScalars={chartScalars}
          currentInstrument={currentInstrument}
          currentMethod={currentMethod}
          currentShortKey={currentShortKey}
          unit={unit}
          tz={tz}
          dateTimeFormat={dateTimeFormat}
          chartLines={chartLines}
          processChartData={processChartData}
          allParams={allParams}
          injectLimitsToData={injectLimitsToData}
        />
      );
    }
    if (section === 'Reports') {
      if (
        !isAdmin(permissionData) &&
        !checkHasPermission(permissionData?.[SCREEN?.REPORT], RULES.VIEW)
      ) {
        return <></>;
      }
      return (
        <ReportsSection
          filteredChartHits={filteredChartHits}
          chartData={chartData}
          chartScalars={chartScalars}
          currentInstrument={currentInstrument}
          currentMethod={currentMethod}
          currentShortKey={currentShortKey}
          permissionData={permissionData}
          radioArchiveValue={radioArchiveValue}
          unit={unit}
        />
      );
    }
    if (section === 'ReportIssue') {
      if (!activeItems.instrument) {
        return <></>;
      }
      return <ReportIssueSection />;
    }
    return <></>;
  }
  const openCurrentAssessment = () => {
    if (chartButtonText === 'Perform Periodic Assessment') {
      const newPeriodicAssessment = newAssessmentPeriodic();
      setModalAssessment(newPeriodicAssessment);
      setShowPeriodicModal(true);
      setShowModal(false);
      return;
    }

    const allAssessments = newAssessment(chartControlStrategySnapshot, isNonUs);
    const isInitialAssessment = chartButtonText === 'Perform Initial Assessment';
    const mostRecent = currentAssessments[currentAssessments.length - 1];
    if (currentAssessments.length > 0 && !isInitialAssessment) {
      if (mostRecent.outcome === 'Pass') {
        setModalAssessment(mostRecent);
        setModalMode('view');

        const firstParam =
          mostRecent.chartDataSnapshot && Object.keys(mostRecent.chartDataSnapshot).length > 0
            ? Object.keys(mostRecent.chartDataSnapshot)[0]
            : Object.keys(mostRecent).length > 0
              ? Object.keys(mostRecent)[0]
              : null;

        setCurrentParameter(firstParam);

        if (mostRecent.type === 'Initial') {
          setShowModal(true);
        } else {
          setShowPeriodicModal(true);
        }
      } else {
        setModalAssessment(allAssessments);
        setModalMode('save');

        const firstParam = Object.keys(allAssessments)[0];
        setCurrentParameter(firstParam);
        setShowModal(true);
      }
    } else {
      if (
        shouldFetchMultiple &&
        (!chartControlStrategySnapshot || Object.keys(chartControlStrategySnapshot).length === 0)
      ) {
        console.warn('Control strategy snapshot not ready yet.');
        return;
      }
      setModalAssessment(allAssessments);
      setModalMode('save');

      const firstParam = Object.keys(allAssessments)[0];
      setCurrentParameter(firstParam);
      setShowModal(true);
    }
  };

  function renderChartButton(chartStageSelected) {
    if (chartStageSelected !== 'In Development') {
      return (
        <div>
          {/* <PrimaryButton
            clicked={() => openCurrentAssessment()}
            text={chartButtonText}
          ></PrimaryButton> */}

          {isAdmin(permissionData) &&
            renderButton(chartButtonText, () => openCurrentAssessment(), SCREEN?.DATA, RULES.SAVE)}
        </div>
      );
    }
    return <></>;
  }

  function renderArchiveAlert(archive) {
    const alertToReturn = [];
    if (archive === 'Yes') {
      alertToReturn.push(
        <div className="archive-alert">
          <Alert key="warning" dismissible variant="info">
            This data set has been archived and is read-only.
          </Alert>
        </div>
      );
    } else {
      alertToReturn.push(<></>);
    }
    return alertToReturn;
  }

  function renderChartStatusFinal(activeTabSelected) {
    const fullKeyComplete =
      currentLocation &&
      currentMethod &&
      currentSampleName &&
      currentInstrument &&
      currentParameter;
    if (activeTabSelected === 'Overview' && fullKeyComplete) {
      return (
        <>
          <div className="header">
            <h2>Overview</h2>
          </div>
          <div className="underline-header">
            <hr />
          </div>
          <div key={uuidv4()} className="chart-status-section">
            {currentControlStrategyConfigurations.controlStatus === 'No' ? (
              <>
                <div>
                  <h3>Chart Stage: Active</h3>
                </div>
              </>
            ) : (
              <>
                <div>
                  <h3>Chart Stage: {chartStage}</h3>
                </div>
                {renderChartButton(chartStage)}
              </>
            )}
          </div>
          {renderArchiveAlert(currentControlStrategyConfigurations.archive)}
        </>
      );
    }
    return <></>;
  }

  useEffect(() => {
    if (Array.isArray(methods) && methods.length > 0) {
      const methodsDropdown = [];
      const parametersDropdown = [];
      methods.forEach((method) => {
        const methodToReturn = {
          id: method.id,
          value: `${method.method}`,
          label: `${method.method}`
        };
        const parameterToReturn = {
          value: method.parameter,
          label: method.parameter
        };
        if (!parametersDropdown.find((parameter) => parameter.value === method.parameter)) {
          parametersDropdown.push(parameterToReturn);
        }
        if (!methodsDropdown.find((dropdownItem) => dropdownItem.value === `${method.method}`)) {
          methodsDropdown.push(methodToReturn);
        }
      });
      methodsDropdown.sort(textSort);
      parametersDropdown.sort(textSort);
      setCurrentParametersDropdown(parametersDropdown);
      setCurrentMethodsDropdown(methodsDropdown);
    }
  }, [methods]);

  useEffect(() => {
    if (Array.isArray(chartHits)) {
      const filteredHits = chartHits.filter((hit) => {
        if (radioArchiveValue === 'Active') {
          return !archiveRegex.test(hit.parameter);
        } else if (radioArchiveValue === 'Archive') {
          return archiveRegex.test(hit.parameter);
        }
        return false;
      });

      setFilteredChartHits(
        filteredHits
          .map((cd, index) => {
            const wFlags = wFlagColumns.map((f) => cd[f]).filter(isValidFlag);
            const oocFlags = oocFlagColumns.map((f) => cd[f]).filter(isValidFlag);
            const row = {
              index,
              flags: `${wFlags.length > 0 ? `Warnings: ${wFlags.join(', ')}` : ''}${
                wFlags.length > 0 && oocFlags.length > 0 ? '; ' : ''
              }${oocFlags.length > 0 ? `OOC: ${oocFlags.join(', ')}` : ''}`
            };
            for (const elt of Object.keys(cd)) {
              if (['date'].includes(elt)) {
                row[elt] = cd[elt];
              } else if (['objectID'].includes(elt)) {
                row[elt] = cd[elt];
              } else if (
                ![
                  'instrument',
                  'parameter',
                  'location',
                  'sampleName',
                  'method',
                  'sampleId'
                ].includes(elt) &&
                isNumericPlaceholder(cd[elt])
              ) {
                // Upstream may write "#N/A", "---", etc. for rows where a
                // numeric calculation produced no value (e.g. moving-range
                // limits on the first observation). Recharts treats these as
                // a string "0" and can blank Lines that read them per-row, so
                // collapse to null and let it draw a gap. Exclude string-label
                // fields so a sample literally named "N/A" isn't nulled.
                row[elt] = null;
              } else if (
                String(cd[elt]).match(/[A-Z]/i) ||
                [
                  'instrument',
                  'parameter',
                  'location',
                  'sampleName',
                  'method',
                  'sampleId'
                ].includes(elt)
              ) {
                row[elt] = cd[elt];
              } else if (!Number.isNaN(parseFloat(cd[elt]))) {
                // parseFloat succeeds but Number() may still be NaN for a typo'd
                // number like "10..5" / "16.3.4" / "110.0`" — keep the raw value
                // (don't coerce to NaN) so it stays visible in the table and the
                // row-nonnumeric highlight can flag it for correction.
                const coerced = Number(cd[elt]);
                row[elt] = Number.isNaN(coerced) ? cd[elt] : coerced; // 3 decimal places max
              } else if (elt !== 'flags') {
                row[elt] = cd[elt];
              }
            }
            if (row.dateTime) {
              const timeZone = tz || 'UTC';
              if (typeof row.dateTime !== 'string') {
                row.dateTime = 'Invalid date';
              } else {
                const theDate = new Date(row.dateTime);

                if (isNaN(theDate.getTime())) {
                  row.dateTime = 'Invalid date';
                } else {
                  row.date = formatInTimeZone(theDate, timeZone, 'M/d/yyyy');
                  row.time = formatInTimeZone(theDate, timeZone, 'h:mm aaa');
                }
              }
            }
            // Format Result, Average (mean), LCL (sd3n) and UCL (sd3p) to the
            // key's Chart Axis Significant Digits, so the limit fields match
            // Result instead of showing raw 13+ decimal floats.
            return formatRowSigDigits(row, currentControlStrategyConfigurations.chartSigDigits);
          })
          .sort((a, b) => {
            const aTime = new Date(a.dateTime).getTime();
            const bTime = new Date(b.dateTime).getTime();
            if (isNaN(aTime)) return 1;
            if (isNaN(bTime)) return -1;
            return aTime - bTime;
          })
      );
    }
  }, [chartHits, currentChartGroupConfigurations, currentControlStrategyConfigurations]);

  function processChartData(filteredChartHits, currentControlStrategyConfigurations) {
    const completeChartData = filteredChartHits.some((chartHit) =>
      Object.prototype.hasOwnProperty.call(chartHit, 'resultOmits')
    );
    if (!completeChartData) return { chartData: [], chartScalars: {}, chartDataComplete: false };
    const newChartData = filteredChartHits
      // Keep only items with resultOmits value
      .filter((cd) => !!cd.resultOmits || parseInt(cd.resultOmits, 10) === 0)
      // Filter out items omitted from SQC or silenced (see isIncludedInSqcChartSeries)
      .filter(isIncludedInSqcChartSeries)
      // Filter out items with empty or invalid dateTime
      .filter((cd) => cd.dateTime && !isNaN(Date.parse(cd.dateTime)));

    if (newChartData.length === 0)
      return { chartData: [], chartScalars: {}, chartDataComplete: false };

    const rs = newChartData.map((d) => Number(d.resultOmits)).filter((r) => isFinite(r));
    const sortedRs = [...rs].sort((a, b) => a - b);
    let rMin, rMax;
    if (sortedRs.length >= 10) {
      const q1 = sortedRs[Math.floor(sortedRs.length * 0.25)];
      const q3 = sortedRs[Math.floor(sortedRs.length * 0.75)];
      const iqr = q3 - q1;
      if (iqr === 0) {
        // Fall back to full dataset range when there's no variation in Q1-Q3
        rMin = sortedRs[0];
        rMax = sortedRs[sortedRs.length - 1];
      } else {
        const lowerFence = q1 - 1.5 * iqr;
        const upperFence = q3 + 1.5 * iqr;
        const inliers = sortedRs.filter((v) => v >= lowerFence && v <= upperFence);
        rMin = inliers.length > 0 ? inliers[0] : sortedRs[0];
        rMax = inliers.length > 0 ? inliers[inliers.length - 1] : sortedRs[sortedRs.length - 1];
      }
    } else {
      rMin = sortedRs.length > 0 ? sortedRs[0] : 0;
      rMax = sortedRs.length > 0 ? sortedRs[sortedRs.length - 1] : 0;
    }
    const lastItem = newChartData[newChartData.length - 1];
    const sd3nVal = parseFloat(lastItem?.sd3n);
    const sd3pVal = parseFloat(lastItem?.sd3p);
    const topYMin = isFinite(sd3nVal) ? Math.min(rMin, sd3nVal) : rMin;
    const topYMax = isFinite(sd3pVal) ? Math.max(rMax, sd3pVal) : rMax;
    const topYInterval = topYMax - topYMin;

    const mrMean = arrayAverage(newChartData.map((d) => d.mrOmits));
    const dateTrend = newChartData
      .map((item) => ({
        zScoreOmits: Number(item.zScoreOmits),
        resultOmits: Number(item.resultOmits)
      }))
      .filter((p) => !Number.isNaN(p.zScoreOmits) && !Number.isNaN(p.resultOmits));

    let trend = null;

    if (dateTrend.length >= 2) {
      const uniqueX = new Set(dateTrend.map((d) => d.zScoreOmits));
      if (uniqueX.size > 1) {
        trend = createTrend(dateTrend, 'zScoreOmits', 'resultOmits');
      }
    }

    const zscores = newChartData.map((d) => Number(d.zScoreOmits));
    const newResults = newChartData.map((d) => Number(d.resultOmits));
    const mrs = newChartData
      .filter((d) => !Number.isNaN(parseFloat(d.mrOmits)))
      .map((d) => parseFloat(d.mrOmits));
    const sortedMrs = [...mrs].sort((a, b) => a - b);
    let mrMaxVal;
    if (sortedMrs.length >= 10) {
      const mrQ1 = sortedMrs[Math.floor(sortedMrs.length * 0.25)];
      const mrQ3 = sortedMrs[Math.floor(sortedMrs.length * 0.75)];
      const mrIqr = mrQ3 - mrQ1;
      if (mrIqr === 0) {
        // Fall back to full dataset range when there's no variation in Q1-Q3
        mrMaxVal = sortedMrs[sortedMrs.length - 1];
      } else {
        const mrUpperFence = mrQ3 + 1.5 * mrIqr;
        const mrInliers = sortedMrs.filter((v) => v <= mrUpperFence);
        mrMaxVal =
          mrInliers.length > 0 ? mrInliers[mrInliers.length - 1] : sortedMrs[sortedMrs.length - 1];
      }
    } else {
      mrMaxVal = sortedMrs.length > 0 ? sortedMrs[sortedMrs.length - 1] : 0;
    }
    const mrUCL = mrMean * 3.27;
    const mrMax = Math.max(mrUCL, mrMaxVal);
    const validZscores = zscores.filter((z) => isFinite(z));
    const validResults = newResults.filter((r) => isFinite(r));
    const sortedResults = [...validResults].sort((a, b) => a - b);
    let yMin, yMax;
    if (sortedResults.length >= 10) {
      const rq1 = sortedResults[Math.floor(sortedResults.length * 0.25)];
      const rq3 = sortedResults[Math.floor(sortedResults.length * 0.75)];
      const riqr = rq3 - rq1;
      if (riqr === 0) {
        // Fall back to full dataset range when there's no variation in Q1-Q3
        yMin = sortedResults[0];
        yMax = sortedResults[sortedResults.length - 1];
      } else {
        const rLower = rq1 - 1.5 * riqr;
        const rUpper = rq3 + 1.5 * riqr;
        const rInliers = sortedResults.filter((v) => v >= rLower && v <= rUpper);
        yMin = rInliers.length > 0 ? rInliers[0] : sortedResults[0];
        yMax =
          rInliers.length > 0
            ? rInliers[rInliers.length - 1]
            : sortedResults[sortedResults.length - 1];
      }
    } else {
      yMin = sortedResults.length > 0 ? sortedResults[0] : 0;
      yMax = sortedResults.length > 0 ? sortedResults[sortedResults.length - 1] : 0;
    }
    const xMin = validZscores.length > 0 ? Math.min(...validZscores) : 0;
    const xMax = validZscores.length > 0 ? Math.max(...validZscores) : 0;

    for (const data of newChartData) {
      data.formattedDate = new Date(data.date);
      if (!data.notes) data.notes = '';
    }

    const sortedAsc = newChartData
      .filter((d) => !isNaN(Date.parse(d.date)))
      .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));

    let personnelNames = [];

    sortedAsc.forEach((data, index) => {
      data.updatedIndex = index;

      let config = null;
      const baseConfig = currentControlStrategyConfigurations;

      if (typeof baseConfig === 'object' && !Array.isArray(baseConfig)) {
        const param = data.parameter || data.chartParameter || '';
        if (param && baseConfig[param]) {
          config = baseConfig[param];
        }
      } else {
        config = baseConfig;
      }

      data.userDefinedUTL = config?.upperToleranceLimit ?? null;
      data.userDefinedLTL = config?.lowerToleranceLimit ?? null;
      data.userDefinedUCL = config?.upperControlLimit ?? null;
      data.userDefinedLCL = config?.lowerControlLimit ?? null;

      personnelNames.push(data.personnel);
    });

    personnelNames = uniq(personnelNames);
    const analystsDots = [];
    const updatedPersonnelNames = [];

    personnelNames.forEach((name) => {
      const color = randomDarkColor();
      analystsDots.push({ analyst: name, color });
      updatedPersonnelNames.push({ name, checked: true, color });
    });

    const setupDataOne = sortedAsc.filter((d) => d.setupData === 1);
    const setupDataZero = sortedAsc.filter((d) => d.setupData === 0);

    return {
      chartData: sortedAsc,
      chartScalars: {
        mrMean,
        mrUCL,
        mrYMax: mrMax * 1.05,
        trendData: trend
          ? [
              { y: trend.calcY(xMin), x: xMin },
              { y: trend.calcY(xMax), x: xMax }
            ]
          : [],
        qqXMin: xMin,
        qqXMax: xMax,
        qqYMin: yMin,
        qqYMax: yMax,
        cYMin: topYMin - 0.05 * topYInterval,
        cYMax: topYMax + 0.05 * topYInterval,
        histogramData: calculateHistogram(newChartData, yMin, yMax)
      },
      chartDataComplete: true,
      personnelNames: updatedPersonnelNames,
      personnelDots: analystsDots,
      setupDataOneCount: setupDataOne.length,
      setupDataZeroCount: setupDataZero.length,
      // newChartData already excludes omitted points (isIncludedInSqcChartSeries).
      includedPointCount: sortedAsc.length
    };
  }

  useEffect(() => {
    if (
      currentLocation &&
      currentMethod &&
      currentSampleName &&
      currentInstrument &&
      currentParameter &&
      Array.isArray(filteredChartHits) &&
      currentControlStrategyConfigurations
    ) {
      try {
        const {
          chartData,
          chartScalars,
          chartDataComplete,
          personnelNames,
          personnelDots,
          setupDataOneCount,
          setupDataZeroCount,
          includedPointCount
        } = processChartData(filteredChartHits, currentControlStrategyConfigurations);
        const enrichedChartData = Array.isArray(chartData)
          ? chartData.map((dataPoint, index) => {
              const updated = {
                ...dataPoint,
                userDefinedUTL: currentControlStrategyConfigurations.upperToleranceLimit,
                userDefinedLTL: currentControlStrategyConfigurations.lowerToleranceLimit,
                userDefinedUCL: currentControlStrategyConfigurations.upperControlLimit,
                userDefinedLCL: currentControlStrategyConfigurations.lowerControlLimit
              };
              return updated;
            })
          : [];

        setChartData(enrichedChartData);
        setChartScalars(chartScalars);
        setChartDataComplete(chartDataComplete);
        setCurrentPersonnelNames(personnelNames);
        setCurrentPersonnelDots(personnelDots);
        setCurrentSetupDataOne(setupDataOneCount);
        setCurrentSetupDataZero(setupDataZeroCount);
        setCurrentIncludedPointCount(includedPointCount || 0);
      } catch (err) {
        console.error('Failed to process and update chart data:', err);
      }
    }
  }, [
    currentLocation,
    currentMethod,
    currentSampleName,
    currentInstrument,
    currentParameter,
    filteredChartHits,
    currentControlStrategyConfigurations
  ]);

  const handleActiveTabWithPermission = () => {
    if (isAdmin(permissionData) || checkHasPermission(permissionData?.[SCREEN?.DATA], RULES.VIEW)) {
      setActiveTab('Overview');
    } else if (checkHasPermission(permissionData?.[SCREEN?.COMPARISON], RULES.VIEW)) {
      setActiveTab('Comparison');
    } else if (activeItems.instrumentLimits) {
      setActiveTab('Instrument Limits');
    } else if (checkHasPermission(permissionData?.[SCREEN?.CONFIG], RULES.VIEW)) {
      setActiveTab('Configuration');
    } else if (checkHasPermission(permissionData?.[SCREEN?.ASSESSMENTS], RULES.VIEW)) {
      setActiveTab('Assessments');
    } else if (checkHasPermission(permissionData?.[SCREEN?.REPORT], RULES.VIEW)) {
      setActiveTab('Reports');
    } else if (checkHasPermission(permissionData?.[SCREEN?.DATA_ENTRY], RULES.VIEW)) {
      setActiveTab('DataEntry');
    } else if (activeItems.instrument) {
      setActiveTab('ReportIssue');
    } else {
      setActiveTab('');
    }
  };

  const handleSelect = (e) => {
    setActiveTab(e);
  };

  const initialTabSet = useRef(false);
  useEffect(() => {
    if (permissionData && !initialTabSet.current && Object.keys(permissionData).length !== 0) {
      handleActiveTabWithPermission();
      initialTabSet.current = true;
    } else {
      setActiveTab('');
    }
  }, [permissionData]);

  const handleArchiveToggleChange = (e) => {
    const value = e.currentTarget.value; // Get the selected toggle value
    setRadioArchiveValue(value);

    // Update the URL with the new mode and clear other parameters
    const query = { mode: value.toLowerCase() };
    history.push({ search: qs.stringify(query) });

    // Reset the state
    setCurrentIndexes(value === 'Archive' ? [...currentArchiveIndexes] : [...currentActiveIndexes]);
    setCurrentLocation('');
    setCurrentMethod('');
    setCurrentSampleName('');
    setCurrentInstrument('');
    setCurrentParameter('');
    setIsSelectCombinedZScore(false);
    setCombinedZScoreData([]);
  };

  useEffect(() => {
    if (currentLocation && currentMethod && currentSampleName && currentInstrument) {
      generateValueForParametersDynamic(currentParametersDynamic);
      if (!loading) {
        loadCombineZScoreParameter();
      }
      setIsSelectCombinedZScore(
        (isAdmin(permissionData) || isContributor(permissionData)) &&
          currentParameter === defaultCombinedParameterName
      );
    }
  }, [
    currentLocation,
    currentMethod,
    currentSampleName,
    currentInstrument,
    currentParameter,
    currentParameters
  ]);

  const generateValueForParametersDynamic = (currentParameters) => {
    const existCombineZScore =
      currentParameters.find((item) => item.name === defaultCombinedParameterName) !== undefined;
    const updatedParameters = [...currentParameters];
    if (!existCombineZScore && radioArchiveValue === 'Active') {
      if (updatedParameters.length > 1) {
        updatedParameters.push({ name: defaultCombinedParameterName });
      }
    }
    setCurrentParametersDynamic(updatedParameters);
  };

  const loadCombineZScoreParameter = async () => {
    const shortKey = `${currentLocation}|${currentMethod}|${currentSampleName}|${currentInstrument}`;
    const configCombine = await readCombineZScoreParameter(shortKey);
    if (configCombine) {
      setConfigCombineZScore(configCombine);
      const parameterData = configCombine.parameters.map((item) => {
        return {
          parameter: item
        };
      });
      setCombinedZScoreData(parameterData);
    } else {
      setConfigCombineZScore(null);
      setCombinedZScoreData([]);
    }
  };

  const addCombineZScoreData = async (rows, isRefresh = false, parameterRequest) => {
    let i = 0;
    const filterBySetupData = rows
      .filter((item) => item.result !== null)
      .map((item) => {
        if (item.setupData === 1) {
          i = i + 1;
        }
        if (i <= 26) {
          return item;
        } else {
          return {
            ...item,
            setupData: 0
          };
        }
      });

    if (isRefresh) {
      // check update
      const updateList = [];
      const addList = [];
      filterBySetupData.forEach((item) => {
        const updateData = filteredChartHits.find((value) => {
          const A = moment(value.dateTime)
            .tz(tz || 'UTC')
            .format(FORMAT_KEY_TIME);
          const B = moment(item.dateTime)
            .tz(tz || 'UTC')
            .format(FORMAT_KEY_TIME);
          return A == B;
        });
        if (updateData) {
          updateList.push({
            ...updateData,
            result: item.result,
            dateTime: moment(item.dateTime).toISOString()
          });
        } else {
          addList.push({ ...item, dateTime: moment(item.dateTime).toISOString() });
        }
      });

      const addDataRequest = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        rows: addList
      };

      if (updateList.length > 0) {
        const updateDataRequest = {
          location: currentLocation,
          method: currentMethod,
          instrument: currentInstrument,
          rows: updateList
        };
        await editDataFunction(updateDataRequest);
      }

      if (addList.length > 0) {
        await addDataFunction(addDataRequest);
        await updateCombineConfig(parameterRequest);
      } else if (updateList.length > 0) {
        runData();
      }
      setLoading(false);
    } else {
      const addDataRequest = {
        location: currentLocation,
        method: currentMethod,
        instrument: currentInstrument,
        rows: filterBySetupData
      };

      addDataFunction(addDataRequest)
        .then(async () => {
          await updateCombineConfig(parameterRequest);
          setLoading(false);
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const startRunCombineZScore = (isRefresh = false) => {
    setLoading(true);
    const parameterRequest = combinedZScoreData.map((item) => item.parameter);
    const request = {
      location: currentLocation,
      method: currentMethod,
      instrument: currentInstrument,
      sampleName: currentSampleName,
      parameter: parameterRequest,
      isRefresh
    };
    runCombineZScore(request)
      .then(async ({ data }) => {
        if (data && data.listMissingParameter.length > 0) {
          setLoading(false);
          let message = '';
          if (data.listMissingParameter && data.listMissingParameter.length > 0) {
            const parameterMessages = data.listMissingParameter.map((item) => (
              <p key={`parameter-${item.sampleId}`}>
                <span
                  style={{
                    fontWeight: 'bold',
                    color: '#007bff'
                  }}
                >
                  [{item.time}]
                </span>{' '}
                <span
                  style={{
                    fontWeight: 'bold',
                    color: '#28a745'
                  }}
                >
                  [{item.sampleId}]
                </span>
                : {item.missingParameter?.join(', ')}
              </p>
            ));
            message = (
              <div>
                <div
                  style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '10px',
                    borderRadius: '5px'
                  }}
                >
                  ----- Missing parameter ({parameterMessages.length}) -----
                </div>
                <div
                  style={{
                    maxHeight: '500px',
                    overflowY: 'auto',
                    border: '1px solid #ccc',
                    marginTop: '10px',
                    padding: '10px',
                    borderRadius: '5px'
                  }}
                >
                  {parameterMessages}
                </div>
              </div>
            );
          } else {
            message = data.message;
          }

          setErrorData({
            title: 'Missing result value',
            message,
            textButton: 'Cancel',
            rows: data.rows,
            isRefresh: isRefresh,
            parameterRequest,
            skip: 'Skip'
          });
          setShowError(true);
        } else {
          const { rows } = data || [];
          addCombineZScoreData(rows, isRefresh, parameterRequest);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const updateCombineConfig = async (parameterRequest) => {
    if (configCombineZScore) {
      // update current config
      const updateRequest = {
        ...configCombineZScore,
        parameters: parameterRequest
      };
      delete updateRequest.id;
      await updateCombineZScoreParameter(configCombineZScore.id, updateRequest);
    } else {
      // create new config
      const shortKey = `${currentLocation}|${currentMethod}|${currentSampleName}|${currentInstrument}`;
      const combineConfigData = {
        shortKey: shortKey,
        parameters: parameterRequest
      };
      await createCombineZScoreParameter(combineConfigData);
    }
  };

  const renderArchiveToggle = () => {
    const radios = [
      { name: 'Active', value: 'Active' },
      { name: 'Archive', value: 'Archive' }
    ];
    const buttonToReturn = [];
    const matchingUser = currentPersonnel.find((p) => p.email === auth.user.email);
    if (matchingUser) {
      if (matchingUser.permission === 'Administrator') {
        buttonToReturn.push(
          <div className="archive-toggle-container">
            <ButtonGroup variant="outlined">
              {radios.map((radio) => (
                <MuiButton
                  variant={radioArchiveValue === radio.value ? 'contained' : 'outlined'}
                  onClick={handleArchiveToggleChange}
                  value={radio.value}
                  sx={{
                    textTransform: 'none',
                    backgroundColor: radioArchiveValue === radio.value ? 'rgb(0, 0, 128)' : '',
                    color: radioArchiveValue === radio.value ? '' : 'rgb(0, 0, 128)',
                    borderColor: 'rgb(0, 0, 128)'
                  }}
                >
                  {radio.value}
                </MuiButton>
              ))}
            </ButtonGroup>
          </div>
        );
      } else {
        buttonToReturn.push(<></>);
      }
    }
    return buttonToReturn;
  };

  const buildOrderParameters = (currentParametersDynamic) => {
    if (orderOfParameters && orderOfParameters[0] && orderOfParameters[0][currentShortKey]) {
      const paramsOrdered = orderOfParameters[0][currentShortKey];
      return currentParametersDynamic.map((param) => {
        return { ...param, order: paramsOrdered[param.name] || 0 };
      });
    }
    return currentParametersDynamic;
  };

  let dropDownBlock;
  if (instrumentBeforeSampleName) {
    dropDownBlock = (
      <>
        <Form.Group as={Col} controlId="instrument">
          <Form.Label>Instrument</Form.Label>
          <Form.Select
            value={currentInstrument || 'Select instrument'}
            onChange={handleInstrumentChange}
            aria-label="Default select example"
          >
            <option value="">Select instrument</option>
            {renderOptionsDynamic(currentInstruments)}
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col} controlId="sampleName">
          <Form.Label>Sample Name</Form.Label>
          <Form.Select
            value={currentSampleName || 'Select sample name'}
            onChange={handleSampleNameChange}
            aria-label="Default select example"
          >
            <option value="">Select sample name</option>
            {renderOptionsDynamic(currentSampleNames)}
          </Form.Select>
        </Form.Group>
      </>
    );
  } else {
    dropDownBlock = (
      <>
        <Form.Group as={Col} controlId="sampleName">
          <Form.Label>Sample Name</Form.Label>
          <Form.Select
            value={currentSampleName || 'Select sample name'}
            onChange={handleSampleNameChange}
            aria-label="Default select example"
          >
            <option value="">Select sample name</option>
            {renderOptionsDynamic(currentSampleNames)}
          </Form.Select>
        </Form.Group>
        <Form.Group as={Col} controlId="instrument">
          <Form.Label>Instrument</Form.Label>
          <Form.Select
            value={currentInstrument || 'Select instrument'}
            onChange={handleInstrumentChange}
            aria-label="Default select example"
          >
            <option value="">Select instrument</option>
            {renderOptionsDynamic(currentInstruments)}
          </Form.Select>
        </Form.Group>
      </>
    );
  }
  if (!auth.permissionsReady) {
    return <Loading />;
  }
  return (
    <>
      <Meta title="QC Data and Charts" />
      <ChartContext.Provider
        value={{
          currentChartGroupConfigurations,
          currentControlStrategyConfigurations,
          filteredShortKeyData,
          filteredChartHits,
          currentLocation,
          currentMethod,
          currentSampleName,
          currentInstrument,
          currentParameter,
          currentShortKey,
          currentFullKey,
          currentSummary,
          resultsDataTableData,
          chartData,
          permissionData,
          personnel,
          currentPersonnel,
          summaries
        }}
      >
        <Row className="mb-3 global-dropdowns">
          <Form.Group as={Col} controlId="location">
            <Form.Label>Location</Form.Label>

            {activeTab === 'PrintOverview' ? (
              <Form.Control type="text" value={getLaboratoryOnly(currentLocation)} readOnly />
            ) : (
              <Form.Select
                value={currentLocation}
                onChange={handleLocationChange}
                aria-label="Location select"
              >
                <option value="">Select location</option>
                {renderLocationOptions(allLocations)}
              </Form.Select>
            )}
          </Form.Group>

          <Form.Group as={Col} controlId="method">
            <Form.Label>Method</Form.Label>
            <Form.Select
              value={currentMethod || 'Select method'}
              onChange={handleMethodChange}
              aria-label="Default select example"
            >
              <option value="">Select method</option>
              {renderOptionsDynamic(currentMethods)}
            </Form.Select>
          </Form.Group>
          {dropDownBlock}
          <Form.Group as={Col} controlId="parameter">
            <Form.Label>Parameter</Form.Label>
            <Form.Select
              value={currentParameter || 'Select parameter'}
              onChange={handleParameterChange}
              aria-label="Default select example"
            >
              <option value="">Select parameter</option>
              {renderOptionsDynamicParameter(buildOrderParameters(currentParametersDynamic))}
            </Form.Select>
          </Form.Group>
          {isSelectCombinedZScore && (
            <Form.Group as={Col} controlId="select-combined" md={3} style={{ paddingTop: '8px' }}>
              <Form.Label></Form.Label>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row'
                }}
              >
                {isAdmin(permissionData) && (
                  <div style={{ marginRight: '16px' }}>
                    {renderButtonWithPermissions(
                      'Select Parameter',
                      () => setShowCombinedZScoreModal(true),
                      SCREEN?.DATA,
                      RULES.CREATE,
                      permissionData,
                      true
                    )}
                  </div>
                )}
                {renderLoadingButton({
                  buttonText: 'Refresh Z-Score',
                  hasLoading: true,
                  isLoading: loading,
                  onClick: () => startRunCombineZScore(true)
                })}
              </div>
            </Form.Group>
          )}
        </Row>
        {renderArchiveToggle()}
        <Tabs
          activeKey={activeTab}
          id="uncontrolled-tab-example"
          className="tri-tabs"
          onSelect={handleSelect}
        >
          {(isAdmin(permissionData) ||
            checkHasPermission(permissionData?.[SCREEN?.DATA], RULES.VIEW)) && (
            <Tab eventKey="Overview" title="Overview" />
          )}
          {(isAdmin(permissionData) ||
            checkHasPermission(permissionData?.[SCREEN?.COMPARISON], RULES.VIEW)) && (
            <Tab eventKey="Comparison" title="Comparison" />
          )}
          {activeItems.instrumentLimits && (
            <Tab eventKey="Instrument Limits" title="Instrument Limits" />
          )}
          {(isAdmin(permissionData) ||
            checkHasPermission(permissionData?.[SCREEN?.CONFIG], RULES.VIEW)) && (
            <Tab eventKey="Configuration" title="Configuration" />
          )}
          {(isAdmin(permissionData) ||
            checkHasPermission(permissionData?.[SCREEN?.ASSESSMENTS], RULES.VIEW)) && (
            <Tab eventKey="Assessments" title="Assessments" />
          )}
          {(isAdmin(permissionData) ||
            checkHasPermission(permissionData?.[SCREEN?.REPORT], RULES.VIEW)) && (
            <Tab eventKey="Reports" title="Reports" />
          )}

          {(isAdmin(permissionData) ||
            checkHasPermission(permissionData?.[SCREEN?.DATA_ENTRY], RULES.VIEW)) && (
            <Tab eventKey="DataEntry" title="Data Entry" />
          )}

          {activeItems.instrument && <Tab eventKey="ReportIssue" title="Report Issue" />}
        </Tabs>
        <Section bg="white" textColor="dark" size="lg" bgImage="" bgImageOpacity={1}>
          <div className="chart-section-container">
            {router.query.paid && auth.user.planIsActive && (
              <Alert
                variant="success"
                className="text-center mx-auto mb-5"
                style={{ maxWidth: '400px' }}
              >
                You are now subscribed to the {auth.user.planId} plan
                <span className="ml-2" role="img" aria-label="party">
                  🥳
                </span>
              </Alert>
            )}
            {renderChartStatusFinal(activeTab)}
            <ChartAssessment
              showModal={showModal}
              setShowModal={(val) => {
                setShowModal(val);
                if (!val) setModalMode('save');
              }}
              currentLogo={currentLogo}
              resultsDataTableData={resultsDataTableData}
              currentParameter={currentParameter}
              unit={unit}
              summaryStatisticsAssessmentData={summaryStatisticsAssessmentData}
              summaryStatisticsAssessmentColumns={summaryStatisticsAssessmentColumns}
              modalAssessment={modalAssessment}
              handleAssessmentChange={handleAssessmentChange}
              saveChartAssessment={saveChartAssessment}
              currentMethod={currentMethod}
              currentInstrument={currentInstrument}
              chartScalars={chartScalars}
              chartData={chartData}
              chartLines={chartLines}
              tz={tz}
              checkedCombinedInitialAssessment={checkedCombinedInitialAssessment}
              allParams={allParams}
              processChartData={processChartData}
              injectLimitsToData={injectLimitsToData}
              modalMode={modalMode}
              chartButtonText={chartButtonText}
            />
            <Modal
              size="xl"
              show={showPeriodicModal}
              onHide={() => {
                setShowPeriodicModal(false);
                setModalMode('save');
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Chart Assessment</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt="logo" src={currentLogo} height="70" />
                  </Col>
                  <Col>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                      <div>Page</div>
                      <Form.Select
                        style={{ width: '70px', marginLeft: '10px' }}
                        value={periodicPage}
                        onChange={selectPeriodicPage}
                        aria-label="Default select example"
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                      </Form.Select>
                    </div>
                  </Col>
                </Row>
                <Row className="report-header">
                  <h4>Periodic Assessment Report</h4>
                </Row>
                <Row className="ia-table">
                  <Col>Method:</Col>
                  <Col>{currentMethod}</Col>
                  <Col>Date:</Col>
                  <Col>
                    {' '}
                    {modalAssessment?.createdAt?.toDate
                      ? moment(modalAssessment.createdAt.toDate())
                          .tz(tz || 'UTC')
                          .format('YYYY/MM/DD')
                      : resultsDataTableData.length > 0
                        ? resultsDataTableData[0].date
                        : ''}
                  </Col>
                </Row>
                <Row className="ia-table">
                  <Col>Instrument:</Col>
                  <Col>{currentInstrument}</Col>
                  <Col>Assessment by:</Col>
                  <Col> {modalAssessment?.createdBy}</Col>
                </Row>
                <Row className="ia-table">
                  <Col>Sample Name:</Col>
                  <Col>{currentSampleName}</Col>
                  <Col>Pre-treat:</Col>
                  <Col>{currentControlStrategyConfigurations.pretreatData}</Col>
                </Row>
                <Row className="ia-table">
                  <Col>Units:</Col>
                  <Col>{unit}</Col>
                  <Col />
                  <Col />
                </Row>
                <div className="periodic-buttons-container">
                  <ToggleButton
                    key="radioPooling-pass"
                    id="radioPooling-pass"
                    type="radio"
                    variant="outline-primary"
                    name="radio"
                    value
                    style={
                      modalAssessment.pool === 'true'
                        ? { backgroundColor: 'navy', color: 'white' }
                        : {}
                    }
                    checked={modalAssessment.pool === 'true'}
                    onChange={(e) => handleAssessmentChange(e, 'pool')}
                  >
                    Pool
                  </ToggleButton>
                  <ToggleButton
                    key="radioPooling-fail"
                    id="radioPooling-fail"
                    type="radio"
                    variant="outline-primary"
                    name="radio"
                    value={false}
                    style={
                      modalAssessment.pool === 'false'
                        ? { backgroundColor: 'navy', color: 'white' }
                        : {}
                    }
                    checked={modalAssessment.pool === 'false'}
                    onChange={(e) => handleAssessmentChange(e, 'pool')}
                  >
                    Do Not Pool
                  </ToggleButton>
                  <Button
                    onClick={archiveDataPoints}
                    variant={modalAssessment.archive === 'Yes' ? 'primary' : 'outline-primary'}
                  >
                    Archive / Restart
                  </Button>
                  <Button onClick={unArchiveDataPoints}>unArchive</Button>
                </div>
                {renderPeriodicPage(periodicPage)}
              </Modal.Body>
              <Modal.Footer>
                <PrimaryButton
                  text="Cancel"
                  clicked={() => {
                    setShowPeriodicModal(false);
                    setModalMode('save');
                  }}
                />
                <PrimaryButton
                  text="Save"
                  clicked={() => saveChartAssessment()}
                  disabled={chartButtonText === 'View Completed Assessment' || modalMode === 'view'}
                />
              </Modal.Footer>
            </Modal>

            <Modal
              size="xl"
              show={showCombinedZScoreModal}
              onHide={() => setShowCombinedZScoreModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Combined Z-score Parameters</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group as={Col}>
                  <Form.Label>Available Parameters {currentParameter}</Form.Label>
                  <Form.Select
                    value={currentParameter}
                    onChange={handleCombinedZScoreParameterChange}
                    aria-label="Default select example"
                  >
                    <option value="">Select parameter</option>
                    {renderOptionsDynamicParameter(
                      buildOrderParameters(
                        currentParametersDynamic.filter(
                          (p) => p.name != defaultCombinedParameterName
                        )
                      )
                    )}
                  </Form.Select>
                </Form.Group>

                <Form.Group as={Col} className="mt-3">
                  <Form.Label>Combined Parameters</Form.Label>
                  <CustomTable
                    data={combinedZScoreData}
                    header={[
                      {
                        field: 'parameter',
                        headerName: 'Parameter',
                        editable: false,
                        flex: 1,
                        sortable: false
                      }
                    ]}
                    hideFooter={true}
                    action={['delete']}
                    actionPosition={'latest'}
                    deleteRowData={handleDeleteParameter}
                  />
                </Form.Group>
                <ModalConfirm
                  show={show}
                  setShow={setShow}
                  onAccept={startRunCombineZScore}
                  primary={'Yes'}
                />
              </Modal.Body>
              <Modal.Footer>
                <PrimaryButton text="Cancel" clicked={() => setShowCombinedZScoreModal(false)} />
                {renderButtonWithPermissions(
                  'Run',
                  configCombineZScore ? () => setShow(true) : () => startRunCombineZScore(false),
                  SCREEN?.DATA,
                  RULES.CREATE,
                  permissionData,
                  true,
                  loading
                )}
              </Modal.Footer>
            </Modal>
            <ModalError
              show={showError}
              setShow={setShowError}
              title={errorData.title}
              skip={errorData.skip || ''}
              messages={[errorData.message]}
              textButton={errorData.textButton}
              runSkip={() => {
                setLoading(true);
                addCombineZScoreData(
                  errorData.rows,
                  errorData.isRefresh,
                  errorData.parameterRequest
                );
              }}
            />
            <Row>
              {activeTab === 'Overview' ? (
                isAdmin(permissionData) ||
                checkHasPermission(permissionData?.[SCREEN?.DATA], RULES.VIEW) ? (
                  <OverviewSection
                    localSearchFinished={localSearchFinished}
                    renderResultsSection={renderResultsSection}
                    renderEditTable={renderEditTable}
                    isEverFlags={isEverFlags}
                    permissionData={permissionData}
                    renderButton={renderButton}
                    handleResetEverFlags={handleResetEverFlags}
                    loadingResetEverFlags={loadingResetEverFlags}
                    exportToCSV={exportToCSV}
                    showEditModal={showEditModal}
                    setShowEditModal={setShowEditModal}
                    renderModalEditTable={renderModalEditTable}
                    featureFlags={featureFlags}
                    saveEditModal={saveEditModal}
                    hasActiveEdits={hasActiveEdits}
                    renderOverviewCharts={renderOverviewCharts}
                    activeTab={activeTab}
                    chartDataComplete={chartDataComplete}
                    handlePrintClick={handlePrintClick}
                    handleLockAllRows={handleLockAllRows}
                    filteredChartHits={filteredChartHits}
                  />
                ) : (
                  <></>
                )
              ) : (
                renderBottomSection(activeTab)
              )}
            </Row>
          </div>
        </Section>
        {chartLoading && <Loading />}
      </ChartContext.Provider>
    </>
  );
}

export default requireAuth(ChartPage);
